var red=(function(exports){'use strict';var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};var src = {};var redFileService = {};var AbstractController = {};var Errors = {};var FileAPIErrorKind_1;
Object.defineProperty(Errors, "__esModule", { value: true });
Errors.RequestError = FileAPIError_1 = Errors.FileAPIError = FileAPIErrorKind_1 = Errors.FileAPIErrorKind = void 0;
var FileAPIErrorKind;
(function (FileAPIErrorKind) {
    FileAPIErrorKind[FileAPIErrorKind["DownloadError"] = 0] = "DownloadError";
    FileAPIErrorKind[FileAPIErrorKind["GetDownloadURLError"] = 1] = "GetDownloadURLError";
    FileAPIErrorKind[FileAPIErrorKind["FileNotExistingError"] = 2] = "FileNotExistingError";
    FileAPIErrorKind[FileAPIErrorKind["GetMetaInfoError"] = 3] = "GetMetaInfoError";
    FileAPIErrorKind[FileAPIErrorKind["UploadError"] = 4] = "UploadError";
    FileAPIErrorKind[FileAPIErrorKind["GetUploadURLError"] = 5] = "GetUploadURLError";
    FileAPIErrorKind[FileAPIErrorKind["UpdateFileMetaError"] = 6] = "UpdateFileMetaError";
})(FileAPIErrorKind || (FileAPIErrorKind_1 = Errors.FileAPIErrorKind = FileAPIErrorKind = {}));
class FileAPIError extends Error {
    constructor(kind, message, details = "") {
        super(message);
        this.kind = kind;
        this.details = details;
    }
}
var FileAPIError_1 = Errors.FileAPIError = FileAPIError;
class RequestError extends Error {
    constructor(message, code, details) {
        super(message);
        this.code = code;
        this.details = details;
    }
}
Errors.RequestError = RequestError;Object.defineProperty(AbstractController, "__esModule", { value: true });
AbstractController.Controller = void 0;
const Errors_1$2 = Errors;
class Controller {
    constructor(rootUrl, apiVersion) {
        this.defaultHeaders = {};
        if (apiVersion) {
            this.rootUrl = new URL(apiVersion, rootUrl);
        }
        else {
            this.rootUrl = new URL(rootUrl);
        }
    }
    useJwt(jwt) {
        this.jwt = jwt;
        this.defaultHeaders = Object.assign(Object.assign({}, this.defaultHeaders), { Authorization: `Bearer ${jwt}` });
        return this;
    }
    async request(endpoint, method = "GET", params) {
        const options = {
            method,
            headers: this.defaultHeaders,
        };
        let url;
        try {
            url = new URL(`${this.rootUrl}${endpoint === "/" ? "" : endpoint}`);
        }
        catch (e) {
            throw new Errors_1$2.RequestError("Invalid url", 18, [this.rootUrl.href, endpoint]);
        }
        for (const param in params) {
            if (Object.prototype.hasOwnProperty.call(params, param)) {
                url.searchParams.append(param, params[param]);
            }
        }
        const response = await fetch(url, options);
        if (response.ok) {
            const result = await response.json();
            return result;
        }
        else {
            const text = await response.text();
            throw new Errors_1$2.RequestError("Response not ok!", response.status, [text, response.statusText]);
        }
    }
    async jsonRequest(endpoint, content, method = "POST") {
        const options = {
            method,
            headers: Object.assign(Object.assign({}, this.defaultHeaders), { "Content-Type": "application/json" }),
            body: JSON.stringify(content),
        };
        let url;
        try {
            url = new URL(`${this.rootUrl}${endpoint === "/" ? "" : endpoint}`);
        }
        catch (e) {
            throw new Errors_1$2.RequestError("Invalid url", 18, [this.rootUrl.href, endpoint]);
        }
        const response = await fetch(url, options);
        const result = await response.json();
        return result;
    }
}
AbstractController.Controller = Controller;var DomainController$1 = {};var FileController$1 = {};Object.defineProperty(FileController$1, "__esModule", { value: true });
FileController$1.FileController = void 0;
const AbstractController_1$2 = AbstractController;
const Errors_1$1 = Errors;
class FileController extends AbstractController_1$2.Controller {
    constructor(ctrl, fileId) {
        super(`${ctrl.url}/files/${fileId}`);
        this.fileId = fileId;
    }
    async updateFileSize(size) {
        return this.request("/", "PUT", { size: size.toString() });
    }
    /**
     * Returns the meta object of the file
     */
    async meta() {
        try {
            const result = await this.request("/");
            return result;
        }
        catch (e) {
            if (e instanceof Errors_1$1.RequestError && e.code === 404) {
                throw new Errors_1$1.FileAPIError(Errors_1$1.FileAPIErrorKind.FileNotExistingError, `file ${this.fileId} does not exist!`);
            }
            else
                throw e;
        }
    }
    /**
     * Confirms the upload and toggles the status to "confirmed"
     */
    async confirmUpload() {
        return this.request("/confirm", "PUT");
    }
    /**
     * Creates a presigned url to download the file directly from S3 storage
     */
    async getDownloadUrl() {
        try {
            const result = await this.request("/download");
            return result;
        }
        catch (e) {
            throw new Errors_1$1.FileAPIError(Errors_1$1.FileAPIErrorKind.GetDownloadURLError, "Could not get download url for file", e);
        }
    }
    /**
     * Download a file from S3.
     * This will retrieve the presigned download url and download the file from s3.
     * @param transform - Function to transform the content before generating the File object (e.g., decryption)
     */
    async download(transform) {
        const { url } = await this.getDownloadUrl();
        const response = await fetch(url);
        if (!response.ok) {
            let errorText;
            try {
                errorText = await response.text();
            }
            catch (e) {
                errorText = e.message || `Unknown error occurred while downloading file ${this.fileId}`;
            }
            throw new Errors_1$1.FileAPIError(response.status === 404 ? Errors_1$1.FileAPIErrorKind.FileNotExistingError : Errors_1$1.FileAPIErrorKind.DownloadError, `Could not download file ${this.fileId} from ${url}`, errorText);
        }
        try {
            const arrayBuffer = await response.arrayBuffer();
            const content = transform ? await transform(new Blob([arrayBuffer])) : arrayBuffer;
            return new Blob([content]);
        }
        catch (e) {
            throw new Errors_1$1.FileAPIError(Errors_1$1.FileAPIErrorKind.DownloadError, "Could not generate a file object from response", e);
        }
    }
    /**
     * Creates a new presigned upload url. Works only with detached files.
     */
    async regenerateSignedUploadUrl() {
        return this.request("/uploadUrl", "PUT");
    }
    /**
     * Uploads a file for the given model and path and confirms the upload
     * @param file
     */
    async detachedUpload(file) {
        try {
            // this step is required to check if the file-upload completed lossless on confirmation
            await this.updateFileSize(file.size);
        }
        catch (e) {
            throw new Errors_1$1.FileAPIError(Errors_1$1.FileAPIErrorKind.UpdateFileMetaError, "Can not adapt file size", e);
        }
        let result;
        try {
            result = await this.regenerateSignedUploadUrl();
        }
        catch (e) {
            throw new Errors_1$1.FileAPIError(Errors_1$1.FileAPIErrorKind.GetUploadURLError, "Can not get upload url", e);
        }
        const formData = new FormData();
        formData.append("file", file, result.fileId);
        const response = await fetch(result.uploadUrl, {
            method: "PUT",
            headers: {
                "Content-Type": "multipart/form-data",
            },
            body: formData,
        });
        if (response.ok) {
            try {
                return await this.confirmUpload();
            }
            catch (e) {
                throw new Errors_1$1.FileAPIError(Errors_1$1.FileAPIErrorKind.UpdateFileMetaError, `Unable to confirm file upload ${result.fileId}`);
            }
        }
        else {
            let errorText;
            try {
                errorText = await response.text();
            }
            catch (e) {
                errorText = `Unknown error occurred during confirm upload. ${result.fileId}`;
            }
            throw new Errors_1$1.FileAPIError(Errors_1$1.FileAPIErrorKind.UploadError, `Error during upload: ${response.status} ${response.statusText}\n${result.uploadUrl}\n${errorText}`);
        }
    }
}
FileController$1.FileController = FileController;Object.defineProperty(DomainController$1, "__esModule", { value: true });
DomainController$1.DomainController = void 0;
const AbstractController_1$1 = AbstractController;
const FileController_1 = FileController$1;
const Errors_1 = Errors;
class DomainController extends AbstractController_1$1.Controller {
    constructor(url) {
        super(url);
        this.url = url;
    }
    File(fileId) {
        return new FileController_1.FileController(this, fileId).useJwt(this.jwt);
    }
    async getDetachedFiles(limit = 0, skip = 0) {
        const params = new URLSearchParams({ skip: skip.toString(), limit: limit.toString() });
        return this.request(`/detached-files?${params.toString()}`);
    }
    /**
     * Uploads a file for the given model and path and confirms the upload
     * Returns File Id and uploads file async
     * @param model
     * @param path
     * @param file
     * @param metaInfo
     */
    async uploadAsync(model, path, file, metaInfo) {
        const result = await this.createFile({
            model,
            path,
            size: file.size.toString(),
            meta: metaInfo,
        });
        const formData = new FormData();
        formData.append("file", file, result.fileId);
        const metaDataPromise = fetch(result.uploadUrl, {
            method: "PUT",
            headers: {
                "Content-Type": "multipart/form-data",
            },
            body: formData,
        }).then(async (response) => {
            if (response.ok) {
                return await result.controller.confirmUpload();
            }
            else {
                let errorText;
                try {
                    errorText = await response.text();
                }
                catch (e) {
                    errorText = `Unknown error occurred during confirm upload. ${result.fileId}`;
                }
                throw new Errors_1.FileAPIError(Errors_1.FileAPIErrorKind.UploadError, `Error during upload: ${response.status} ${response.statusText}\n${result.uploadUrl}\n${errorText}`);
            }
        });
        return {
            fileId: result.fileId,
            metaDataPromise,
        };
    }
    /**
     * Uploads a file for the given model and path and confirms the upload
     * @param model
     * @param path
     * @param file
     * @param metaInfo
     */
    async upload(model, path, file, metaInfo) {
        const result = await this.createFile({
            model,
            path,
            size: file.size.toString(),
            meta: metaInfo,
        });
        const formData = new FormData();
        formData.append("file", file, result.fileId);
        const response = await fetch(result.uploadUrl, {
            method: "PUT",
            headers: {
                "Content-Type": "multipart/form-data",
            },
            body: formData,
        });
        if (response.ok) {
            return await result.controller.confirmUpload();
        }
        else {
            let errorText;
            try {
                errorText = await response.text();
            }
            catch (e) {
                errorText = `Unknown error occurred during confirm upload. ${result.fileId}`;
            }
            throw new Errors_1.FileAPIError(Errors_1.FileAPIErrorKind.UploadError, `Error during upload: ${response.status} ${response.statusText}\n${result.uploadUrl}\n${errorText}`);
        }
    }
    /**
     * Returns a pressigned url to upload
     * @param model
     * @param path
     * @param size
     * @param metaInfo
     * @constructor
     */
    async createFile({ model, path, size, meta, detach }) {
        try {
            const params = new URLSearchParams({ model, path, size });
            if (detach) {
                params.set("detach", "true");
            }
            let result;
            if (meta && typeof meta === "object") {
                result = await this.jsonRequest(`/files?${params.toString()}`, { meta });
            }
            else {
                result = await this.request(`/files?${params.toString()}`, "POST");
            }
            return {
                controller: new FileController_1.FileController(this, result.fileId).useJwt(this.jwt),
                fileId: result.fileId,
                uploadUrl: result.uploadUrl,
            };
        }
        catch (e) {
            throw new Errors_1.FileAPIError(Errors_1.FileAPIErrorKind.GetUploadURLError, `Could not create file for ${model} - ${path}
                detached: ${detach}
                `, e);
        }
    }
    async getStorageSize() {
        return this.request("/storage-size");
    }
    async enableDetachedMode() {
        const params = new URLSearchParams();
        params.set("value", "true");
        return this.request(`/info/detachedMode?${params.toString()}`, "PUT");
    }
    async disableDetachedMode() {
        const params = new URLSearchParams();
        params.set("value", "false");
        return this.request(`/info/detachedMode?${params.toString()}`, "PUT");
    }
    /**
     * Deletes all files and their meta data in a specific time range
     * @requires admin_access
     * @param from
     * @param to
     */
    async resetDetached(from, to) {
        return this.request("/info/reset-detached", "POST", {
            from,
            to,
        });
    }
}
DomainController$1.DomainController = DomainController;Object.defineProperty(redFileService, "__esModule", { value: true });
redFileService.RedFileService = void 0;
const AbstractController_1 = AbstractController;
const DomainController_1 = DomainController$1;
const API_VERSION = "v1";
class RedFileService extends AbstractController_1.Controller {
    constructor(serviceHost, jwt) {
        super(serviceHost, API_VERSION);
        this.useJwt(jwt);
    }
    Domain(domain, owner) {
        return new DomainController_1.DomainController(`${this.rootUrl}/${domain}/${owner}`).useJwt(this.jwt);
    }
}
redFileService.RedFileService = RedFileService;(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(redFileService, exports);
	
} (src));var DatamodelManager$1 = {};Object.defineProperty(DatamodelManager$1, "__esModule", { value: true });
var DatamodelManager_2 = DatamodelManager$1.DatamodelManager = void 0;
class DatamodelManager {
    static _instance = new DatamodelManager();
    datamodel;
    relationMap;
    headRelationMap;
    _sortedModelVersions = new Map();
    constructor() {
        if (DatamodelManager._instance) {
            throw new Error("Error: Instantiation failed: Use DatamodelManager.getInstance() instead of new.");
        }
        DatamodelManager._instance = this;
        this.datamodel = {};
        this.relationMap = {};
        this.headRelationMap = {};
    }
    static getInstance() {
        return DatamodelManager._instance;
    }
    getDatamodel() {
        return this.datamodel;
    }
    setDatamodel(data, staging = false) {
        this.datamodel = data;
        this._sortedModelVersions.clear();
        /*
         * The datamodels are set to staging mode first
         * After model and field checks staging is set to false by calling this method again
         */
        if (!staging) {
            // if datamodel is set at the beginning of datamodel checks (staging), no need to initialize
            this.initializeModel();
        }
        this.calculateRelationMap();
    }
    initializeModel() {
        function processFields(model, fields) {
            let fieldname, field;
            for (fieldname in fields) {
                if (fields.hasOwnProperty(fieldname)) {
                    field = fields[fieldname];
                    if (field.check) {
                        if (/^function/.test(field.check)) {
                            eval("field.check_func = " + field.check);
                        }
                        else {
                            eval("field.check_func = function(value, record) { return " + field.check + "; }");
                        }
                    }
                    if (typeof field.mandatory === "string") {
                        if (field.mandatory.search("this.") > -1) {
                            eval("field.mandatory_func = function(record) { return " +
                                field.mandatory.replace(/this\./g, "record.") +
                                "; }");
                        }
                        else {
                            eval("field.mandatory_func = " + field.mandatory);
                        }
                    }
                    else if (typeof field.mandatory === "function") {
                        field.mandatory_func = field.mandatory;
                    }
                    if (typeof field.initfn === "string") {
                        eval("field.init_func = function(record, obj, tools) { return " +
                            field.initfn.replace(/this\./g, "record.") +
                            "; }");
                    }
                    else if (typeof field.initfn === "function") {
                        field.init_func = field.initfn;
                    }
                    if (typeof field.updatefn === "string") {
                        eval("field.update_func = function(record, oldRecord, tools) { return " +
                            field.updatefn.replace(/this\./g, "record.") +
                            "; }");
                    }
                    else if (typeof field.updatefn === "function") {
                        field.update_func = field.updatefn;
                    }
                    if (field.type === "autoid" || field.type === "autonumber") {
                        field.update = false;
                    }
                    if (field.fields) {
                        processFields(model, field.fields);
                    }
                    if (field.array && field.array.fields) {
                        processFields(model, field.array.fields);
                    }
                    if (field.search) {
                        model.search = true;
                        if (field.search.collected && (field.crypto || (field.array && field.array.crypto))) {
                            model.searchCrypto = true;
                        }
                        if (field.search.global) {
                            model.globalSearch = true;
                            if (typeof field.search.global === "string") {
                                if (field.search.global.search("this.") > -1) {
                                    eval("field.search.globalFn = function(record) { return " +
                                        field.search.global.replace(/this\./g, "record.") +
                                        "; }");
                                }
                                else {
                                    eval("field.search.globalFn = " + field.search.global);
                                }
                            }
                            else if (typeof field.search.global === "function") {
                                field.search.globalFn = field.search.global;
                            }
                        }
                    }
                    if (field.crypto) {
                        model.crypto = true;
                    }
                }
            }
        }
        const processDatamodel = (datamodel) => {
            let modelname, modelVersions;
            for (modelname in datamodel) {
                if (datamodel.hasOwnProperty(modelname)) {
                    modelVersions = datamodel[modelname];
                    modelVersions.forEach((model) => {
                        if (model.check) {
                            if (/^function/.test(model.check)) {
                                eval("model.check_func = " + model.check);
                            }
                            else {
                                eval("model.check_func = function(record) { return " + model.check.replace(/this\./g, "record.") + "; }");
                            }
                        }
                        processFields(model, model.fields);
                    });
                }
            }
        };
        processDatamodel(this.datamodel);
    }
    static compareVersions(versionX, versionY) {
        if (versionY.quarter || versionX.quarter) {
            const quarterCompare = (versionY.quarter || "").localeCompare(versionX.quarter || "");
            if (quarterCompare !== 0) {
                return quarterCompare;
            }
        }
        const strVersionX = `${versionX.version}`, strVersionY = `${versionY.version}`;
        const nrVersionX = !strVersionX.includes(".") ? parseInt(strVersionX, 10) : NaN, nrVersionY = !strVersionY.includes(".") ? parseInt(strVersionY, 10) : NaN, versionsAreNumbers = !isNaN(nrVersionX) && !isNaN(nrVersionY);
        return versionsAreNumbers
            ? nrVersionY - nrVersionX
            : versionY.version.localeCompare(versionX.version);
    }
    compareModelVersions(modelA, modelB) {
        if (modelA.versions && modelB.versions) {
            const [highestVersionA] = modelA.versions.sort(DatamodelManager.compareVersions), [highestVersionB] = modelB.versions.sort(DatamodelManager.compareVersions);
            return DatamodelManager.compareVersions(highestVersionA, highestVersionB);
        }
        return -1;
    }
    getModelListSortedByVersion(modelList) {
        if (modelList.length > 1) {
            return modelList.sort(this.compareModelVersions);
        }
        return modelList;
    }
    getModelListByNameSortedByVersion(modelName) {
        if (this.datamodel && this.datamodel[modelName]) {
            if (this._sortedModelVersions.has(modelName)) {
                return this.datamodel[modelName];
            }
            // sort all existing models for given name descending by highest version
            const result = this.getModelListSortedByVersion(this.datamodel[modelName]);
            this._sortedModelVersions.set(modelName, true);
            return result;
        }
        return undefined;
    }
    getModelByNameAndVersion(modelName, modelVersion) {
        if (!modelVersion || !modelVersion.version) {
            return this.getModelByNameLatestVersion(modelName);
        }
        // when data without head_version have to be checked against the datamodel, the first existing version should be used.
        // in this case this function can be called with version="first"
        if (modelVersion.version === "first") {
            return this.getModelByNameFirstVersion(modelName);
        }
        if (this.datamodel && this.datamodel[modelName]) {
            return this.datamodel[modelName].find((item) => {
                const findByQuarter = !!modelVersion.quarter && item.versions?.every(versionItem => !!versionItem.quarter);
                return (item.versions &&
                    item.versions.some(versionItem => {
                        return (versionItem.version === modelVersion.version &&
                            (!findByQuarter || versionItem.quarter === modelVersion.quarter));
                    }));
            });
        }
        return undefined;
    }
    getModelByNameLatestVersion(modelName) {
        if (this.datamodel && this.datamodel[modelName]) {
            const sortedModelList = this.getModelListByNameSortedByVersion(modelName);
            if (sortedModelList) {
                return sortedModelList[0];
            }
        }
        return undefined;
    }
    getModelByNameFirstVersion(modelName) {
        let listLength, sortedModelList;
        if (this.datamodel && this.datamodel[modelName]) {
            listLength = this.datamodel[modelName].length;
            sortedModelList = this.getModelListByNameSortedByVersion(modelName);
            if (sortedModelList) {
                return sortedModelList[listLength - 1];
            }
        }
        return undefined;
    }
    getContainer(modelName, defaultContainer = "" /* Container.None */, version) {
        const model = this.getModelByNameAndVersion(modelName, version);
        return model && model.container ? model.container : defaultContainer;
    }
    _getRelationFields(modelname, version, fields, path) {
        let field, fieldPath;
        const fieldNames = fields ? Object.keys(fields) : [];
        for (const fieldName of fieldNames) {
            field = JSON.parse(JSON.stringify(fields[fieldName]));
            fieldPath = path + (path ? "." : "") + fieldName;
            field._path = fieldPath;
            if (field.relation) {
                this.relationMap[modelname][version][field.relation] ??= [];
                this.relationMap[modelname][version][field.relation].push(field);
            }
            else if (field.headRelation) {
                this.headRelationMap[modelname][version][field.headRelation] ??= [];
                this.headRelationMap[modelname][version][field.headRelation].push(field);
            }
            else if (field.type === "object") {
                this._getRelationFields(modelname, version, field.fields, fieldPath);
            }
            else if (field.type === "array" && field.array && field.array.type === "object") {
                this._getRelationFields(modelname, version, field.array.fields, fieldPath);
            }
        }
    }
    calculateRelationMap() {
        for (const modelname in this.datamodel) {
            if (this.datamodel.hasOwnProperty(modelname)) {
                const modelVersions = this.datamodel[modelname];
                for (const model of modelVersions) {
                    this.relationMap[modelname] ??= {};
                    this.relationMap[modelname][model.versions?.[0]?.version] = {};
                    this.headRelationMap[modelname] ??= {};
                    this.headRelationMap[modelname][model.versions?.[0]?.version] = {};
                    this._getRelationFields(modelname, model.versions?.[0]?.version, model.fields, "");
                }
            }
        }
    }
    getRelationValueFields(modelName, relatedModelName, modelVersion) {
        const model = this.getModelByNameAndVersion(modelName, modelVersion);
        if (!model || !this.relationMap[modelName]) {
            return [];
        }
        return this.relationMap[modelName][model.versions?.[0]?.version]?.[relatedModelName] || [];
    }
    getHeadRelationValueFields(modelName, relatedModelName, modelVersion) {
        const model = this.getModelByNameAndVersion(modelName, modelVersion);
        if (!model || !this.headRelationMap[modelName]) {
            return [];
        }
        return this.headRelationMap[modelName][model.versions?.[0]?.version]?.[relatedModelName] || [];
    }
    relationExists(relatedName, modelName, bidirectional, relatedVersion, modelVersion) {
        return (this.getRelationValueFields(modelName, relatedName, modelVersion).length > 0 ||
            (bidirectional && this.getRelationValueFields(relatedName, modelName, relatedVersion).length > 0));
    }
    getRelationFields(modelName, version) {
        const model = this.getModelByNameAndVersion(modelName, version);
        if (!model || !this.relationMap[modelName]) {
            return [];
        }
        let result = [];
        for (const relationModel in this.relationMap[modelName][model.versions?.[0]?.version]) {
            result = result.concat(this.relationMap[modelName][model.versions?.[0]?.version][relationModel]);
        }
        return result;
    }
    getElasticContainer(modelName, defaultContainer = "" /* Container.None */, version) {
        const model = this.getModelByNameAndVersion(modelName, version);
        return model?.database || model?.container || defaultContainer;
    }
    getDateRelationValueFields(modelName, relatedModelName, modelVersion) {
        return this.getRelationValueFields(modelName, relatedModelName, modelVersion).filter(function (item) {
            return item.relationDate !== undefined && !item.crypto;
        });
    }
    nestedRelationExists(relatedName, modelName, modelVersion) {
        return (this.relationExists(modelName, relatedName, false, modelVersion) ||
            this.headRelationExists(modelName, relatedName, false, modelVersion));
    }
    headRelationExists(relatedName, modelName, bidirectional, relatedVersion, modelVersion) {
        return (this.getHeadRelationValueFields(modelName, relatedName, modelVersion).length > 0 ||
            (bidirectional && this.getHeadRelationValueFields(relatedName, modelName, relatedVersion).length > 0));
    }
    relationIsHeadRelation(modelName, relatedModelName, version) {
        const relations = this.getHeadRelationValueFields(modelName, relatedModelName, version);
        return relations.length > 0;
    }
    getLatestModelVersionByName(modelName) {
        const latestModel = this.getModelByNameLatestVersion(modelName);
        return latestModel && latestModel.versions && latestModel.versions.length
            ? latestModel.versions.sort((versionX, versionY) => {
                return versionY.version > versionX.version ? 1 : -1;
            })[0].version
            : undefined;
    }
    findFieldFromQueryPath(path, modelName, modelVersion) {
        let i = 0, currentField = this.getModelByNameAndVersion(modelName, modelVersion), currentProperty;
        const pathArr = path.split("."), pathLength = pathArr.length;
        if (!currentField) {
            return undefined;
        }
        for (i; i < pathLength; ++i) {
            currentProperty = pathArr[i];
            if (currentField) {
                if (currentField.hasOwnProperty(currentProperty)) {
                    currentField = currentField[currentProperty];
                }
                else if (currentField.hasOwnProperty("fields")) {
                    currentField = currentField.fields;
                    --i; // decrement counter to check current property again (below fields)
                }
                else if (currentField.hasOwnProperty("array")) {
                    currentField = currentField.array;
                    --i; // decrement counter to check current property again (below array)
                }
                else {
                    // field can not be found
                    currentField = undefined;
                    break;
                }
            }
        }
        return currentField;
    }
    getAutonumberFieldsOnModelPath(pathToLevel, modelName, crypted = true, modelVersion) {
        let currentField = pathToLevel === ""
            ? this.getModelByNameAndVersion(modelName, modelVersion)
            : this.findFieldFromQueryPath(pathToLevel, modelName, modelVersion);
        const result = [];
        if (currentField) {
            if (currentField.type && currentField.type === "array") {
                currentField = currentField.array;
            }
            if (currentField?.fields) {
                currentField = currentField.fields;
            }
            else {
                currentField = undefined;
            }
        }
        if (currentField) {
            for (const fieldname in currentField) {
                if (currentField.hasOwnProperty(fieldname) && currentField[fieldname].type === "autonumber") {
                    if ((crypted && currentField[fieldname].crypto) || !crypted) {
                        result.push(Object.assign({ _fieldname: fieldname }, currentField[fieldname]));
                    }
                }
            }
        }
        return result;
    }
    /**
     * Returns the database name for the container.
     * Returns undefined if there is no existing model.
     * @param modelName
     * @param version
     */
    getDatabase(modelName, version) {
        const model = this.getModelByNameAndVersion(modelName, version);
        if (!model) {
            return undefined;
        }
        return model.database || "tenant" /* Container.Tenant */;
    }
    getIdentFieldName(modelName, version) {
        const model = this.getModelByNameAndVersion(modelName, version);
        let identFieldName = "", fieldName;
        if (model && model.fields) {
            for (fieldName in model.fields) {
                if (model.fields.hasOwnProperty(fieldName) && model.fields[fieldName].ident) {
                    identFieldName = fieldName;
                    break;
                }
            }
        }
        return identFieldName;
    }
    getRelationDateFields(modelName, version) {
        const relationFields = this.getRelationFields(modelName, version);
        return relationFields.filter((item) => {
            return !!item.relationDate;
        });
    }
    relationIsCrypted(modelName, relatedModelName, version) {
        const headRelations = this.getHeadRelationValueFields(modelName, relatedModelName, version);
        const relations = this.getRelationValueFields(modelName, relatedModelName, version);
        const allRelations = headRelations.concat(relations);
        return !!allRelations.find(field => field.crypto);
    }
    getModelsWithMetaField(field) {
        const modelNames = Object.keys(this.getDatamodel());
        return modelNames.filter(currentModelName => {
            const model = this.getModelByNameLatestVersion(currentModelName);
            return model && model.meta && model.meta[field];
        });
    }
}
DatamodelManager_2 = DatamodelManager$1.DatamodelManager = DatamodelManager;var TypeChecker$1 = {};var DateType_1;
Object.defineProperty(TypeChecker$1, "__esModule", { value: true });
var TypeChecker_2 = TypeChecker$1.TypeChecker = DateType_1 = TypeChecker$1.DateType = void 0;
var DateType;
(function (DateType) {
    DateType["date"] = "date";
    DateType["datetime"] = "datetime";
    DateType["timestamp"] = "timestamp";
})(DateType || (DateType_1 = TypeChecker$1.DateType = DateType = {}));
class TypeChecker {
    static _instance = new TypeChecker();
    constructor() {
        if (TypeChecker._instance) {
            throw new Error("Error: Instantiation failed: Use TypeChecker.getInstance() instead of new.");
        }
        TypeChecker._instance = this;
    }
    static getInstance() {
        return TypeChecker._instance;
    }
    typeOf(value) {
        switch (typeof value) {
            case "string":
                return "string";
            case "boolean":
                return "boolean";
            case "function":
                return "function";
            case "number":
                return "number";
            case "object":
                if (Array.isArray(value)) {
                    return "array";
                }
                if (value === null) {
                    return "null";
                }
                return "object";
            default:
                return "undefined";
        }
    }
    /**
     * Tests the given value on being a valid date/datetime/timestamp string.
     *
     * 3 formats are supported:
     * 1) date: from '0000-00-00' to '2999-12-31'
     * 2) datetime: from '0000-00-00 00:00[:00[.000]]' to '2999-12-31 23:59[:59[.999]]'
     * 3) timestamp: from '0000-00-00 00:00:00.000' to '2999-12-31 23:59:59.999'
     *
     * Currently, there is no specific reason for the upper boundary being year 2999.
     * In an earlier version a date was valid until year 2100.
     */
    isDateFormatValid(value, dateType = DateType.datetime) {
        switch (dateType) {
            case DateType.date:
                return /^[012]\d{3}-(0\d|1[012])-([012]\d|3[01])$/.test(value);
            case DateType.datetime:
                return /^[012]\d{3}-(0\d|1[012])-([012]\d|3[01]) ([01]\d|2[0123]):([012345]\d)(:[012345]\d(\.\d{3})?)?$/.test(value);
            case DateType.timestamp:
                return /^[012]\d{3}-(0\d|1[012])-([012]\d|3[01]) ([01]\d|2[0123]):([012345]\d):[012345]\d\.\d{3}$/.test(value);
        }
        return false;
    }
    checkFieldType(field, value, options) {
        let typeOfArray, fieldType;
        if (field) {
            fieldType = field.type;
        }
        options = options || {};
        // if $in operator is used field type check must be omitted (at the moment)
        if (value === null) {
            return true;
        }
        if (typeof value === "object" && Object.keys(value)[0] && Object.keys(value)[0][0] === "$") {
            // it can be 2 keys in some cases
            // example case: date range ("gueltigVon":{"$gte":"2024-02-13","$lte":"2024-02-23"})
            if (Object.keys(value).length !== 1 && Object.keys(value).length !== 2) {
                return false;
            }
            const COMPARISON_OPERATORS_ARRAY = ["$in", "$nin"];
            const COMPARISON_OPERATORS = ["$eq", "$gt", "$gte", "$lt", "$lte", "$ne"];
            return Object.keys(value).every(key => {
                if (COMPARISON_OPERATORS_ARRAY.includes(key)) {
                    if (!Array.isArray(value[key])) {
                        return false;
                    }
                    return value[key].every(v => this.checkFieldType(field, v));
                }
                if (COMPARISON_OPERATORS.includes(key)) {
                    return this.checkFieldType(field, value[key]);
                }
                if (key === "$contains") {
                    return this.checkFieldType(field, value[key]);
                }
                if (key === "$exists") {
                    return this.checkFieldType({ type: "boolean" }, value[key]);
                }
                if (key === "$size") {
                    return this.checkFieldType({ type: "int" }, value[key]);
                }
                return true;
            });
        }
        const typeOfValue = this.typeOf(value);
        switch (fieldType) {
            case "intstring":
                if (typeOfValue !== "number" && typeOfValue !== "string") {
                    return false;
                }
                break;
            case "autoid":
                if (typeOfValue !== "number" && typeOfValue !== "string") {
                    return false;
                }
                break;
            case "int":
            case "float":
                if (typeOfValue !== "number") {
                    return false;
                }
                break;
            case "boolean":
                if (value !== true && value !== false) {
                    return false;
                }
                break;
            case "file":
            case "string":
                if (typeOfValue !== "string") {
                    return false;
                }
                break;
            case "object":
                if (typeOfValue !== "object") {
                    return false;
                }
                break;
            case "array":
                if (field && field.array) {
                    typeOfArray = field.array.type === "model" ? "object" : field.array.type;
                }
                if (typeOfValue !== "array") {
                    if (options.write || !this.checkFieldType({ type: typeOfArray }, value)) {
                        return false;
                    }
                }
                else if (!(field.array.crypto || options.preventArrayDeepTest)) {
                    if (!value.every(item => {
                        return this.checkFieldType({ type: typeOfArray }, item);
                    })) {
                        return false;
                    }
                }
                break;
            case "date":
            case "datetime":
            case "timestamp":
                if (typeOfValue !== "string") {
                    return false;
                }
                if (options.isCrypto) {
                    return true;
                }
                return this.isDateFormatValid(value, DateType[fieldType]);
        }
        return true;
    }
}
TypeChecker_2 = TypeChecker$1.TypeChecker = TypeChecker;class KoelnerPhonetik {
    constructor(word) {
        this.word = word;
    }
    getValue() {
        return this.calculate(this.word);
    }
    calculate(word) {
        var letters, i, n, len, value = [], retValue, code;
        if (Array.isArray(word)) {
            for (n = 0; n < word.length; n += 1) {
                word[n] = this.calculate(word[n]);
            }
            return word;
        }
        if (word.search(/[0-9]/) > -1) {
            return "_KP_N" + word;
        }
        word = word.toLowerCase();
        word = word.replace(/ä/g, "a");
        word = word.replace(/ö/g, "o");
        word = word.replace(/ü/g, "u");
        word = word.replace(/ß/g, "ss");
        word = word.replace(/ph/g, "f");
        len = word.length;
        for (i = 0; i < len; i += 1) {
            value[i] = "";
            // Exceptions
            if (i === 0 && word[i] + word[i + 1] === "cr") {
                value[i] = "4";
            }
            for (code in KoelnerPhonetik.exceptionsLeading) {
                if (KoelnerPhonetik.exceptionsLeading.hasOwnProperty(code)) {
                    letters = KoelnerPhonetik.exceptionsLeading[code];
                    if (letters.indexOf(word[i] + word[i + 1]) > -1) {
                        value[i] = code;
                    }
                }
            }
            if (i !== 0 && KoelnerPhonetik.exceptionsFollowing.indexOf(word[i - 1] + word[i]) > -1) {
                value[i] = "8";
            }
            // normal encoding
            // detects the key of the array in which the current letter occures
            if (value[i] === "") {
                for (code in KoelnerPhonetik.codingTable) {
                    if (KoelnerPhonetik.codingTable.hasOwnProperty(code)) {
                        letters = KoelnerPhonetik.codingTable[code];
                        if (letters.indexOf(word[i]) > -1) {
                            value[i] = code;
                            break;
                        }
                    }
                }
            }
        }
        for (i = 1; i < len; i += 1) {
            if (value[i] === value[i - 1]) {
                value[i] = "";
            }
        }
        for (i = 1; i < len; i += 1) {
            // omitting first characer code and h
            if (value[i] === "0") {
                value[i] = "";
            }
        }
        retValue = value.join("");
        return "_KP_" + retValue;
    }
}
KoelnerPhonetik.exceptionsLeading = {
    "4": ["ca", "ch", "ck", "cl", "co", "cq", "cu", "cx"],
    "8": ["dc", "ds", "dz", "tc", "ts", "tz"]
};
KoelnerPhonetik.exceptionsFollowing = ["sc", "zc", "cx", "kx", "qx"];
// red version of the Cologne Phonetik algorithm:
// added "h" to the vocals in the coding table, to dont get an empty string,
// if searching for names which leading letter is 'H' followed by a vocal e.g (Hue)
KoelnerPhonetik.codingTable = {
    "0": ["a", "e", "i", "j", "o", "u", "y", "h"],
    "1": ["b", "p"],
    "2": ["d", "t"],
    "3": ["f", "v", "w"],
    "4": ["c", "g", "k", "q"],
    "48": ["x"],
    "5": ["l"],
    "6": ["m", "n"],
    "7": ["r"],
    "8": ["s", "z"]
};class StringUtils {
    /**
     * Generates a random string
     * @returns The random string
     */
    static generateRandomString() {
        return Math.random().toString(36).substr(2);
    }
    /**
     * Returns a random string of given length
     * @param length - The length the random string should have
     * @returns The random string
     */
    static getRandomString(length) {
        var randomString = this.generateRandomString();
        while (randomString.length < length) {
            randomString = randomString + this.generateRandomString();
        }
        return randomString.substr(0, length);
    }
    /**
     * Generates an array of random tokens starting with given token and using given random string
     * @param token - The starting token to generate following random tokens with
     * @param randomString - The random string to be used to generate random tokens from
     * @returns The array of generated random tokens
     */
    static generateRandomTokens(token, randomString) {
        var arr = [], i;
        for (i = 1; i <= randomString.length; ++i) {
            arr.push(token + randomString.substr(0, i));
        }
        return arr;
    }
    /**
     * returns array of random tokens missing to make given token array having given minimum length
     * @param tokens - The array of tokens
     * @param length - The array has to be filled to have this minimum length
     * @returns The array of random tokens
     */
    static getRandomTokens(tokens, length) {
        var lastToken = tokens[tokens.length - 1], randomString = this.getRandomString(length - tokens.length), randomTokens = this.generateRandomTokens(lastToken, randomString);
        return randomTokens;
    }
    static isStringWithNumber(data) {
        return !isNaN(parseFloat(data)) && isFinite(data);
    }
}const isServerContext = typeof exports !== "undefined" && typeof window === "undefined";
class SearchData {
    /**
     * Creates an array of all substrings starting with the initial of a given string.
     */
    static initialize(s) {
        var arr = [], i, max = 10, n;
        if (typeof s === "string") {
            for (i = 0; i < max && i < s.length; i += 1) {
                arr.push(s.substr(0, i + 1));
            }
        }
        else {
            // array
            for (n = 0; n < s.length; n += 1) {
                for (i = 0; i < max && i < s[n].length; i += 1) {
                    arr.push(s[n].substr(0, i + 1));
                }
            }
        }
        return arr;
    }
    static normalizedInitialize(s, options) {
        return this.initialize(this.normalizedTokenize(s, options));
    }
    static phoneticInitialize(s, options) {
        return new KoelnerPhonetik(this.normalizedInitialize(s, options)).getValue();
    }
    static filledUpInitialize(s, options) {
        let initializedTokens = this.normalizedInitialize(s, options);
        return initializedTokens.concat(StringUtils.getRandomTokens(initializedTokens, 10));
    }
    static phoneticFilledUpInitialize(s, options) {
        return new KoelnerPhonetik(this.filledUpInitialize(s, options)).getValue();
    }
    static seperateUnitsFromNumbers(str) {
        const numbersAndUnits = /(\d+)(cm|Fl|IE|kg|mg|ml|mm|P|Sp|St|µg|g|m)\b/g;
        if (numbersAndUnits.test(str)) {
            return `${str} + ${str.replace(numbersAndUnits, " $1 $2 ").trim()}`;
        }
        return str;
    }
    /**
     * converts given parameter to array of single search tokens.
     */
    static tokenize(str) {
        var key, ret, tempString = "";
        function getObjectValuesRecursive(str) {
            var property;
            for (property in str) {
                if (str.hasOwnProperty(property)) {
                    if (typeof str[property] === "object") {
                        tempString = " " + getObjectValuesRecursive(str[property]);
                    }
                    else {
                        tempString += " " + str[property];
                    }
                }
            }
            return tempString;
        }
        if (!str) {
            return [];
        }
        if (Array.isArray(str)) {
            ret = [];
            for (key in str) {
                if (str.hasOwnProperty(key)) {
                    ret = ret.concat(this.tokenize(str[key]));
                }
            }
            return ret;
        }
        if (typeof str === "object") {
            str = getObjectValuesRecursive(str);
        }
        str = this.seperateUnitsFromNumbers(str);
        str = str.replace(/[a-z]-/g, function (match) {
            return match[0] + " ";
        });
        // cut off leading and trailing spaces
        str = str.replace(/^\s+|\s+$/g, "");
        return str.split(/\s+/);
    }
    static normalizedTokenize(s, options) {
        return this.tokenize(this.normalize(s, options));
    }
    static phoneticTokenize(s, options) {
        return new KoelnerPhonetik(this.normalizedTokenize(s, options)).getValue();
    }
    /**
     * Normailzes a given string respectively first converts given parameter to string.
     */
    static normalize(exp, options) {
        var i, key, ret;
        options = options || {};
        if (Array.isArray(exp)) {
            ret = [];
            for (i = 0; i < exp.length; i += 1) {
                ret.push(this.normalize(exp[i]));
            }
            return ret;
        }
        if (typeof exp === "object") {
            ret = "";
            for (key in exp) {
                if (exp.hasOwnProperty(key)) {
                    if (Array.isArray(exp[key])) {
                        if (exp[key].length) {
                            ret += " " + this.normalize(exp[key]);
                        }
                    }
                    else {
                        ret += " " + this.normalize(exp[key]);
                    }
                }
            }
            if (ret === " ") {
                return "";
            }
            return ret;
        }
        if (typeof exp !== "string") {
            exp = exp.toString();
        }
        exp = exp.toLowerCase();
        exp = exp.replace(/\//g, " ");
        exp = exp.replace(/\-\-/g, "-");
        exp = exp.replace(/ä/g, "ae");
        exp = exp.replace(/[àåáâã]/g, "a");
        exp = exp.replace(/[æ]/g, "ae");
        exp = exp.replace(/[ç]/g, "c");
        exp = exp.replace(/[ð]/g, "d");
        exp = exp.replace(/[èéêë]/g, "e");
        exp = exp.replace(/[ìíîï]/g, "i");
        exp = exp.replace(/[ñ]/g, "n");
        exp = exp.replace(/ö/g, "oe");
        exp = exp.replace(/[òóôõø]/g, "o");
        exp = exp.replace(/ü/g, "ue");
        exp = exp.replace(/[ùúû]/g, "u");
        exp = exp.replace(/[ýÿ]/g, "y");
        exp = exp.replace(/[ž]/g, "z");
        exp = exp.replace(/[ß]/g, "ss");
        // convert floats written with `,` to dot notation
        exp = exp.replace(/(\d+),(\d+)/, "$1.$2");
        // replace all characters that are reserved for elastic with space: - = && || > < ! ( ) { } [ ] ^ " ~ * ? : \ /
        exp = exp.replace(/[\^!"§$%&/\\|()=?,;:\[\]\-<>{}~*]/g, " ");
        // delete all spaces longer than one
        exp = exp.replace(/\s+/g, " ");
        // delete all leading, trailing, single and multiple +
        exp = exp.replace(/(\s*\++\s*)+/g, "+");
        exp = exp.replace(/\+\s*$/, "");
        exp = exp.replace(/\+\s*(#_search|#_search_c)$/, " $1");
        if (!options.phone) {
            exp = exp.replace(/^\s*\+/, "");
            // for all other + add spaces
            exp = exp.replace(/\+/g, " + ");
        }
        exp = exp.replace(/\r|\n|\t/g, " ");
        exp = exp.replace(/\s+$/g, "");
        exp = exp.replace(/[^\x00-\xFF]/g, "");
        return exp;
    }
    static birthdize(str) {
        var arr = this.tokenize(str.replace(/(\d\d)\.(\d\d)\.(\d\d|\d\d\d\d)/g, "$1" + " " + "$2" + " " + "$3"));
        if (str.match(/^\d\d\d\d\s\d\d\s\d\d$/)) {
            arr = arr.concat(str.substr(2, 2));
            arr = arr.concat(str.substr(8, 2) + str.substr(5, 2) + str.substr(2, 2));
            arr = arr.concat(str.substr(8, 2) + str.substr(5, 2) + str.substr(0, 4));
        }
        return arr;
    }
    static normalizedBirthdize(s, options) {
        return this.birthdize(this.normalize(s, options));
    }
    static phoneize(str) {
        var phoneNumber, internationalAreaCode = "49", addIAC = false;
        // remove all chars except numbers and "+"
        phoneNumber = str.replace(/[^\d\+]/ig, "");
        if (phoneNumber.length > 0) {
            // filter international area code
            if (phoneNumber.indexOf("+") === 0) {
                internationalAreaCode = phoneNumber.substr(1, 2);
                phoneNumber = phoneNumber.substring(3);
                addIAC = true;
            }
            else if (phoneNumber.indexOf("00") === 0) {
                internationalAreaCode = phoneNumber.substr(2, 2);
                phoneNumber = phoneNumber.substring(4);
                addIAC = true;
            }
            // filter leading zero of area code
            if (phoneNumber.indexOf("0") === 0) {
                phoneNumber = phoneNumber.substring(1);
                addIAC = true;
            }
            if (addIAC) {
                phoneNumber = internationalAreaCode + phoneNumber;
            }
        }
        return phoneNumber;
    }
    static normalizedPhoneize(s, options) {
        return this.phoneize(this.normalize(s, options));
    }
    static removeHtmlTags(value) {
        return value.replace(/(<([^>]+)>)/ig, " ");
    }
    /**
     * Converts date string into iso date format string.
     */
    static dateString2Iso(s) {
        if (typeof s !== "string") {
            throw new Error("dateString2Iso: param has to be string");
        }
        // adding 'T' and 'Z' to the string will enable interpretation as ISO string with UTC timezone
        s = s.replace(/\s/, "T");
        if (s.substr(-1) !== "Z") {
            s += "Z";
        }
        return new Date(s).toISOString();
    }
    static getHeadSearchValue(headSearchValue, value, isArray) {
        return isArray ? (headSearchValue || []).concat(value) : value;
    }
    static shortenForHash(value) {
        if (typeof value === "string") {
            return value.substr(0, 10);
        }
        return value.map((item) => {
            return item.substr(0, 10);
        });
    }
    static getClearHeadSearchValuesAndExtensions(fieldSearch, value, fieldType, fieldCrypto, isSearch, shortenForHashes, normalizeOptions, collected = true) {
        let resultList = [], clearValue = "", clearSoundexValue, ext;
        if (fieldSearch.indexed === "birthday") {
            // indexed:birthday is only allowed on crypto fields
            clearValue = this.normalizedBirthdize(value, normalizeOptions);
            if (shortenForHashes) {
                clearValue = this.shortenForHash(clearValue);
            }
            ext = "_token";
            resultList.push({ clearValue, ext });
        }
        else if (fieldSearch.indexed === "phone") {
            // indexed:phone is only allowed on crypto fields
            const isHashedPhoneNumber = fieldCrypto && isServerContext;
            clearValue = isHashedPhoneNumber ? value : this.normalizedPhoneize(value, normalizeOptions);
            ext = "_exact";
            resultList.push({ clearValue, ext });
        }
        else if (fieldSearch.indexed === "exact") {
            if (["date", "datetime"].indexOf(fieldType) !== -1 && !fieldCrypto) {
                // for crypted data there is no need to save date on dedicated search field as this is only needed for date range queries which are not
                // possible on crypted dates
                clearValue = new Date(this.dateString2Iso(value));
                ext = "_date";
                resultList.push({ clearValue, ext });
            }
            else if (fieldType === "int") {
                clearValue = value;
                ext = "_int";
                resultList.push({ clearValue, ext });
            }
            else if (fieldType === "float") {
                clearValue = value;
                ext = "_float";
                resultList.push({ clearValue, ext });
            }
            else {
                clearValue = this.normalize(value, normalizeOptions);
                ext = "_exact";
                resultList.push({ clearValue, ext });
            }
        }
        else if (fieldSearch.indexed.substr(0, 5) === "token") {
            if (!isSearch && fieldCrypto && fieldSearch.indexed.substr(0, 7) === "token_i") {
                // initialize is only needed for crypted data - for cleartext elastic can search for word beginnings itself
                clearValue = this.filledUpInitialize(value, normalizeOptions);
            }
            else {
                clearValue = this.normalizedTokenize(value, normalizeOptions);
            }
            if (shortenForHashes) {
                clearValue = this.shortenForHash(clearValue);
            }
            ext = "_token";
            resultList.push({ clearValue, ext });
            if (fieldSearch.indexed.indexOf("kp") > -1) {
                clearSoundexValue = this.phoneticTokenize(value, normalizeOptions);
                if (shortenForHashes) {
                    clearSoundexValue = this.shortenForHash(clearSoundexValue);
                }
                ext = "_soundex";
                if (!isSearch && fieldSearch.indexed === "token_i_kp") {
                    if (fieldCrypto) {
                        clearSoundexValue = this.phoneticFilledUpInitialize(value, normalizeOptions);
                    }
                    else {
                        clearSoundexValue = this.phoneticInitialize(value, normalizeOptions);
                    }
                    if (shortenForHashes) {
                        clearSoundexValue = this.shortenForHash(clearSoundexValue);
                    }
                }
                resultList.push({ clearValue: clearSoundexValue, ext });
                clearValue = clearValue.concat(clearSoundexValue);
            }
        }
        if (collected && fieldSearch.collected) {
            ext = "_collect";
            resultList.push({ clearValue, ext });
        }
        return resultList;
    }
}
SearchData.clearCollectFieldName = "search_clear_collect";
SearchData.cryptoCollectFieldName = "search_c_collect";class DateConverter {
    constructor(date) {
        this.date = date;
    }
    toLocaleISOString() {
        if (!this.date.getFullYear) {
            return this.date;
        }
        function pad(n) {
            return ("0" + n).substr(-2);
        }
        var day = [this.date.getFullYear(), pad(this.date.getMonth() + 1), pad(this.date.getDate())].join("-"), time = [this.date.getHours(), this.date.getMinutes(), this.date.getSeconds()].map(pad).join(":"), ms = this.date.getMilliseconds(), len;
        if (ms) {
            ms = ms.toString();
            len = 4 - ms.length;
            ms += new Array(len).join("0");
            time += "." + ms;
        }
        return day + " " + time;
    }
}class Log {
    static write(level, ...args) {
        let key, arr = [];
        for (key in args) {
            if (args.hasOwnProperty(key)) {
                if (typeof args[key] === "object") {
                    arr.push(JSON.parse(JSON.stringify(args[key])));
                }
                else {
                    arr.push(args[key]);
                }
            }
        }
        arr.unshift(new DateConverter(new Date()).toLocaleISOString(), ":");
        if (level >= this.logLevel) {
            switch (level) {
                case 0:
                    window.console.debug.apply(window.console, arr);
                    break;
                case 2:
                    window.console.warn.apply(window.console, arr);
                    break;
                case 3:
                    window.console.error.apply(window.console, arr);
                    break;
                default:
                    window.console.log.apply(window.console, arr);
            }
        }
    }
}
Log.logLevel = 1 /* LogLevel.info */;exports.ObjectStoreNames=void 0;
(function (ObjectStoreNames) {
    ObjectStoreNames["KEYS"] = "keys";
    ObjectStoreNames["RED_APP_VERSION"] = "redAppVersion";
})(exports.ObjectStoreNames || (exports.ObjectStoreNames = {}));
exports.IndexedDBWrapperState=void 0;
(function (IndexedDBWrapperState) {
    IndexedDBWrapperState["CONSTRUCTED"] = "constructed";
    IndexedDBWrapperState["OPENING"] = "opening";
    IndexedDBWrapperState["OPENED"] = "opened";
    IndexedDBWrapperState["READY"] = "ready";
    IndexedDBWrapperState["UPGRADENEEDED"] = "upgradeneeded";
    IndexedDBWrapperState["ERROR"] = "error";
    IndexedDBWrapperState["BLOCKED"] = "blocked";
    IndexedDBWrapperState["VERSIONCHANGE"] = "versionchange";
    IndexedDBWrapperState["CLOSED"] = "closed";
})(exports.IndexedDBWrapperState || (exports.IndexedDBWrapperState = {}));
exports.IndexedDBWrapperEvents=void 0;
(function (IndexedDBWrapperEvents) {
    IndexedDBWrapperEvents["ERROR"] = "error";
    IndexedDBWrapperEvents["VERSIONCHANGE"] = "versionchange";
    IndexedDBWrapperEvents["READY"] = "ready";
    IndexedDBWrapperEvents["CLOSE"] = "close";
})(exports.IndexedDBWrapperEvents || (exports.IndexedDBWrapperEvents = {}));
class IndexedDBWrapper extends EventTarget {
    constructor(databaseName, version, objectStoresConfiguration) {
        super();
        this.databaseName = databaseName;
        this.version = version;
        this.objectStoresConfiguration = objectStoresConfiguration;
        this.state = exports.IndexedDBWrapperState.CONSTRUCTED;
        this.objectStoreNames = Object.keys(objectStoresConfiguration);
        if (!IndexedDBWrapper.indexedDBFactory) {
            throw new Error("IndexedDB not implemented in Browser");
        }
    }
    getStateAndDetails() {
        return {
            state: this.state,
            stateDetails: this.stateDetails
        };
    }
    canBeOpened() {
        return [
            exports.IndexedDBWrapperState.CONSTRUCTED,
            exports.IndexedDBWrapperState.ERROR,
            exports.IndexedDBWrapperState.CLOSED
        ].includes(this.state);
    }
    isReady() {
        return this.state === exports.IndexedDBWrapperState.READY;
    }
    isBroken() {
        return [
            exports.IndexedDBWrapperState.ERROR,
            exports.IndexedDBWrapperState.BLOCKED
        ].includes(this.state);
    }
    addEventListener(type, callback, options) {
        super.addEventListener(type, callback, options);
    }
    open() {
        if (!this.canBeOpened()) {
            return this;
        }
        this.state = exports.IndexedDBWrapperState.OPENING;
        const openRequest = IndexedDBWrapper.indexedDBFactory
            .open(this.databaseName, this.version);
        openRequest.addEventListener("error", (event) => {
            // Error on opening the database
            // Two major causes:
            //  1. An old version is requested
            //  2. IndexedDB cannot be accessed (private browser mode for example)
            this.state = exports.IndexedDBWrapperState.ERROR;
            const error = new Error("IndexedDB open error");
            error.details = openRequest.error;
            this.stateDetails = error;
            console.error(error);
            this.dispatchEvent(new Event(exports.IndexedDBWrapperEvents.ERROR));
        });
        openRequest.addEventListener("upgradeneeded", () => {
            // Database has to be created or upgraded
            this.state = exports.IndexedDBWrapperState.UPGRADENEEDED;
            const database = openRequest.result;
            for (const objectStoreName of this.objectStoreNames) {
                const objectStoreParameters = this.objectStoresConfiguration[objectStoreName];
                // If there was the object store in previous version, it is transferred to the new version automatically
                if (!database.objectStoreNames.contains(objectStoreName)) {
                    database.createObjectStore(objectStoreName, objectStoreParameters);
                }
            }
            this.database = database;
            setTimeout(() => {
                if (this.state === exports.IndexedDBWrapperState.UPGRADENEEDED) {
                    this.state = exports.IndexedDBWrapperState.READY;
                    this.dispatchEvent(new Event(exports.IndexedDBWrapperEvents.READY));
                }
            }, 5);
        });
        openRequest.addEventListener("success", (event) => {
            // Successfully opened the database
            if (this.state !== exports.IndexedDBWrapperState.UPGRADENEEDED) {
                this.state = exports.IndexedDBWrapperState.OPENED;
            }
            setTimeout(() => {
                if (this.state === exports.IndexedDBWrapperState.OPENED) {
                    this.state = exports.IndexedDBWrapperState.READY;
                    this.dispatchEvent(new Event(exports.IndexedDBWrapperEvents.READY));
                }
            }, 5);
            this.database = openRequest.result;
            this.database.addEventListener("versionchange", () => {
                // Another page / open tab wants to update the indexedDB
                // So, we have to close our connection
                this.state = exports.IndexedDBWrapperState.VERSIONCHANGE;
                this.database.close();
                this.dispatchEvent(new Event(exports.IndexedDBWrapperEvents.VERSIONCHANGE));
                setTimeout(() => {
                    if (this.state === exports.IndexedDBWrapperState.VERSIONCHANGE) {
                        this.state = exports.IndexedDBWrapperState.CLOSED;
                        this.dispatchEvent(new Event(exports.IndexedDBWrapperEvents.CLOSE));
                    }
                }, 5);
            });
            this.database.addEventListener("close", () => {
                // Event is only fired if close was unexpected!
                if (this.state !== exports.IndexedDBWrapperState.VERSIONCHANGE) {
                    this.state = exports.IndexedDBWrapperState.CLOSED;
                }
                this.dispatchEvent(new Event(exports.IndexedDBWrapperEvents.CLOSE));
            });
            this.database.addEventListener("error", (event) => {
                // Catches all unhandled error events on this database, its transactions and requests
                console.error("indexedDB error", event);
            });
            this.database.addEventListener("abort", (event) => {
                // A transaction is aborted
                console.error("indexedDB transaction aborted");
            });
        });
        openRequest.addEventListener("blocked", () => {
            // The database is currently blocked by a versionchange transaction
            if (this.state !== exports.IndexedDBWrapperState.BLOCKED || !this.stateDetails.retries) {
                this.dispatchEvent(new Event("blocked"));
                this.stateDetails = {
                    retries: 1
                };
            }
            else {
                this.stateDetails.retries++;
            }
            this.state = exports.IndexedDBWrapperState.BLOCKED;
            if (this.stateDetails.retries < 10) {
                setTimeout(() => {
                    // Retry
                    this.open();
                }, 500);
            }
        });
        return this;
    }
    /**
     * Checks if all object stores exist and there are objects stored in
     * @private
     */
    async checkDatabaseHealthiness() {
        for (const objectStoreName of this.objectStoreNames) {
            if (!this.database.objectStoreNames.contains(objectStoreName)) {
                throw new Error(`ObjectStore is not available: ${objectStoreName}`);
            }
            await new Promise((resolve, reject) => {
                let pending = true;
                const request = this.database
                    .transaction(objectStoreName)
                    .objectStore(objectStoreName)
                    .count();
                request.addEventListener("success", () => {
                    if (pending) {
                        pending = false;
                        resolve(request.result);
                    }
                });
                request.addEventListener("error", () => {
                    if (pending) {
                        pending = false;
                        reject(request.error);
                    }
                });
            });
        }
    }
    waitForReadyState() {
        if (this.isReady()) {
            return Promise.resolve();
        }
        if (this.isBroken()) {
            return Promise.reject(new Error(`Illegal IndexedDB state ${this.state}`));
        }
        if (this.state === exports.IndexedDBWrapperState.CLOSED) {
            this.open();
            return this.waitForReadyState();
        }
        return new Promise((resolve, reject) => {
            let pending = true;
            this.addEventListener(exports.IndexedDBWrapperEvents.READY, () => {
                if (pending) {
                    pending = false;
                    resolve();
                }
            });
            this.addEventListener(exports.IndexedDBWrapperEvents.ERROR, (err) => {
                if (pending) {
                    pending = false;
                    reject(err);
                }
            });
            setTimeout(() => {
                if (pending) {
                    pending = false;
                    reject(new Error("Timeout waiting for IndexedDB to be ready"));
                }
            }, 10000);
        });
    }
    async deleteDatabase() {
        await this.waitForReadyState();
        await new Promise((resolve, reject) => {
            let pending = true;
            const deleteRequest = IndexedDBWrapper.indexedDBFactory.deleteDatabase(this.databaseName);
            deleteRequest.addEventListener("error", (err) => {
                if (pending) {
                    pending = false;
                    reject(deleteRequest.error);
                }
            });
            deleteRequest.addEventListener("success", () => {
                if (pending) {
                    pending = false;
                    resolve();
                }
            });
            setTimeout(() => {
                if (pending) {
                    pending = false;
                    reject(new Error("Deletion timeout"));
                }
            }, 5000);
        });
    }
    async get(storeName, id) {
        this.checkStoreAvailable(storeName);
        await this.waitForReadyState();
        await this.checkAndRepairDatabase();
        return new Promise((resolve, reject) => {
            let pending = true;
            const transaction = this.database.transaction(storeName);
            transaction.addEventListener("error", (event) => {
                event.stopPropagation();
                if (pending) {
                    pending = false;
                    reject(new Error(`IndexedDB read transaction error. ID: ${id}`));
                }
            });
            const objectStore = transaction.objectStore(storeName);
            const request = objectStore.get(id);
            request.addEventListener("error", (event) => {
                event.stopPropagation();
                if (pending) {
                    pending = false;
                    reject(new Error(`IndexedDB read request error. ID: ${id}`));
                }
            });
            request.addEventListener("success", (event) => {
                event.stopPropagation();
                if (pending) {
                    pending = false;
                    resolve(request.result);
                }
            });
            setTimeout(() => {
                if (pending) {
                    pending = false;
                    reject(new Error("Timeout waiting for IndexedDB to return data"));
                }
            }, 10000);
        });
    }
    async set(storeName, data) {
        this.checkStoreAvailable(storeName);
        await this.waitForReadyState();
        await this.checkAndRepairDatabase();
        return new Promise((resolve, reject) => {
            let pending = true;
            const transaction = this.database.transaction(storeName, "readwrite");
            const objectStore = transaction.objectStore(storeName);
            const request = objectStore.put(data);
            transaction.addEventListener("error", (event) => {
                event.stopPropagation();
                if (pending) {
                    pending = false;
                    reject(new Error(`IndexedDB write transaction error. Data: ${data}`));
                }
            });
            transaction.addEventListener("complete", (event) => {
                event.stopPropagation();
                if (pending) {
                    pending = false;
                    resolve();
                }
            });
            request.addEventListener("error", (event) => {
                event.stopPropagation();
                if (pending) {
                    pending = false;
                    reject(new Error(`IndexedDB write request error. Data: ${data}`));
                }
            });
            request.addEventListener("success", (event) => {
                event.stopPropagation();
            });
            setTimeout(() => {
                if (pending) {
                    pending = false;
                    reject(new Error("Timeout waiting for IndexedDB to complete transaction"));
                }
            }, 10000);
        });
    }
    async del(storeName, id) {
        this.checkStoreAvailable(storeName);
        await this.waitForReadyState();
        await this.checkAndRepairDatabase();
        await new Promise((resolve, reject) => {
            let pending = true;
            const transaction = this.database.transaction(storeName, "readwrite");
            const objectStore = transaction.objectStore(storeName);
            const request = objectStore.delete(id);
            transaction.addEventListener("error", (event) => {
                event.stopPropagation();
                if (pending) {
                    pending = false;
                    reject(new Error(`IndexedDB delete transaction error. ID: ${id}`));
                }
            });
            transaction.addEventListener("complete", (event) => {
                event.stopPropagation();
                if (pending) {
                    pending = false;
                    resolve();
                }
            });
            request.addEventListener("error", (event) => {
                event.stopPropagation();
                if (pending) {
                    pending = false;
                    reject(new Error(`IndexedDB delete request error. ID: ${id}`));
                }
            });
            request.addEventListener("success", (event) => {
                event.stopPropagation();
            });
            setTimeout(() => {
                if (pending) {
                    reject(new Error("Timeout waiting for IndexedDB to complete transaction"));
                }
                pending = false;
            }, 10000);
        });
    }
    async checkAndRepairDatabase() {
        var _a;
        for (let i = 0; i < 10; i++) {
            try {
                await this.checkDatabaseHealthiness();
            }
            catch (err) {
                if (err instanceof DOMException) {
                    console.error(err.name, `(${err.code}):`, err.message);
                    if ((_a = err.message) === null || _a === void 0 ? void 0 : _a.includes("A version change transaction is running")) {
                        // Retry if version change is running
                        await new Promise(r => setTimeout(r, 1000));
                        console.log("retry...");
                        continue;
                    }
                }
                else {
                    console.error(err);
                }
                console.error("Illegal state of IndexedDB. Recreating...");
                try {
                    await this.deleteDatabase();
                }
                catch (e) {
                    console.error(e);
                }
                this.open();
                await this.waitForReadyState();
            }
            return;
        }
        throw "maximum number of database repairs exceeded";
    }
    checkStoreAvailable(storeName) {
        if (!this.objectStoreNames.includes(storeName)) {
            throw new Error(`Illegal Store Name: ${storeName}. Must be one of: ${this.objectStoreNames.join(", ")}`);
        }
    }
}
// @ts-ignore
IndexedDBWrapper.indexedDBFactory = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
class indexedDB {
    // increment version, when creating new tables / object stores
    static async write(storeName, data) {
        return this.dataStore.set(storeName, data);
    }
    static async read(storeName, id) {
        return this.dataStore.get(storeName, id);
    }
    static async delete(storeName, id) {
        return this.dataStore.del(storeName, id);
    }
    static async deleteDatabase() {
        return this.dataStore.deleteDatabase().then(() => true);
    }
}
indexedDB.databaseName = "RED Medical GmbH";
indexedDB.databaseVersion = 2;
indexedDB.dataStore = new IndexedDBWrapper(indexedDB.databaseName, indexedDB.databaseVersion, {
    [exports.ObjectStoreNames.KEYS]: { keyPath: "id" },
    [exports.ObjectStoreNames.RED_APP_VERSION]: { keyPath: "id" }
}).open();const STORAGE_KEYS = {
    LOCAL: {
        DEVICE_ID: "deviceId"
    },
    SESSION: {
        HASH_SALT: "hash_salt",
        USER_ID: "user_id",
        SESSION_ID: "session_id",
        SALT: "salt",
        USER_ALIAS: "user_alias",
        TERMINAL_ID: "terminal_id",
        TENANT_ID: "tenant_id",
        SESSION_LICENSE: "session_license"
    }
};class crypto {
    static async encrypt(clear, key, type) {
        const cryptoKey = key || await crypto.getKey("key_tenant_s");
        if (!cryptoKey) {
            throw new Error("encryption not possible: missing key");
        }
        const version = 3; // version saved in header - old magic number
        const ivl = 16; // initialization vector length - 16 byte is webcrypto default
        const iv = this.randomArray(ivl);
        let cleartext = clear;
        let rawBuffer;
        if (type === "base64") {
            cleartext = atob(clear);
            rawBuffer = this.bin2Array(cleartext);
        }
        else if (clear instanceof Uint8Array) {
            rawBuffer = [...clear];
        }
        else {
            switch (typeof clear) {
                case "object":
                    cleartext = JSON.stringify(clear);
                    break;
                case "number":
                case "boolean":
                    cleartext = clear.toString();
                    break;
            }
            rawBuffer = this.string2Array(cleartext);
        }
        let missing = 16 - rawBuffer.length % 16; // cleartext buffer will be filled up to a length divisible by 16
        if (missing === 16) {
            missing = 0;
        }
        const filledBuffer = this.array2Uint8Array(rawBuffer, rawBuffer.length + missing);
        const header = new Uint8Array(2); // 2 is the header length.
        // Header will be the first 2 bytes and holds information about version and length.
        header[0] = (missing * 16) + (ivl - 1);
        header[1] = version;
        const res = await window.crypto.subtle.encrypt({
            name: "AES-GCM",
            iv: this.arrayBufferFromUint8Array(iv),
            tagLength: 128 // currently recommended length of authentication tag
        }, cryptoKey, this.arrayBufferFromUint8Array(filledBuffer));
        const u8arrRes = this.concatUint8Array(this.concatUint8Array(header, iv.subarray(0, ivl)), new Uint8Array(res));
        return this.Uint8Array2b64(u8arrRes);
    }
    static async encryptAESKey(aesKey, publicKey) {
        const aesRawBuffer = this.string2Array(aesKey);
        const aesKeyBuffer = this.array2Uint8Array(aesRawBuffer, aesRawBuffer.length);
        const encrypted = await window.crypto.subtle.encrypt({
            name: "RSA-OAEP"
        }, publicKey, this.arrayBufferFromUint8Array(aesKeyBuffer));
        return this.Uint8Array2b64(new Uint8Array(encrypted));
    }
    /**
     * Decrypts a cipher text. If it is encrypted by hybrid encryption (RSA), the text will be decrypted with the tenant's private key.
     *
     * @param cipher Encrypted cipher text
     * @param key Key to use, ignored if encrypted by RSA. If not specified, the symmetric tenant key is used
     * @param type data type for type casting
     */
    static async decrypt(cipher, key, type) {
        let algorithm;
        let iv;
        let decryptArr;
        let intermediateKey;
        if (typeof cipher === "string" && cipher.startsWith("{") && cipher.endsWith("}")) {
            // JSON Object
            const cipherObj = JSON.parse(cipher);
            algorithm = cipherObj.algorithm;
            iv = this.b64ToUint8Array(cipherObj.iv);
            decryptArr = this.b64ToUint8Array(cipherObj.encryptedValue);
            if (cipherObj.key) {
                intermediateKey = cipherObj.key;
            }
        }
        else {
            algorithm = "aes";
            const cipherArr = cipher instanceof Uint8Array ? cipher : this.b64ToUint8Array(cipher);
            const missing = cipherArr[0] >> 4;
            const ivl = cipherArr[0] - (missing * 16) + 1;
            const version = cipherArr[1];
            iv = new Uint8Array(16);
            if (version > 2) {
                iv.set(cipherArr.subarray(2, 2 + ivl));
            }
            decryptArr = cipherArr.subarray(2 + ivl);
        }
        let cryptoKey;
        switch (algorithm) {
            case "aes":
                cryptoKey = key || await crypto.getKey("key_tenant_s");
                break;
            case "rsa":
                const rsaKey = await this.getKey("key_private_rsa_tenant_s");
                // Ignores given cryptoKey!
                cryptoKey = await this.objectToAesKey(JSON.parse(await this.decryptAesKey(intermediateKey, rsaKey)));
                break;
        }
        const res = await window.crypto.subtle.decrypt({
            name: "AES-GCM",
            iv: this.arrayBufferFromUint8Array(iv)
        }, cryptoKey, this.arrayBufferFromUint8Array(decryptArr));
        const resultArr = this.removePaddingFromUint8Array(new Uint8Array(res));
        switch (type) {
            case "base64":
                return this.Uint8Array2b64(resultArr);
            case "string":
                return this.Uint8Array2string(resultArr);
            case "float":
                return parseFloat(this.Uint8Array2string(resultArr));
            case "int":
                return parseInt(this.Uint8Array2string(resultArr), 10);
            case "boolean":
                return this.Uint8Array2string(resultArr) === "true";
            case "unit8array":
                return resultArr;
            default:
                const cleartext = this.Uint8Array2string(resultArr);
                try {
                    return JSON.parse(cleartext);
                }
                catch (err) {
                    return cleartext;
                }
        }
    }
    static async decryptAesKey(cryptedKey, privateKey) {
        const cipherArr = this.b64ToUint8Array(cryptedKey);
        const decrypted = await window.crypto.subtle.decrypt({
            name: "RSA-OAEP"
        }, privateKey, this.arrayBufferFromUint8Array(cipherArr));
        return this.Uint8Array2string(new Uint8Array(decrypted));
    }
    static async createPBKDF2Context(password) {
        return await window.crypto.subtle.importKey("raw", this.string2Uint8Array(password, 32), { name: "PBKDF2" }, false, ["deriveBits"]);
    }
    static async derivateKey(password, salt, it, extractable = false) {
        let baseKey = await this.createPBKDF2Context(password);
        // Derive a bit array from the password (deriveKey is not available for Safari at the moment; so we use deriveBits and importKey)
        const bitArray = await window.crypto.subtle.deriveBits({
            name: "PBKDF2",
            salt: this.string2Uint8Array(salt, 32),
            iterations: it || this.derivate_key_it,
            hash: "SHA-256"
        }, baseKey, 128);
        // derive a key from the bit array
        return window.crypto.subtle.importKey("raw", bitArray, { name: "AES-GCM" }, extractable, ["encrypt", "decrypt"]);
    }
    static async createRandomSymmetricKey() {
        const randomArray = this.randomArray(16);
        // derive a key from the bit array
        return await window.crypto.subtle.importKey("raw", this.arrayBufferFromUint8Array(randomArray), { name: "AES-GCM", length: 128 }, true, ["encrypt", "decrypt"]);
    }
    static async createRSAKeyPair() {
        return window.crypto.subtle.generateKey({
            name: "RSA-OAEP",
            modulusLength: 4096, // can be 1024, 2048, or 4096
            publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
            hash: { name: "SHA-256" } // can be "SHA-1", "SHA-256", "SHA-384", or "SHA-512"
        }, true, // whether the key is extractable (i.e. can be used in exportKey)
        ["encrypt", "decrypt"] // must be ["encrypt", "decrypt"] or ["wrapKey", "unwrapKey"]
        );
    }
    static removePaddingFromUint8Array(arr) {
        let arrEdit = arr.slice(0);
        while (arrEdit[arrEdit.length - 1] === 0) {
            arrEdit = arrEdit.slice(0, arrEdit.length - 1);
        }
        return arrEdit;
    }
    static removeEncodePadding(s) {
        return decodeURIComponent(encodeURIComponent(s).replace(/(%00)+$/, ""));
    }
    static async aesKeyToString(key) {
        const exportKeyResult = await window.crypto.subtle.exportKey("jwk", key);
        return exportKeyResult.k;
    }
    static async stringToAesKey(keyString, extractable = false) {
        const keyStringWithoutPadding = this.removeEncodePadding(keyString);
        const keyObject = {
            alg: "A128GCM",
            ext: true,
            k: keyStringWithoutPadding,
            key_ops: ["encrypt", "decrypt"],
            kty: "oct"
        };
        return window.crypto.subtle.importKey("jwk", keyObject, { name: "AES-GCM", length: 128 }, extractable, ["encrypt", "decrypt"]);
    }
    static async objectToAesKey(jwkObject, extractable = false) {
        return window.crypto.subtle.importKey("jwk", jwkObject, { name: "AES-GCM" }, extractable, ["encrypt", "decrypt"]);
    }
    static async rsaKeyToString(key) {
        const exportKeyResult = await window.crypto.subtle.exportKey("jwk", key);
        return JSON.stringify(exportKeyResult);
    }
    static async stringToRsaKey(keyString, extractable = false) {
        const keyObject = JSON.parse(keyString);
        return window.crypto.subtle.importKey("jwk", keyObject, {
            name: "RSA-OAEP",
            hash: { name: "SHA-256" } // can be "SHA-1", "SHA-256", "SHA-384", or "SHA-512"
        }, extractable, keyObject.key_ops);
    }
    static rawHash(plaintext, salt, length) {
        const arrayBuffer = this.str2ab(salt + plaintext);
        return window.crypto.subtle.digest("SHA-256", arrayBuffer)
            .then((hashBuffer) => {
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            const hashHex = hashArray.map(b => ("00" + b.toString(16)).slice(-2)).join("");
            return hashHex.substr(0, length);
        });
    }
    /**
     *
     * @param plaintext //derivate_key
     * @param salt
     * @param len
     * @returns {*}
     */
    static async hash(plaintext, salt, len) {
        const length = len || 32;
        // Chrome returns null if unset
        if (salt === undefined || salt === null) {
            salt = sessionStorage.getItem(STORAGE_KEYS.SESSION.HASH_SALT);
        }
        if (salt === undefined || salt === null) {
            // try to reload hash salt from server
            const hashSaltResult = await redServicePromised({
                class: "auth",
                method: "getHashSalt"
            });
            if (!hashSaltResult || !hashSaltResult.hashSalt) {
                return Promise.reject(new Error("Missing salt using this.hash() - cannot reload from server"));
            }
            const hashSalt = await crypto.decrypt(hashSaltResult.hashSalt);
            if (hashSalt !== "") {
                sessionStorage.setItem(STORAGE_KEYS.SESSION.HASH_SALT, hashSalt);
                salt = hashSalt;
            }
            else {
                return Promise.reject(new Error("Missing salt using this.hash() - reloading from server failed"));
            }
        }
        if (typeof salt !== "string") {
            return Promise.reject(new Error("Salt is not a string this.hash()"));
        }
        if (typeof plaintext === "string") {
            return this.rawHash(plaintext, salt, length);
        }
        if (Array.isArray(plaintext)) {
            const arr = [];
            let i, arrayLength = plaintext.length;
            for (i = 0; i < arrayLength; ++i) {
                arr.push(this.rawHash(plaintext[i], salt, length));
            }
            return Promise.all(arr);
        }
        // object, boolean, number
        return this.rawHash(JSON.stringify(plaintext), salt, length);
    }
    /**
     *
     * @param {Number} [countBytes]
     * @param {Boolean} [ts_flag]
     * @returns {*}
     */
    static randomArray(countBytes, ts_flag) {
        var buffer, d, timestamp;
        countBytes = countBytes || 16;
        if (ts_flag) {
            d = new Date();
            timestamp = new Uint8Array([
                d.getYear(),
                d.getDate(),
                d.getHours(),
                d.getMinutes(),
                d.getSeconds(),
                d.getMonth() * d.getMilliseconds() >> 8,
                d.getMilliseconds() % 256
            ]);
            countBytes -= 7;
        }
        else {
            timestamp = new Uint8Array(0);
        }
        buffer = new Uint8Array(countBytes);
        // IE 11 uses msCrypto ...
        if (window.msCrypto) {
            window.msCrypto.getRandomValues(buffer);
        }
        else {
            window.crypto.getRandomValues(buffer);
        }
        return this.concatUint8Array(buffer, timestamp);
    }
    static random(counBytes, ts_flag) {
        return this.Uint8Array2b64(this.randomArray(counBytes, ts_flag));
    }
    /**
     *
     * @param s
     * @returns {Array}
     */
    static string2Array(s) {
        var i, cc, len, n, buf = [];
        len = s.length;
        for (i = 0, n = 0; i < len; i += 1, n += 1) {
            cc = s.charCodeAt(i);
            if (cc > 254) {
                buf[n] = 255;
                buf[n + 1] = cc >> 8;
                buf[n + 2] = cc % 256;
                n += 2;
            }
            else {
                buf[n] = cc;
            }
        }
        return buf;
    }
    /**
     *
     * @param s
     * @returns {Array}
     */
    static bin2Array(s) {
        var i, len, buf = [];
        len = s.length;
        for (i = 0; i < len; i += 1) {
            buf[i] = s.charCodeAt(i);
        }
        return buf;
    }
    /**
     *
     * @param buf
     * @param [len]
     * @returns {Uint8Array}
     */
    static array2Uint8Array(buf, len) {
        var ta;
        len = len || buf.length;
        ta = new Uint8Array(len);
        ta.set(buf, 0);
        return ta;
    }
    /**
     *
     * @param s
     * @param [len]
     * @returns {*}
     */
    static string2Uint8Array(s, len) {
        var buf = this.string2Array(s);
        return this.array2Uint8Array(buf, len);
    }
    /**
     * @constructor
     */
    static Uint8Array2string(buf, len) {
        var i, cc, s = "";
        len = len || buf.byteLength;
        for (i = 0; i < len; i += 1) {
            cc = buf[i];
            if (cc === 255) {
                if (i > len - 3) {
                    throw new Error("invalid array, wrong 0xff at " + i);
                }
                s += String.fromCharCode(buf[i + 1] * 256 + buf[i + 2]);
                i += 2;
            }
            else {
                s += String.fromCharCode(cc);
            }
        }
        return s;
    }
    static concatUint8Array(buffer1, buffer2) {
        var tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
        tmp.set(buffer1, 0);
        tmp.set(buffer2, buffer1.byteLength);
        return tmp;
    }
    static Uint8Array2b64(arr, len) {
        var b64 = "", i;
        len = len || arr.byteLength;
        for (i = 0; i < len; i += 1) {
            b64 += String.fromCharCode(arr[i]);
        }
        return btoa(b64);
    }
    static b64ToUint8Array(b64) {
        return new Uint8Array(atob(b64).split("")
            .map(function (c) {
            return c.charCodeAt(0);
        }));
    }
    static str2ab(str) {
        let buf = new ArrayBuffer(str.length * 2); // 2 bytes for each char
        let bufView = new Uint16Array(buf);
        for (let i = 0, strLen = str.length; i < strLen; i++) {
            bufView[i] = str.charCodeAt(i);
        }
        return buf;
    }
    static async getKey(id, userIdent) {
        const userId = userIdent || sessionStorage.getItem("user_id");
        if (typeof userId === "string" && typeof id === "string") {
            const keyPath = userId + "|" + id;
            const result = await indexedDB.read("keys", keyPath);
            if (result && result.key) {
                return result.key;
            }
        }
    }
    static async setKey(id, key, userIdent) {
        const userId = userIdent || sessionStorage.getItem("user_id");
        if (!userId) {
            return Promise.reject("UserId not set for setting key!");
        }
        if (!id) {
            return Promise.reject("Id not set for setting key!");
        }
        if (typeof userId === "string" && typeof id === "string") {
            const keyPath = userId + "|" + id;
            return indexedDB.write("keys", { id: keyPath, key });
        }
    }
    static arrayBufferFromUint8Array(buf) {
        return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength);
    }
}
// testrunner accesses this var, so make it public
crypto.derivate_key_it = 100000;var RelationType;
(function (RelationType) {
    RelationType[RelationType["Relation"] = 0] = "Relation";
    RelationType[RelationType["HeadRelation"] = 1] = "HeadRelation";
})(RelationType || (RelationType = {}));// We have to make sure that only required parts are imported!
class CryptedConstraintChecker {
    constructor(stammdatenCache) {
        this.stammdatenCache = stammdatenCache;
        this.constraintList = [];
        this.transactionDatasetIdMap = new Map();
    }
    addConstraint(relationModel, identifier, fieldPath, model, relationType, relationDate) {
        this.constraintList.push({
            relationModel: relationModel,
            identifier: identifier,
            path: fieldPath,
            model: model,
            relationType: relationType,
            relationDate: relationDate,
            handled: false
        });
    }
    hasConstraints() {
        return this.constraintList.length > 0;
    }
    addTransactionDatasetId(modelname, id) {
        if (!this.transactionDatasetIdMap.has(modelname)) {
            this.transactionDatasetIdMap.set(modelname, []);
        }
        this.transactionDatasetIdMap.get(modelname).push(id);
    }
    getConstraintRequest() {
        let requestList = [], request, dManager = DatamodelManager_2.getInstance();
        for (let i = 0, len = this.constraintList.length; i < len; i++) {
            let constraintItem = this.constraintList[i], identFieldName, modelRequest;
            if (this.transactionDatasetIdMap.has(constraintItem.relationModel)) {
                if (this.transactionDatasetIdMap.get(constraintItem.relationModel).includes(constraintItem.identifier)) {
                    constraintItem.handled = true;
                    continue;
                }
            }
            if (constraintItem.relationType === RelationType.HeadRelation && this.stammdatenCache.has(constraintItem.relationModel)) {
                if (this.stammdatenCache.get(constraintItem.relationModel).includes(constraintItem.identifier)) {
                    constraintItem.handled = true;
                    continue;
                }
            }
            request = {
                class: "crud",
                method: "read"
            };
            request[constraintItem.relationModel] = request[constraintItem.relationModel] || {};
            modelRequest = request[constraintItem.relationModel];
            if (constraintItem.relationType === RelationType.Relation) {
                identFieldName = dManager.getIdentFieldName(constraintItem.relationModel);
                if (constraintItem.relationDate) {
                    // will add a date filter if relationDate is defined
                    modelRequest.options = {
                        date: constraintItem.relationDate
                    };
                }
            }
            else {
                identFieldName = "head_id"; // this is a HeadRelation
                modelRequest.options = {
                    deleted: true // it is neccessary to set this option to be able to read deleted records
                };
            }
            if (identFieldName) {
                modelRequest[identFieldName] = constraintItem.identifier;
            }
            requestList.push(request);
        }
        return requestList;
    }
    checkResultForMissingConstraints(result) {
        return new Promise((resolve, reject) => {
            let errorList = [], constraintItem, errorSuffix, dManager = DatamodelManager_2.getInstance();
            let resultCtr = 0;
            for (let i = 0, len = this.constraintList.length; i < len; i++) {
                constraintItem = this.constraintList[i];
                if (constraintItem.handled) {
                    // ID was created during current transaction
                    continue;
                }
                if (!result[resultCtr][constraintItem.relationModel]) {
                    errorList.push("constraint model missing [" + constraintItem.relationModel +
                        "] in check response for [" + constraintItem.path + "]");
                }
                else {
                    if (!Array.isArray(result[resultCtr][constraintItem.relationModel])
                        || !result[resultCtr][constraintItem.relationModel].find((element) => {
                            var _a;
                            if (constraintItem.relationType === RelationType.Relation) {
                                const identFieldName = dManager.getIdentFieldName(constraintItem.relationModel);
                                return element[identFieldName] === constraintItem.identifier;
                            }
                            else {
                                return element["head_id"] === constraintItem.identifier
                                    || !!((_a = element["head_pre_ids"]) === null || _a === void 0 ? void 0 : _a.includes(constraintItem.identifier));
                            }
                        })) {
                        if (constraintItem.relationType === RelationType.Relation && constraintItem.relationDate) {
                            errorSuffix = " for given date [" + constraintItem.relationDate + "]";
                        }
                        else {
                            errorSuffix = "";
                        }
                        errorList.push("missing constraint relation for [" + constraintItem.path + ":" + constraintItem.identifier + "]" + errorSuffix);
                    }
                }
                resultCtr++;
            }
            if (errorList.length > 0) {
                reject(errorList); // just return error list here - will be converted to error in redservice
            }
            else {
                resolve();
            }
        });
    }
}/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};const hybridCallbackPromise = function (additionalFunctionParameter = false) {
    return (target, key, descriptor) => {
        return {
            value: function (...args) {
                const callback = args[args.length - 1];
                const argsWithoutCallback = args.slice(0, args.length - 1);
                let result;
                if (typeof callback === "function" &&
                    (!additionalFunctionParameter || (typeof args[args.length - 2] === "function" || args[args.length - 2] === null))) {
                    Log.write(2 /* LogLevel.warning */, "DEPRECATED", "Use promise instead of callback:", key);
                    result = descriptor.value.apply(target, argsWithoutCallback)
                        .then((res) => {
                        callback(null, res);
                    })
                        .catch((err) => {
                        callback(err);
                    });
                }
                else {
                    result = descriptor.value.apply(target, args);
                }
                return result;
            }
        };
    };
};exports.DocumentType=void 0;
(function (DocumentType) {
    DocumentType["ArztbriefReceived"] = "arztbriefReceived";
    DocumentType["ArztbriefSent"] = "arztbriefSent";
    DocumentType["Muster12"] = "muster12";
    DocumentType["Muster13"] = "muster13";
    DocumentType["Muster19"] = "muster19";
    DocumentType["Muster1A"] = "muster1a";
    DocumentType["Muster2"] = "muster2";
    DocumentType["Muster22"] = "muster22";
    DocumentType["Muster26"] = "muster26";
    DocumentType["Muster27"] = "muster27";
    DocumentType["Muster52"] = "muster52";
    DocumentType["Muster6"] = "muster06";
    DocumentType["Muster7"] = "muster07";
    DocumentType["MusterE010"] = "musterE010";
    DocumentType["PatientenerklaerungEuKV"] = "patientenerklaerungEuKv";
    DocumentType["Personalienfeld"] = "personalienfeld";
    DocumentType["PrivatabrechnungRechnungsdruck"] = "privatabrechnung_rechnungsdruck";
    DocumentType["PTV1"] = "ptv1";
    DocumentType["PTV10"] = "ptv10";
    DocumentType["PTV11"] = "ptv11";
    DocumentType["PTV12"] = "ptv12";
    DocumentType["PTV2"] = "ptv2";
    DocumentType["PTV3"] = "ptv3";
    DocumentType["PTV8"] = "ptv8";
    DocumentType["Terminzettel"] = "terminzettel";
})(exports.DocumentType || (exports.DocumentType = {}));exports.MessageType=void 0;
(function (MessageType) {
    MessageType["Text"] = "text";
    MessageType["ContactRequest"] = "contactRequest";
    MessageType["ContactUpdate"] = "contactUpdate";
    MessageType["ReadConfirmation"] = "readConfirmation";
})(exports.MessageType || (exports.MessageType = {}));exports.ChatStatus=void 0;
(function (ChatStatus) {
    ChatStatus["RequestSent"] = "requestSent";
    ChatStatus["RequestReceived"] = "requestReceived";
    ChatStatus["Rejected"] = "rejected";
    ChatStatus["Active"] = "active"; // all chat partners confirmed, messages can be sent
})(exports.ChatStatus || (exports.ChatStatus = {}));/**
 * this class wraps a FileId of an already uploaded file
 * passing it to {@link FileUploader.addToQueue} will skip the upload process and checks for existence instead
 * So if one would pass a FileId object to some create or update command of {@link red.redServicePromised}, it would reuse the ID
 * if it already exists in the model and fieldPath
 *
 * BEWARE: You can only reuse FieldIds within the same model AND field!
 */
class FileId {
    constructor(_id) {
        this._id = _id;
    }
    static fromString(id) {
        return new FileId(id);
    }
    get id() {
        return this._id;
    }
    toString() {
        return this.id;
    }
    async existsInContext(model, path) {
        try {
            const tenantId = await getTenantId();
            const service = new FileServiceInterface(FileServiceDomain.Tenant, tenantId);
            const meta = await service.meta(this.id, { modelName: model, fieldPath: path });
            return !!meta;
        }
        catch (err) {
            return false;
        }
    }
    ;
}function checkRequest(modelname, classmethod, item, modelVersion) {
    let dManager = DatamodelManager_2.getInstance(), model = dManager.getModelByNameAndVersion(modelname, modelVersion), err, keys = Object.keys(item.obj), pk, path, value, key, field, hasFields, newHasArray, newModelName;
    if (classmethod === "crud/create" && model && !isRecordCheckOk(model, item.obj)) {
        err = "record check failed - " + modelname + "(IS: " + JSON.stringify(item.obj) + ", CHECK: " + model.check.toString() + ")";
        return {
            error: err
        };
    }
    for (pk = 0; pk < keys.length; pk += 1) {
        path = item.path;
        key = keys[pk];
        value = item.obj[key];
        field = getField(modelname, key, path, item.hasArray, modelVersion);
        if (value === undefined || value === null ||
            value === "" && !isEmptyStringAllowed(classmethod) ||
            value.constructor === Object && Object.keys(value).length === 0 && !isEmptyObjectAllowed(classmethod, path, key, field)) {
            err = "value is undefined - " + path + "." + key;
            return {
                error: err
            };
        }
        hasFields = !!(field && (field.fields || field.array && field.array.fields));
        newHasArray = !!(field && field.array && !field.relation && (field.array.type !== "object" || field.array.fields));
        if (field && classmethod !== "crud/read") {
            if (!isFieldTypeValid(field, value, classmethod)) {
                err = "wrong field type sent - "
                    + path + "."
                    + key
                    + "(IS: " + TypeChecker_2.getInstance().typeOf(value) + "/" + JSON.stringify(value)
                    + ", SHOULD: " + field.type + ")";
                return {
                    error: err
                };
            }
            if (!isFieldCheckOk(field, value, item.recordBase)) {
                err = "field check failed - " + path + "." + key + "(IS: " + value + ", CHECK: " + field.check + ")";
                return {
                    error: err
                };
            }
        }
        if (typeof value === "object"
            && (item.amArray
                || dManager.getModelByNameAndVersion(key)
                || key === "search" || key === "transaction"
                || hasFields
                || newHasArray)) {
            path += (path ? "." : "") + key;
            if (item.amArray || hasFields || newHasArray) {
                newModelName = modelname;
            }
            else {
                newModelName = key;
            }
            if (classmethod === "crud/read") {
                if (modelname && newModelName !== modelname && modelname !== "transaction") {
                    // if the outer model is transaction - it is no relation but a complex request
                    // otherwise we have a nested request
                    if (!dManager.relationExists(newModelName, modelname, true)
                        && !dManager.headRelationExists(newModelName, modelname, true)) {
                        err = "relation between [" + modelname + "] and [" + newModelName + "] does not exist for path [" + path + "]";
                        return {
                            error: err
                        };
                    }
                    if (dManager.relationIsCrypted(newModelName, modelname)) {
                        // if the crypted relation goes from nested model to parent model --> return an error
                        err = "backward relation from [" + newModelName + "] to [" + modelname + "] is currently not supported; path [" + path + "]";
                        return {
                            error: err
                        };
                    }
                }
            }
        }
        else if (key !== "options"
            && key[0] !== "$"
            && dManager.getModelByNameAndVersion(modelname)
            && !(key === "head_id" || key === "search")
            && !field) {
            err = "sent field unknown - " + modelname + " - " + path + "." + key;
            return {
                error: err
            };
        }
    }
    return {
        error: err
    };
}
function isEmptyStringAllowed(classmethod) {
    return [
        "crud/create",
        "crud/update",
        "user/update",
        "user/update_as_admin",
        "terminal/create",
        "auth/create_user",
        "user_group/create",
        "user_group/update"
    ].indexOf(classmethod) === -1;
}
function isEmptyObjectAllowed(classmethod, path, key, field) {
    const dManager = DatamodelManager_2.getInstance();
    const isClassMethodAllowed = [
        "crud/create",
        "crud/update",
        "user/update",
        "user/update_as_admin",
        "terminal/create",
        "auth/create_user",
        "user_group/create",
        "user_group/update"
    ].indexOf(classmethod) === -1;
    if (isClassMethodAllowed) {
        return true;
    }
    const isModel = !!dManager.getModelByNameAndVersion(key) ||
        key.match(/^\d+$/) && !!dManager.getModelByNameAndVersion(path.split(".").pop());
    if (isModel) {
        return true;
    }
    const autoTypes = ["autoid", "autonumber"];
    if (field && field.type === "object") {
        let nestedField;
        for (nestedField in field.fields) {
            if (field.fields.hasOwnProperty(nestedField) && autoTypes.indexOf(field.fields[nestedField].type) > -1) {
                return true;
            }
        }
    }
    return false;
}// We have to make sure that only required parts are imported!
function getField(modelname, fieldname, path, hasArray, modelVersion) {
    let dManager = DatamodelManager_2.getInstance(), model = dManager.getModelByNameAndVersion(modelname, modelVersion), path_arr, posOfSearch, li, field, modelArrayRegEx;
    path = path || modelname;
    posOfSearch = path.search("search.");
    // wenn das feld teil eines search-ergebnisses ist, dann "search" gegen den modelnamen tauschen
    if (posOfSearch > -1 && posOfSearch < 3) {
        path = path.replace(/search\./, modelname + ".");
    }
    if (!model || !modelname || !fieldname || !path) {
        return undefined;
    }
    // if fieldname is a path -> find field by query path
    if (fieldname.search(/\./) > -1) {
        return dManager.findFieldFromQueryPath(fieldname, modelname, modelVersion);
    }
    if (fieldname.substr(0, 5) === "head_"
        || fieldname === "_index"
        || fieldname === "_score"
        || fieldname === "_version_") {
        return {};
    }
    modelArrayRegEx = new RegExp(modelname + "\\.\\d+(\\.|$)", "g");
    path_arr = path.replace(modelArrayRegEx, `${modelname}$1`) // model array Index -> weg ($1 to keep the tailing dot)
        .replace(/\.\d+/g, ".array") // alle anderen Array Indizes -> array
        .replace(/\./g, ".fields.") // fields einfügen
        .replace(/\.fields\.array/g, ".array") // fields vor array entfernen
        .split(".");
    li = path_arr.lastIndexOf(modelname);
    if (li === -1) {
        path_arr = [];
    }
    else {
        path_arr = path_arr.filter(function (item, i, arr) {
            return (i > li);
        });
    }
    if (hasArray) {
        path_arr.push("array");
    }
    else {
        path_arr.push("fields");
    }
    if (!StringUtils.isStringWithNumber(fieldname)) {
        if (hasArray) {
            path_arr.push("fields");
        }
        path_arr.push(fieldname);
    }
    if (path_arr.length > 1) {
        // only check if really a field is addressed
        field = getValueFromKeyArr(model, path_arr, 0);
    }
    return field;
}
/**
 *
 * @param {Object} model
 * @param {*} record
 * @returns {Boolean}
 */
function isRecordCheckOk(model, record) {
    if (model.check) {
        return model.check_func(record);
    }
    return true;
}
/**
 *
 * @param {Object} field
 * @param {*} value
 * @param {Object} record
 * @returns {Boolean}
 */
function isFieldCheckOk(field, value, record) {
    if (field.check) {
        return field.check_func(value, record);
    }
    return true;
}
/**
 *
 * @param {Object} field
 * @param {*} value
 * @param {String} [classmethod]
 * @returns {boolean}
 */
function isFieldTypeValid(field, value, classmethod) {
    let ret = true;
    const typeChecker = TypeChecker_2.getInstance();
    if (value !== "$unset" && !field.ignore) {
        // exclude birthday fields from validation during search
        if (!(classmethod === "crud/search" && field.type === "date" && field.search && field.search.indexed === "birthday")) {
            // FileId has to get converted to string before passing it to shared TypeChecker
            // which does not know what a FileId is
            if (field.type === "file" && value instanceof FileId) {
                value = value.id;
            }
            ret = typeChecker.checkFieldType(field, value, { preventArrayDeepTest: true });
            if (field.type === "array" && (classmethod === "crud/read" || classmethod === "crud/search")) {
                ret = isFieldTypeValid(field.array, value, classmethod);
            }
        }
    }
    return ret;
}
function findMatchingDatamodel(modelName, classmethod, item) {
    let sortedModels = DatamodelManager_2.getInstance().getModelListByNameSortedByVersion(modelName), sortedDatamodelVersions, err, matchingVersion;
    if (sortedModels && (classmethod === "crud/read" || classmethod === "crud/search")) {
        // check all versions for a matching one only for crud/read and crud/search - all other requests must fit to the most recent datamodel
        sortedDatamodelVersions = sortedModels.map((modelItem) => {
            return modelItem.versions ? modelItem.versions[0] : undefined;
        });
        sortedDatamodelVersions.some((version, index) => {
            let checkResult = checkRequest(modelName, classmethod, item, version);
            if (!checkResult.error) {
                matchingVersion = version;
                return true;
            }
            // if it is the most recent version, save the error.
            // If no matching version is found, the error of comparison to the most recent version should be used.
            if (index === 0) {
                err = checkResult.error;
            }
            return false;
        });
    }
    else {
        err = checkRequest(modelName, classmethod, item).error;
    }
    return {
        error: matchingVersion ? undefined : err,
        datamodelVersion: matchingVersion
    };
}
/**
 *
 * @param {Object} obj
 * @param {Array} arr
 * @param {Number} [i]
 * @returns {*}
 */
function getValueFromKeyArr(obj, arr, i) {
    if (obj === undefined || i === arr.length) {
        return obj;
    }
    return getValueFromKeyArr(obj[arr[i]], arr, i + 1);
}const SYM_ENCRYPTED_FILTER = Symbol("Filter already encrypted");
var SimpleFilterOperations;
(function (SimpleFilterOperations) {
    SimpleFilterOperations["$NE"] = "$ne";
})(SimpleFilterOperations || (SimpleFilterOperations = {}));
const SIMPLE_FILTER_OPERATIONS = Object.keys(SimpleFilterOperations).map(key => SimpleFilterOperations[key]);
var ListFilterOperations;
(function (ListFilterOperations) {
    ListFilterOperations["$NIN"] = "$nin";
    ListFilterOperations["$IN"] = "$in";
})(ListFilterOperations || (ListFilterOperations = {}));
var TermFilterOperations;
(function (TermFilterOperations) {
    TermFilterOperations["$exists"] = "$exists";
})(TermFilterOperations || (TermFilterOperations = {}));
const TERM_FILTER_OPERATIONS = Object.keys(TermFilterOperations).map(key => TermFilterOperations[key]);
const LIST_FILTER_OPERATIONS = Object.keys(ListFilterOperations).map(key => ListFilterOperations[key]);
var NestingFilterOperations;
(function (NestingFilterOperations) {
    NestingFilterOperations["$AND"] = "$and";
    NestingFilterOperations["$OR"] = "$or";
})(NestingFilterOperations || (NestingFilterOperations = {}));
const NESTING_FILTER_OPERATIONS = Object.keys(NestingFilterOperations).map(key => NestingFilterOperations[key]);
const ALL_FILTER_OPERATIONS = [...SIMPLE_FILTER_OPERATIONS, ...LIST_FILTER_OPERATIONS, ...NESTING_FILTER_OPERATIONS, ...TERM_FILTER_OPERATIONS];
class searchClass {
    /**
     * Executes multiple Requests against SOLR (and perhaps Mongo) to get great search results.
     * @param search - The String to search for
     * @param modelName - The model to search for | "search"
     * @param options - Search parameter Object
     */
    static async search(search, modelName, options = {}, callback) {
        const global = options["global"] || false;
        let requests = [];
        requests.push(searchClass.searchClear(search, modelName, options));
        if (!global) {
            requests.push(searchClass.searchCrypto(search, modelName, options));
        }
        let clearSearch;
        let tenantCryptoSearch;
        try {
            [clearSearch, tenantCryptoSearch] = await Promise.all(requests);
        }
        catch (err) {
            // ensure error interface from single / multiple crud requests
            if (!Array.isArray(err)) {
                throw [err];
            }
            throw err;
        }
        let results = [].concat(clearSearch);
        if (tenantCryptoSearch) {
            results = results.concat(tenantCryptoSearch);
        }
        const aggregatedResult = searchClass.aggregateResult(results, "", "");
        if (clearSearch.searchErrors) {
            aggregatedResult.searchErrors = clearSearch.searchErrors;
        }
        return aggregatedResult;
    }
    static checkModelNameParameter(modelName) {
        if (modelName !== undefined && typeof modelName !== "string") {
            throw {
                error: "provided parameter [modelName] has to be a string"
            };
        }
    }
    static getEmptyResult(search, modelName, filter = []) {
        const validFilters = filter.filter(f => (!!f
            && Object.keys(f).length > 0));
        if (search.trim() === "" && validFilters.length === 0) {
            return {
                success: true,
                [modelName]: [],
                aggregations: { head_model: { buckets: [] } },
                totalCount: { search: 0 }
            };
        }
    }
    static buildSearchOptions(options = {}) {
        if (options === null || options === void 0 ? void 0 : options.date) {
            let typeChecker = TypeChecker_2.getInstance();
            if (!(typeChecker.isDateFormatValid(options.date, DateType_1.date)
                || typeChecker.isDateFormatValid(options.date, DateType_1.datetime))) {
                throw {
                    errtag: "paramterFormatError",
                    error: "format is not datetime compatible for <options.date>"
                };
            }
        }
        const { search_id, sortAbda, ik, filter, global } = options, remainingOptions = __rest(options, ["search_id", "sortAbda", "ik", "filter", "global"]);
        const abda = {
            sort: sortAbda,
            ik: ik || "",
            filter: filter || {}
        };
        const innerOptions = Object.assign(Object.assign({ aggregations: {
                head_model: {
                    terms: { field: "head_model" }
                }
            } }, remainingOptions), { filter: filter || {} });
        const requestOptions = {
            search_id: search_id
        };
        return { innerOptions, requestOptions, abda, global: global || false };
    }
    static getTenantRequest(search, innerOptions, requestOptions, crypto = false) {
        return {
            class: "crud",
            method: "search",
            search: {
                search: `${search} #_search${crypto ? "_c" : ""}`,
                options: innerOptions
            },
            options: requestOptions
        };
    }
    static getAbdaRequest(search, abda, innerOptions) {
        const sort = abda.sort || innerOptions.sort;
        return {
            class: "abda",
            method: "search",
            search: {
                search: search,
                options: {
                    sort: sort ? [].concat(sort) : undefined,
                    ik: abda.ik,
                    filter: abda.filter,
                    limit: innerOptions.limit,
                    skip: innerOptions.skip
                }
            },
            options: {
                date: innerOptions.date
            }
        };
    }
    static getBaseRequest(search, innerOptions, requestOptions, container) {
        return {
            class: "crud",
            method: "search",
            search: {
                search: search,
                options: Object.assign({ container: container }, innerOptions)
            },
            options: requestOptions
        };
    }
    static getModelRequest(search, modelName, innerOptions, requestOptions, global, crypto = false) {
        let modelRequest = {
            class: "crud",
            method: "search",
            options: Object.assign(Object.assign({}, requestOptions), { global: global && !crypto })
        };
        let modelOptions = cloneObject(innerOptions);
        modelOptions.context = modelOptions.context || [];
        modelOptions.context.push(crypto ? "_search_c" : "_search");
        delete modelOptions.container;
        modelRequest[modelName] = {
            search: search,
            options: modelOptions
        };
        return modelRequest;
    }
    static getGlobalRequest(search, innerOptions, requestOptions) {
        return {
            class: "crud",
            method: "search",
            search: {
                search: search,
                options: innerOptions
            },
            options: Object.assign(Object.assign({}, requestOptions), { global: true })
        };
    }
    static async searchClear(search, modelName = "search", options = {}) {
        var _a, _b, _c, _d, _e;
        searchClass.checkModelNameParameter(modelName);
        let prioriseAbdaResults = false;
        let { innerOptions, requestOptions, abda, global } = searchClass.buildSearchOptions(options);
        search = search.replace(/\*/g, "");
        let emptyResult = searchClass.getEmptyResult(search, modelName, [innerOptions.filter, requestOptions.filter, abda.filter]);
        if (emptyResult) {
            return emptyResult;
        }
        let command_arr;
        if (global) {
            command_arr = [searchClass.getGlobalRequest(search, innerOptions, requestOptions)];
        }
        else {
            command_arr = [
                searchClass.getBaseRequest(search, innerOptions, requestOptions, "abda" /* Container.Abda */),
                searchClass.getBaseRequest(search, innerOptions, requestOptions, "quarter" /* Container.Quarter */),
                searchClass.getBaseRequest(search, innerOptions, requestOptions, "base" /* Container.Base */),
                searchClass.getBaseRequest(search, innerOptions, requestOptions, "gba" /* Container.Gba */)
            ];
            if (abda.ik || abda.sort) {
                prioriseAbdaResults = true;
                command_arr.push(searchClass.getAbdaRequest(search, abda, innerOptions));
            }
            command_arr.push(searchClass.getTenantRequest(search, innerOptions, requestOptions));
        }
        let modelNameOrg;
        if (modelName && modelName !== "search") {
            modelNameOrg = modelName;
            command_arr.push(searchClass.getModelRequest(search, modelName, innerOptions, requestOptions, global));
        }
        let results;
        let searchResponses;
        try {
            results = await redServicePromised(command_arr);
        }
        catch (err) {
            const errarr = confirmArray(err);
            searchResponses = errarr.reduce((acc, obj) => {
                if (obj.success) {
                    acc.successful.push(obj);
                }
                else {
                    acc.failed.push(obj);
                }
                return acc;
            }, { successful: [], failed: [] });
            if (searchResponses.successful.length === 0) {
                throw err;
            }
            searchResponses.failed.forEach(error => {
                // MISSING: "ABDA" and "GBA" DB's excluded hier until Pharma will be further developed
                if (error.model !== "abda" /* Container.Abda */ && error.model !== "gba" /* Container.Gba */) {
                    console.error(error.error);
                }
            });
            results = searchResponses.successful;
        }
        // beware of array order: 0 must be container:abda search, 4 must be ABDA search(!)
        if (prioriseAbdaResults && ((_b = (_a = results[4]) === null || _a === void 0 ? void 0 : _a.PharmaArtikel) === null || _b === void 0 ? void 0 : _b.length) > 0 && ((_d = (_c = results[0]) === null || _c === void 0 ? void 0 : _c.search) === null || _d === void 0 ? void 0 : _d.length) > 0) {
            results[0].search = results[0].search.filter((result) => (result === null || result === void 0 ? void 0 : result.head_model) !== "PharmaArtikel");
        }
        const aggregatedResults = searchClass.aggregateResult(results, modelName, modelNameOrg);
        if (((_e = searchResponses === null || searchResponses === void 0 ? void 0 : searchResponses.failed) === null || _e === void 0 ? void 0 : _e.length) > 0) {
            aggregatedResults.searchErrors = searchResponses.failed;
        }
        return aggregatedResults;
    }
    static async searchCrypto(search, modelName = "search", options = {}) {
        searchClass.checkModelNameParameter(modelName);
        let { innerOptions, requestOptions } = searchClass.buildSearchOptions(options);
        innerOptions.crypto = true;
        search = search.replace(/\*/g, "");
        let emptyResult = searchClass.getEmptyResult(search, modelName, [innerOptions.filter, requestOptions.filter]);
        if (emptyResult) {
            return emptyResult;
        }
        let command_arr = [searchClass.getTenantRequest(search, innerOptions, requestOptions, true)];
        let modelNameOrg;
        if (modelName && modelName !== "search") {
            modelNameOrg = modelName;
            command_arr.push(searchClass.getModelRequest(search, modelName, innerOptions, requestOptions, false, true));
        }
        const results = await redServicePromised(command_arr);
        return searchClass.aggregateResult(results, modelName, modelNameOrg);
    }
    static mergeAggregationResults(listA, listB) {
        const fullList = [].concat(listA).concat(listB);
        const map = {};
        fullList.forEach((item) => {
            const key = item.key;
            if (map[key]) {
                map[key] += item.doc_count;
            }
            else {
                map[key] = item.doc_count;
            }
        });
        const resultList = [];
        let key;
        for (key in map) {
            if (map.hasOwnProperty(key)) {
                resultList.push({
                    key,
                    doc_count: map[key]
                });
            }
        }
        return resultList;
    }
    static aggregateResult(result, modelName, modelNameOrg) {
        var _a;
        let baseResultObject = result.shift();
        let modelResult = result.length ? result[result.length - 1] : undefined;
        if (!baseResultObject.aggregations) {
            baseResultObject.aggregations = {
                head_model: {
                    doc_count_error_upper_bound: 0,
                    sum_other_doc_count: 0,
                    buckets: []
                }
            };
            baseResultObject.isAccurate = true;
        }
        let aggregatedResults = result
            .slice(0) // copy array to preserve original list
            .reduce((finalResult, singleResult, index, arr) => {
            var _a, _b, _c, _d, _e, _f;
            if (!(singleResult === null || singleResult === void 0 ? void 0 : singleResult.success)) {
                arr.splice(index); // break execution
                return singleResult;
            }
            if (((_c = (_b = (_a = singleResult === null || singleResult === void 0 ? void 0 : singleResult.aggregations) === null || _a === void 0 ? void 0 : _a.head_model) === null || _b === void 0 ? void 0 : _b.buckets) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                finalResult.aggregations.head_model.buckets =
                    searchClass.mergeAggregationResults(finalResult.aggregations.head_model.buckets, singleResult.aggregations.head_model.buckets);
            }
            if (((_d = singleResult === null || singleResult === void 0 ? void 0 : singleResult.search) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                finalResult.search = singleResult.search.concat(finalResult.search);
            }
            if (((_e = singleResult === null || singleResult === void 0 ? void 0 : singleResult.PharmaArtikel) === null || _e === void 0 ? void 0 : _e.length) > 0) {
                finalResult.search = singleResult.PharmaArtikel.concat(finalResult.search);
            }
            finalResult.totalCount.search += (((_f = singleResult === null || singleResult === void 0 ? void 0 : singleResult.totalCount) === null || _f === void 0 ? void 0 : _f.search) || 0);
            if (singleResult.search_id) {
                finalResult.search_id = singleResult.search_id;
            }
            return finalResult;
        }, baseResultObject);
        if (!(aggregatedResults === null || aggregatedResults === void 0 ? void 0 : aggregatedResults.success)) {
            return aggregatedResults;
        }
        // only add 'search' if more than one category found
        if (aggregatedResults.aggregations.head_model.buckets.length > 1
            && !aggregatedResults.aggregations.head_model.buckets.some(bucket => bucket.key === "search")) {
            aggregatedResults.aggregations.head_model.buckets.push({
                key: "search",
                doc_count: aggregatedResults.totalCount.search || 0
            });
        }
        aggregatedResults.aggregations.head_model.buckets = aggregatedResults.aggregations.head_model.buckets.sort(function (a, b) {
            if (a.doc_count < b.doc_count) {
                return 1;
            }
            if (a.doc_count > b.doc_count) {
                return -1;
            }
            return 0;
        });
        if (!modelName || modelName === "search") {
            return aggregatedResults;
        }
        // if modelname !== search, we get a result like 'ebm'. so move result.xyz into result.search
        if (modelResult[modelName]) { // do not try to transform if already transformed
            modelResult.search = modelResult[modelName];
            delete modelResult[modelName];
        }
        modelResult.aggregations = aggregatedResults.aggregations;
        // rewrite totalCount onto aggregations.head_model and totalCount.search
        if (((_a = modelResult === null || modelResult === void 0 ? void 0 : modelResult.totalCount) === null || _a === void 0 ? void 0 : _a.search) === undefined) { // do not try to transform if already transformed
            let totalCount = typeof modelResult.totalCount === "object" ? modelResult.totalCount[modelName] : modelResult.totalCount;
            const aggItem = modelResult.aggregations.head_model.buckets.find(item => item.key === modelNameOrg);
            if (aggItem) {
                aggItem.doc_count = totalCount;
            }
            else {
                modelResult.aggregations.head_model.buckets.push({
                    key: modelNameOrg,
                    doc_count: totalCount
                });
            }
            modelResult.totalCount = {
                search: totalCount
            };
        }
        return modelResult;
    }
    /**
     * hashes a value if a field has crypto enabled
     * @param datamodel
     * @param value
     * @param path a value path, that will is rebuilt to a field path by using fieldPathEscapeRegex
     * @see fieldPathEscapeRegex
     * @private
     */
    static async hashCryptoField(datamodel, value, path) {
        const fieldPath = path
            .replace(searchClass.fieldPathEscapeRegex, "")
            .replace(/^\./, "");
        let field = getField(datamodel, fieldPath);
        if (!field) {
            throw new Error(`No field for ${path} that could be used as filter`);
        }
        while (field.type === "array") {
            field = field.array;
        }
        if (field.type === "object") {
            throw new Error(`Field for ${path} would be an object: ${JSON.stringify(field)}`);
        }
        if (field.crypto) {
            const hashSalt = sessionStorage.getItem(STORAGE_KEYS.SESSION.HASH_SALT);
            if (field.type === "date" || field.type === "datetime") {
                // enforcing the date "string"
                value = SearchData.normalize((value instanceof Date ? value.toISOString() : value.toString()).slice(0, 10));
            }
            else if (field.type !== "int" && field.type !== "float") {
                value = SearchData.normalize(value);
            }
            return crypto.hash(value, hashSalt, 16);
        }
    }
    /**
     * traverses a filter tree to find and hash filter values of crypto fields
     * @param datamodel
     * @param filters
     * @param path
     * @private
     */
    static async hashEncryptedFilterFields(datamodel, filters, path = "") {
        let result = new Map();
        if (filters[SYM_ENCRYPTED_FILTER] !== undefined) {
            return result;
        }
        for (const filterKey in filters) {
            if (!filters.hasOwnProperty(filterKey)) {
                continue;
            }
            const filterValue = filters[filterKey];
            const newPath = !path.length ? filterKey : [path, filterKey].join(".");
            if (typeof filterValue !== "object" || filterValue === null) {
                const val = await searchClass.hashCryptoField(datamodel, filterValue, newPath);
                if (val) {
                    result.set(newPath, val);
                }
            }
            else {
                if (filterValue instanceof Date) {
                    const val = await searchClass.hashCryptoField(datamodel, filterValue.toISOString(), newPath);
                    if (val) {
                        result.set(path, val);
                    }
                }
                let entries;
                if (filterValue instanceof Set) {
                    entries = Object.entries([...filterValue]);
                }
                else if (Array.isArray(filterValue)) {
                    entries = Object.entries(filterValue);
                }
                else if (filterValue instanceof Map) {
                    entries = [...filterValue.entries()];
                }
                else {
                    entries = Object.entries(filterValue);
                }
                const filterObject = Object.fromEntries(entries);
                const encrypted = await searchClass.hashEncryptedFilterFields(datamodel, filterObject, newPath);
                result = new Map([
                    ...result.entries(),
                    ...encrypted.entries()
                ]);
            }
        }
        return result;
    }
    /**
     * Applies a FilterCrypto-Map<string, string> with path-value mapping to an FilterOptions object
     * @param filters
     * @param encryptedFields
     * @see hashEncryptedFilterFields
     * @private
     */
    static applyEncryptedFieldsToObject(filters, encryptedFields) {
        var _a, _b;
        for (const [key, value] of encryptedFields) {
            const keyPath = key.split(".");
            const leafIdx = keyPath.pop();
            let node = filters;
            for (const element of keyPath) {
                let idx = element;
                if (Array.isArray(node)) {
                    idx = parseInt(element, 10);
                }
                // set parent Symbol, if not already
                node[SYM_ENCRYPTED_FILTER] = (_a = node[SYM_ENCRYPTED_FILTER]) !== null && _a !== void 0 ? _a : true;
                node = node[idx];
                // set child Symbol, if not already
                node[SYM_ENCRYPTED_FILTER] = (_b = node[SYM_ENCRYPTED_FILTER]) !== null && _b !== void 0 ? _b : true;
            }
            node[Array.isArray(node) ? parseInt(leafIdx, 10) : leafIdx] = value;
            node[SYM_ENCRYPTED_FILTER] = true;
        }
    }
    /**
     * recursively hashes all crypto fields of search filters.
     * It marks the objects it worked on with a Symbol to prevent calculating hashes of hashes and also reducing the load.
     * The function directly works on the Filter Options-Object to reduce the cost and complexity of Object-copying.
     * This means reusing the filter options elsewhere may be dangerous!
     * @see SYM_ENCRYPTED_FILTER
     * @param options
     */
    static async hashEncryptedFilterOptions(options) {
        var _a;
        let hasModelFilters = false;
        if (options[SYM_ENCRYPTED_FILTER] !== undefined) {
            return;
        }
        for (const modelName in options) {
            if (!options.hasOwnProperty(modelName)) {
                continue;
            }
            const modelExists = !!DatamodelManager_2.getInstance().getModelListByNameSortedByVersion(modelName);
            if (!modelExists) {
                throw new Error(`Model in search filter unknown: ${modelName}`);
            }
            const modelFilters = options[modelName];
            const encryptedFields = await searchClass.hashEncryptedFilterFields(modelName, modelFilters);
            searchClass.applyEncryptedFieldsToObject(modelFilters, encryptedFields);
            modelFilters[SYM_ENCRYPTED_FILTER] = (_a = modelFilters[SYM_ENCRYPTED_FILTER]) !== null && _a !== void 0 ? _a : false;
            hasModelFilters = modelFilters[SYM_ENCRYPTED_FILTER] || false;
        }
        options[SYM_ENCRYPTED_FILTER] = hasModelFilters;
    }
}
searchClass.fieldPathEscapeRegex = new RegExp(`(^|\\.)(\\d+|${ALL_FILTER_OPERATIONS.map(op => op.replace("$", "\\$")).join("|")})`, "g");
__decorate([
    hybridCallbackPromise()
], searchClass, "search", null);
const search = searchClass;class FileUploader {
    // private uploadHandle: IFileUploadHandle;
    // private progressHandle: IFileUploadProgressHandle;
    constructor(progressHandle = () => null) {
        this.progressHandle = progressHandle;
        this.uploadProcesses = [];
        this.fileIds = [];
        this.uploadErrors = [];
    }
    /**
     * Add files strings to upload queue.
     * Will generate and return a list of ids for each file.
     */
    async addToQueue(files, modelName, fieldPath) {
        const listInput = files instanceof FileList || Array.isArray(files);
        const idList = [], fileList = listInput ? files : [files];
        for (let i = 0, len = fileList.length; i < len; i++) {
            const value = fileList[i];
            let id = value instanceof FileId ? value.id : undefined;
            let uploadProcess;
            if (value instanceof FileId) {
                if (this.progressHandle) {
                    this.progressHandle({
                        id: id,
                        type: "init_upload",
                        percent: 0
                    });
                }
                console.log("is a FileId", value);
                uploadProcess = value.existsInContext(modelName, fieldPath)
                    .then(doesExist => {
                    if (!doesExist) {
                        this.uploadErrors.push(`Error for passed FileId ${value.id}: File does not seem to exist for ${modelName}: ${fieldPath}`);
                    }
                    this.progressHandle({
                        id: id,
                        type: "upload",
                        percent: 100,
                        size: 0
                    });
                });
            }
            else {
                const tenantId = await getTenantId();
                const strValue = value;
                const meta = { encoding: "base64" };
                let groups = strValue.match(/data:(.*);base64,/);
                if ((groups === null || groups === void 0 ? void 0 : groups.length) >= 2) {
                    meta.fileType = groups[1].split(";")[0];
                }
                try {
                    const result = await new FileServiceInterface(FileServiceDomain.Tenant, tenantId).uploadAsync(modelName, fieldPath, strValue, meta);
                    id = result.fileId;
                    uploadProcess = result.metaDataPromise.catch((err) => {
                        this.uploadErrors.push("Error for file with id [" + id + "]: " + (typeof err === "string" ? err : JSON.stringify(err)));
                    });
                    if (this.progressHandle) {
                        this.progressHandle({
                            id: id,
                            type: "init_upload",
                            percent: 0
                        });
                    }
                }
                catch (err) {
                    // We can do every upload process in parallel, but we will have to wait for each to finish.
                    // Therefore we catch and handle the error here and resolve each promise.
                    this.uploadErrors.push("Error for file with id [unknown]: " + (typeof err === "string" ? err : JSON.stringify(err)));
                }
            }
            this.uploadProcesses.push(uploadProcess);
            idList.push(id);
        }
        // add the current id list to the complete list of ids
        this.fileIds = this.fileIds.concat(idList);
        return listInput ? idList : idList[0];
    }
    finishUpload() {
        return Promise.all(this.uploadProcesses)
            .then(() => {
            if (this.uploadProcesses.length === 0) {
                // simply resolve if no items have been processed, otherwise
                return Promise.resolve();
            }
            // If any of the upload processes failed before, we will have an item in the list of upload errors.
            // If there is any error, we can't do a finalize. So instead reject here and do a rollback on each later on.
            if (this.uploadErrors.length > 0) {
                return Promise.reject(this.uploadErrors);
            }
            return Promise.resolve(this.fileIds);
        });
    }
}async function fileServiceGetSize(data) {
    console.warn("You are using a legacy function to get a RED file size. " +
        "Please use red.file.meta instead of calling red.fileService");
    return requestAjax("", {
        id: data.fileId,
        uri: "service/file",
        req_type: "HEAD",
        data_type: "base64",
        async: true,
        query: {
            modelName: data.modelName,
            fieldPath: data.fieldPath,
            fileId: data.fileId
        },
        header: {
            "RedMedical-Session-Id": sessionStorage.getItem(STORAGE_KEYS.SESSION.SESSION_ID),
            "RedMedical-Terminal-Id": sessionStorage.getItem(STORAGE_KEYS.SESSION.TERMINAL_ID)
        },
        requestedHeaders: ["ContentLength", "AcceptRanges"]
    });
}
async function fileService(data, options, fnProgress) {
    async function fileServiceRead(data, fnProgress) {
        const fileService = new FileServiceInterface(FileServiceDomain.Tenant, await getTenantId());
        return fileService.download(data.fileId, Object.assign(Object.assign({}, data), { fnProgress, isLegacy: true }));
    }
    async function legacyRead(data, fnProgress) {
        console.warn("You are using a legacy function to read RED file data. " +
            "Please use red.file.download instead of inline crud api (autodownload, getBinaryData, uploadUptoMb) or direct red.fileService calls");
        const header = {
            "RedMedical-Session-Id": sessionStorage.getItem(STORAGE_KEYS.SESSION.SESSION_ID),
            "RedMedical-Terminal-Id": sessionStorage.getItem(STORAGE_KEYS.SESSION.TERMINAL_ID),
            // disable cache because result will be a signed url
            "Cache-Control": "no-cache, no-store, max-age=0",
            "Expires": new Date(0).toUTCString(),
            "Pragma": "no-cache"
        };
        const urlResponse = await requestAjax("", {
            id: data.fileId,
            uri: "service/file",
            req_type: "GET",
            async: true,
            query: {
                modelName: data.modelName,
                fieldPath: data.fieldPath,
                fileId: data.fileId,
                downloadMode: "signed-url"
            },
            header
        }, null);
        try {
            new URL(urlResponse);
        }
        catch (err) {
            throw new Error("file download url invalid; " + urlResponse + " is not a valid URL");
        }
        /*
        Possible combinations:

        confidential: -> decrypt and return binary data
        !confidential:
            + !getBinaryData: -> auto download possible (directly) or return url
            + getBinaryData: -> auto download possible (via blob) or return binary data
         */
        let result;
        if (data.getBinaryData || isConfidential(data.modelName)) {
            result = await requestAjax("", {
                id: data.fileId,
                url: urlResponse,
                req_type: "GET",
                responseType: "base64",
                async: true,
                query: {}
            }, fnProgress);
        }
        if (!isConfidential(data.modelName)) {
            if (data.getBinaryData) {
                result = new Blob([result], { type: "application/octet-stream" });
                if (data.autoDownload) {
                    const URL = window.URL || window.webkitURL;
                    const downloadUrl = URL.createObjectURL(result);
                    window.open(downloadUrl, "_blank");
                }
            }
            else {
                if (data.autoDownload) {
                    // s3 URL - open directly
                    window.open(urlResponse, "_blank");
                }
                result = urlResponse;
            }
        }
        else {
            const key = await crypto.getKey("key_tenant_s");
            const decrypted = await crypto.decrypt(result, key, "base64");
            result = atob(decrypted);
        }
        return {
            success: true,
            fileId: data.fileId,
            data: result
        };
    }
    async function fileServicePresignedUpload(file, fileId, data_type, header, fnProgress) {
        const startResult = (await requestAjax(JSON.stringify({
            fileId,
            modelName: data.modelName,
            fieldPath: data.fieldPath,
            content_type: header["content-type"]
        }), {
            id: fileId,
            uri: "service/file/multipart",
            req_type: "POST",
            data_type,
            async: true,
            query: {},
            header
        }));
        if (!startResult || !startResult.success) {
            return Promise.reject("cannot start upload");
        }
        if (!startResult.signedUrl || !startResult.signedUrl.fields || !startResult.signedUrl.url) {
            return Promise.reject("cannot get signed url");
        }
        fileId = startResult.fileId;
        try {
            await new Promise((resolve, reject) => {
                let data = new Blob([file], { type: header["content-type"] || "text/plain" });
                const formData = new FormData();
                Object.keys(startResult.signedUrl.fields).forEach(key => {
                    formData.append(key, startResult.signedUrl.fields[key]);
                });
                formData.append("file", data, fileId);
                const ajax = new XMLHttpRequest();
                ajax.upload.onprogress = function (e) {
                    let percent;
                    if (fnProgress && e.lengthComputable) {
                        percent = e.loaded * 100 / e.total;
                        fnProgress({
                            id: fileId,
                            type: "upload",
                            size: e.total,
                            percent: percent
                        });
                    }
                };
                ajax.open("POST", startResult.signedUrl.url, true);
                ajax.onload = () => {
                    if (ajax.status === 204) {
                        resolve();
                    }
                    else {
                        reject(ajax.responseText);
                    }
                };
                ajax.onerror = (error) => {
                    reject(error);
                };
                ajax.onabort = () => {
                    reject(new Error("Upload canceled by user"));
                };
                ajax.send(formData);
            });
        }
        catch (err) {
            return Promise.reject("cannot upload file\n" + err);
        }
        return {
            success: true,
            filePath: startResult.filePath,
            fileId: startResult.fileId
        };
    }
    async function fileServiceCreate(data, fnProgress) {
        console.warn("You are using a legacy function to write RED file data. " +
            "Please use red.file.upload instead of inline crud api or direct red.fileService calls");
        let header = {
            "RedMedical-Session-Id": sessionStorage.getItem(STORAGE_KEYS.SESSION.SESSION_ID),
            "RedMedical-Terminal-Id": sessionStorage.getItem(STORAGE_KEYS.SESSION.TERMINAL_ID)
        };
        let data_type = "base64";
        let file = data.data;
        let fileId = data.fileId;
        if (isConfidential(data.modelName) && typeof data.data === "string") {
            // base64
            if (data.data.search(/^data:/) !== 0 || data.data.search(/;base64,/) <= 0) {
                return Promise.reject("missing base64 file header");
            }
            // find data type
            let groups = data.data.match(/data:(.*);base64,/);
            if ((groups === null || groups === void 0 ? void 0 : groups.length) >= 2) {
                header["content-type"] = groups[1];
            }
            file = btoa(data.data);
            const key = await crypto.getKey("key_tenant_s");
            file = await crypto.encrypt(file, key, "base64");
        }
        else {
            return Promise.reject("Unsupported interface given. Base data should be binary, all other data should be base64");
        }
        if (!fileId) {
            return Promise.reject("missing parameter: fileId");
        }
        return fileServicePresignedUpload(file, fileId, data_type, header, fnProgress);
    }
    if (typeof data !== "object") {
        throw new Error("fileService(): input should be an object");
    }
    switch (data.method) {
        case "create":
            return fileServiceCreate(data, fnProgress);
        case "read":
            return fileServiceRead(data, fnProgress);
        case "legacyRead":
            return legacyRead(data, fnProgress);
        case "getSize":
            return fileServiceGetSize(data);
        default:
            return Promise.reject("ERROR: unknown method");
    }
}async function fetchFile(data, downloadUpToMb, getBinaryData = false, autoDownload = false) {
    const tenantId = await getTenantId();
    const fileServiceInterface = new FileServiceInterface(FileServiceDomain.Tenant, tenantId);
    const meta = await fileServiceInterface.meta(data.fileId, Object.assign({}, data));
    const megabyte = meta.size / 1e6;
    if (megabyte > downloadUpToMb) {
        throw { errtag: "error_filesize_too_large", errspec: "filesize too large: " + megabyte };
    }
    if (meta.legacy) {
        const result = await fileService(Object.assign(Object.assign({}, data), { getBinaryData, autoDownload, method: "read" }));
        return result.data;
    }
    else {
        const fileResult = await fileServiceInterface.download(data.fileId, Object.assign({}, data));
        if (autoDownload) {
            const URL = window.URL || window.webkitURL;
            const downloadUrl = URL.createObjectURL(fileResult);
            window.open(downloadUrl, "_blank");
        }
        return fileResult.data;
    }
}var SocketMessageSubtypes;
(function (SocketMessageSubtypes) {
    /**
     * @deprecated Message is not used anymore by any client.
     */
    SocketMessageSubtypes["Message"] = "message";
    /**
     * @deprecated RED Connect is not used anymore by any client.
     */
    SocketMessageSubtypes["Chat"] = "chat";
})(SocketMessageSubtypes || (SocketMessageSubtypes = {}));
/**
 * this enum includes all internal events
 */
var ApiMessageTypes;
(function (ApiMessageTypes) {
    ApiMessageTypes["UserInteraction"] = "userInteraction";
    ApiMessageTypes["Error"] = "error";
    ApiMessageTypes["Close"] = "close";
    ApiMessageTypes["ConnectionError"] = "connection-error";
    ApiMessageTypes["ConnectionLost"] = "connection-lost";
})(ApiMessageTypes || (ApiMessageTypes = {}));/*
Background on the following lines and the
event instanceof InternalMessageEvent as _InternalMessageEvent
thing happening in prepareEventForPublish()

We want some kind of internal events to to pass them around as-is in the browser.
But how to recognize such events? Best thing to do: extend a class and use instanceOf
The typescript definition of MessageEvent is the worst evil and TypeScript its best friend!
MessageEvent is declared as an interface and a var exporting new().
This is NOT extendable in TypeScript and it does not allow any clean way to achieve this.
 */
// @ts-ignore
class _InternalMessageEvent extends MessageEvent {
} // TypeScript at its worst!
const InternalMessageEvent = _InternalMessageEvent;
function isInternalMessageEvent(evt) {
    return evt instanceof InternalMessageEvent;
}
function isMessageEvent(evt) {
    // a really dirty workaround for JSDOM and eventsource package, but luckily this typeguard is not really important (see usage below)
    return evt instanceof MessageEvent || evt.constructor.name.endsWith("MessageEvent");
}
async function prepareEventForPublish(event /* <= intended any to allow InternalMessageEvents */, skipDecryptRedObject = false) {
    var _a;
    if (isInternalMessageEvent(event)) {
        return event;
    }
    if (!isMessageEvent(event)) {
        // this is just there to keep Typescript happy
        console.error("eventDispatcher: unsupported Event ancestor", event);
        return event;
    }
    let message = event.data;
    if (typeof event.data === "string") {
        message = JSON.parse(event.data);
    }
    let isCrypto = false;
    if (typeof message === "object") {
        (_a = message, { crypto: isCrypto } = _a, message = __rest(_a, ["crypto"]));
        if (isCrypto) {
            message.data = await crypto.decrypt(message.data);
        }
        // messages with id are handled by server, now. Client can listen to events via addEventListener(messageId, ...)
        // internal - and another few - events do not need to decrypt events
        if (skipDecryptRedObject) {
            return new MessageEvent(event.type, {
                data: message,
                lastEventId: event.lastEventId,
                bubbles: event.bubbles,
                composed: event.composed,
                origin: event.origin,
                source: event.source,
                ports: event.ports, // lhs is "mutable", rhs is readonly
                cancelable: event.cancelable
            });
        }
        else {
            const msg = message.data ? message.data : message;
            await decryptRedObject(msg, Array.isArray(msg), {}, null)
                .catch((err) => {
                /* ignore decrypt error for socket messages */
                console.warn("cannot decrypt message", err);
            });
            return new MessageEvent(event.type, {
                data: message,
                lastEventId: event.lastEventId,
                bubbles: event.bubbles,
                composed: event.composed,
                origin: event.origin,
                source: event.source,
                ports: event.ports, // lhs is "mutable", rhs is readonly
                cancelable: event.cancelable
            });
        }
    }
    else {
        // in case someone would ever want to publish non-object messages
        return new MessageEvent(event.type, {
            data: message,
            lastEventId: event.lastEventId,
            bubbles: event.bubbles,
            composed: event.composed,
            origin: event.origin,
            source: event.source,
            ports: event.ports, // lhs is "mutable", rhs is readonly
            cancelable: event.cancelable
        });
    }
}
function isEventListenerObject(o) {
    return "handleEvent" in o && typeof o.handleEvent === "function";
}
class EventDispatcher extends EventTarget {
    /**
     * used by tests
     * returns eventListener count for events that are added on every connection
     */
    static get staticEventListenerCount() {
        return this._staticListeners.length;
    }
    /**
     * used by tests
     * returns eventListener count for events that are added on next connection
     */
    get preparedEventListenerCount() {
        return this._eventListeners.length;
    }
    static addStaticEventListener(params) {
        this._staticListeners.push(params);
    }
    constructor() {
        super();
        /**
         * prepared eventListeners before connect is successful
         * @private
         */
        this._eventListeners = [];
        this._currentEventListeners = [];
        this._abortController = new AbortController();
        /**
         * maps original callbacks with overridden ones.
         * due to crypto operations, it is necessary to override callbacks.
         * But as a client we want the imagination of my function being the real event handler
         * @private
         */
        this._funcMap = new WeakMap();
        this._eventListeners = [...EventDispatcher._staticListeners];
    }
    get isConnected() {
        return !!this._eventSource && this._eventSource.readyState !== EventSource.CLOSED;
    }
    createAbortController() {
        const controller = new AbortController();
        controller.signal[EventDispatcher.ABORT_SIGNAL_MARKER] = true;
        this._abortController = controller;
        return controller;
    }
    /**
     * connects to a eventstream with given sessionId
     * if one already existed, the old one es closed and a new one is opened.
     * @param sessionId
     * @param retries
     */
    async connect(sessionId, retries = 3) {
        if (this._connectPromise) {
            return this._connectPromise;
        }
        if (this.isConnected) {
            console.log(`closing eventsource of ${this._currentSessionId} in favor of ${sessionId}`);
            this.close();
        }
        this._abortController = this._abortController.signal.aborted ? this.createAbortController() : this._abortController;
        let appVersion = await indexedDB.read(exports.ObjectStoreNames.RED_APP_VERSION, "appVersion");
        const url = new URL("/service/eventstream", exports.protocol + "//" + exports.host + (exports.port === "" ? "" : ":" + exports.port) + "/");
        url.searchParams.set("session_id", sessionId);
        url.searchParams.set("red_version", appVersion.version);
        this._eventSource = new EventSource(url);
        /**
         * true when initial connection attempt failed
         * if attemptFailed is true but Promise resolves, it means a reconnect attempt was successful and therefore promise chain needs to take a shortcut
         */
        let attemptFailed = false;
        const promise = new Promise((resolve, reject) => {
            let errorCount = 0;
            const connectAbortController = new AbortController();
            const onOpen = () => {
                if (!connectAbortController.signal.aborted) {
                    connectAbortController.abort("event source opened");
                    // remove initial error listener - in case it is triggered afterwards
                    this._eventSource.removeEventListener("error", onError);
                    resolve();
                }
            };
            const onError = (error) => {
                if (!connectAbortController.signal.aborted) {
                    console.warn("EventSource connect failed", errorCount, retries, error);
                    if (this._eventSource.readyState === EventSource.CLOSED && retries > 0) {
                        this._connectPromise = undefined;
                        connectAbortController.abort("eventsource closed during due to connect error");
                        attemptFailed = true;
                        this.dispatchEvent(new MessageEvent("connection-error", { data: error }));
                        setTimeout(() => {
                            this.connect(sessionId, retries - 1)
                                .then(() => resolve())
                                .catch((err) => reject(err));
                        }, 1000);
                    }
                    else if (errorCount++ >= retries) {
                        // remove initial open listener
                        connectAbortController.abort("event source errored");
                        reject(error);
                    }
                }
            };
            this._eventSource.addEventListener("open", onOpen, { once: true, signal: connectAbortController.signal });
            this._eventSource.addEventListener("error", onError, { signal: connectAbortController.signal });
        });
        this._connectPromise = promise
            .then(() => {
            if (attemptFailed) { // reconnect already prepared everything below
                return;
            }
            this._currentSessionId = sessionId;
            this._eventSource.onopen = () => { console.debug("opened eventsource", sessionId); };
            this._eventSource.onerror = async (...args) => {
                const isClosed = this._eventSource.readyState === EventSource.CLOSED;
                console.warn("errored eventsource", sessionId, args, isClosed ? "closed" : "reconnecting");
                if (isClosed) {
                    this._connectPromise = undefined;
                    // this is necessary so that currently active listeners get added to EventSource again, when connection succeeds
                    this._eventListeners = this._currentEventListeners;
                    this.dispatchEvent(new MessageEvent("connection-lost", { data: args }));
                    try {
                        // this will retry connection 3 times
                        await this.connect(sessionId);
                    }
                    catch (err) {
                        // we send all three events at the same time to distinguish actions based on what is supposed to happen on frontend side:
                        // error: handle or just show an error
                        // logout: trigger logout redirect or anything else that is related to logout
                        // close: not that much about frontend, but this definitely closes the EventDispatcher
                        for (const event of [ApiMessageTypes.Error, "logout" /* SocketMessageTypes.Logout */, ApiMessageTypes.Close]) {
                            this.dispatchEvent(new InternalMessageEvent(event, {
                                data: {
                                    message: "reconnect after error failed",
                                    reason: err
                                }
                            }));
                        }
                    }
                }
            };
            this._eventSource.onmessage = (e) => { console.debug("received an untyped message", sessionId, e); };
        })
            .then(() => {
            if (attemptFailed) { // reconnect already prepared everything below
                return;
            }
            for (const [type, listener, options] of this._eventListeners) {
                const opts = EventDispatcher.containsExternalSignal()
                    ? options
                    : Object.assign(Object.assign({}, (typeof options === "boolean"
                        ? { capture: !!options, signal: this._abortController.signal }
                        : options)), { signal: this._abortController.signal });
                this._eventSource.addEventListener(type, listener, opts);
                // adding this enables us to successfully dispatch local events like cud, logout or userInteraction
                super.addEventListener(type, listener, opts);
            }
            this._currentEventListeners = this._eventListeners;
            this._eventListeners = [...EventDispatcher._staticListeners];
        })
            .finally(() => {
            this._connectPromise = undefined;
        });
        return this._connectPromise;
    }
    close() {
        var _a;
        this._abortController.abort("closed eventsource");
        return (_a = this._eventSource) === null || _a === void 0 ? void 0 : _a.close();
    }
    clear() {
        if (this.isConnected) {
            this.close();
        }
        this._eventListeners = [...EventDispatcher._staticListeners];
        this._eventSource = undefined;
    }
    static containsExternalSignal(options) {
        if (typeof options === "boolean" || !options) {
            return false;
        }
        return !!options.signal && !options.signal[EventDispatcher.ABORT_SIGNAL_MARKER];
    }
    addEventListener(type, listener, options) {
        const _a = typeof options === "object" && "skipDecryptRedObject" in options
            ? options
            : { capture: !!options }, { skipDecryptRedObject = false } = _a, origEventSourceOptions = __rest(_a, ["skipDecryptRedObject"]);
        const sessionId = this._currentSessionId;
        const eventSourceOptions = EventDispatcher.containsExternalSignal(options)
            ? origEventSourceOptions
            : Object.assign(Object.assign({}, origEventSourceOptions), { signal: this._abortController.signal });
        if (isEventListenerObject(listener)) {
            let origHandleEvent = listener.handleEvent.bind(listener);
            listener.handleEvent = function (evt) {
                prepareEventForPublish(evt, skipDecryptRedObject)
                    .then((evt) => {
                    evt[EventDispatcher.SOURCE_SESSION] = sessionId;
                    return origHandleEvent(evt);
                })
                    .catch(err => {
                    console.warn("error, error", err);
                    throw err;
                });
            };
        }
        else {
            const origCallback = listener;
            listener = function (evt) {
                prepareEventForPublish(evt, skipDecryptRedObject)
                    .then((evt) => {
                    evt[EventDispatcher.SOURCE_SESSION] = sessionId;
                    return origCallback(evt);
                })
                    .catch(err => {
                    console.warn("error, error", err);
                    throw err;
                });
            };
            if (this._funcMap.has(origCallback)) {
                this._funcMap.get(origCallback).push([type, listener]);
            }
            else {
                this._funcMap.set(origCallback, [[type, listener]]);
            }
        }
        if (this._eventSource) {
            this._currentEventListeners.push([type, listener, eventSourceOptions]);
            this._eventSource.addEventListener(type, listener, eventSourceOptions);
            super.addEventListener(type, listener, eventSourceOptions);
        }
        else {
            this._eventListeners.push([type, listener, eventSourceOptions]);
        }
    }
    removeEventListener(type, listener, options) {
        let listeners = [listener];
        if (listener && typeof listener === "function" && this._funcMap.has(listener)) {
            listeners = this._funcMap.get(listener).filter(([t]) => t === type).map(([, f]) => f);
        }
        if (this._eventSource) {
            for (const callback of listeners) {
                this._eventSource.removeEventListener(type, callback, options);
            }
        }
        else {
            for (const callback of listeners) {
                const idx = this._eventListeners.findIndex(([pType, pCallback, pOptions]) => {
                    return type === pType && callback === pCallback && options === pOptions;
                });
                if (idx >= 0) {
                    this._eventListeners.splice(idx, 1);
                }
            }
        }
        super.removeEventListener(type, listener, options);
    }
}
EventDispatcher.SOURCE_SESSION = Symbol("source session where eventstream sessionid where an event was triggered from");
EventDispatcher.ABORT_SIGNAL_MARKER = Symbol("marker for EventDispatcher signals");
/**
 * static (internal) eventListeners prepared for every instance created
 * @private
 */
EventDispatcher._staticListeners = [];
/**
 * @deprecated only used in integration tests. DO NOT USE in production!
 */
function initEventDispatcher() {
    exports.eventDispatcher = new EventDispatcher();
}
// we only use let here to enable integration tests to have multiple eventDispatchers.
// Normally this should be _const_, but it would require a huge refactoring, again.
exports.eventDispatcher = new EventDispatcher();
function addStaticEventListener(...params) {
    EventDispatcher.addStaticEventListener(params);
    exports.eventDispatcher.addEventListener(...params);
}
addStaticEventListener(ApiMessageTypes.Close, evt => {
    exports.eventDispatcher.close();
}, { skipDecryptRedObject: true });// We have to make sure that only required parts are imported!
const UNI_OPERATORS = ["$eq", "$ne"];
const NOT_ENCRYPT_OPERATORS = ["$exists"];
const ARRAY_OPERATORS = ["$in", "$nin"];
const ALL_OPERATORS = UNI_OPERATORS.concat(...NOT_ENCRYPT_OPERATORS, ...ARRAY_OPERATORS);
let inRequest = 0;
const MAX_CONCURRENT_REQUESTS = 100;
const queueList = [];
const MAX_RETRIES = 10;
const stammdatenCache = new Map();
function arrayContains(arr, obj) {
    if (arr === undefined || !Array.isArray(arr)) {
        return false;
    }
    if (arr.indexOf(obj) === -1) {
        return false;
    }
    return true;
}
function stringify(x) {
    if (typeof x === "string") {
        return x;
    }
    return JSON.stringify(x);
}
exports.terminalIdentifier = null;
/**
 * only for test purpose!
 * @param newIdentifier
 */
function setTerminalIdentifier(newIdentifier) {
    exports.terminalIdentifier = newIdentifier;
}
function initializeSession(getTerminalIdentifierHandler) {
    getTerminalIdentifierHandler((err, result) => {
        if (err) {
            Log.write(2 /* LogLevel.warning */, "Initialization for redService failed.");
        }
        else {
            exports.terminalIdentifier = result;
        }
    });
}
exports.host = location.hostname;
exports.port = location.port;
exports.protocol = location.protocol;
/**
 *
 * @param _host
 * @param _port
 * @param _protocol
 */
function setHostCredentials(_host, _port, _protocol) {
    exports.host = _host;
    exports.port = _port;
    exports.protocol = _protocol;
}
async function getTenantId() {
    var _a;
    let tenantId = sessionStorage.getItem(STORAGE_KEYS.SESSION.TENANT_ID);
    if (!tenantId) {
        const result = await redServicePromised({
            "class": "sessions",
            "method": "getSessionInformation"
        });
        tenantId = (_a = result.Tenant[0]) === null || _a === void 0 ? void 0 : _a.id.toString();
        sessionStorage.setItem(STORAGE_KEYS.SESSION.TENANT_ID, tenantId);
    }
    return tenantId;
}
async function getSession() {
    var session = {
        session_id: sessionStorage.getItem(STORAGE_KEYS.SESSION.SESSION_ID),
        terminal_id: sessionStorage.getItem(STORAGE_KEYS.SESSION.TERMINAL_ID),
        deviceId: localStorage.getItem(STORAGE_KEYS.LOCAL.DEVICE_ID)
    }, terminal_id_connector;
    if (session.deviceId) {
        if (exports.terminalIdentifier) {
            terminal_id_connector = await crypto.hash(exports.terminalIdentifier, "", 32);
            if (terminal_id_connector !== session.deviceId) {
                session.terminal_id_connector = terminal_id_connector;
            }
        }
    }
    else {
        if (exports.terminalIdentifier) {
            session.deviceId = await crypto.hash(exports.terminalIdentifier, "", 32);
        }
    }
    return session;
}
/**
 * @method mergeObjects
 * @param dest
 * @param source
 * @returns {*}
 */
function mergeObjects(dest, source) {
    var key;
    for (key in source) {
        if (source.hasOwnProperty(key)) {
            dest[key] = source[key];
        }
    }
    return dest;
}
/**
 * @method cloneObject
 * @param obj
 * @returns {*}
 */
function cloneObject(obj) {
    if (obj === undefined) {
        throw new Error("cloneObject(): input should be an object");
    }
    return JSON.parse(JSON.stringify(obj));
}
/**
 * @method loadDatamodel
 */
function loadDatamodel() {
    Log.write(1 /* LogLevel.info */, "loading datamodel");
    return redServicePromised({ "class": "datamodel", "method": "get" }, { compress: false, decrypt: false })
        .then(function (data) {
        delete data.time;
        DatamodelManager_2.getInstance().setDatamodel(data);
        return data;
    });
}
function setDatamodel(data) {
    DatamodelManager_2.getInstance().setDatamodel(typeof data === "string" ? JSON.parse(data) : data);
}
function getDatamodel(callback) {
    if (callback) {
        callback(null, DatamodelManager_2.getInstance().getDatamodel());
    }
    else {
        return DatamodelManager_2.getInstance().getDatamodel();
    }
}
/**
 *
 * @param dataUncompressed
 * @param options
 * @param fnProgress
 */
function requestAjax(dataUncompressed, options, fnProgress) {
    function getResponseHeader(ajax, name) {
        return ajax.getResponseHeader(name);
    }
    function object2Query(obj) {
        var str = [], p;
        for (p in obj) {
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        }
        return str.join("&");
    }
    function _requestAjax(dataUncompressed, options, fnProgress) {
        return new Promise(async (resolve, reject) => {
            var data, ajax; await crypto.getKey("key_tenant_s"); var chunk_no, size = 0, file_len, text_len, chunk_len, chunk_frequence, percent, ajaxTimeout, query, url;
            data = dataUncompressed;
            if (data) {
                size = data.length;
            }
            // build url
            query = object2Query(options.query);
            if (query !== "") {
                query = "?" + query;
            }
            url = options.url || exports.protocol + "//" + exports.host + (exports.port === "" ? "" : ":" + exports.port) + "/" + options.uri + query;
            // build request
            ajax = new XMLHttpRequest();
            ajax.onerror = function (e) {
                // console.log(e); //e: XMLHttpRequestProgressEvent
                reject("ajax error at: " + url + " (async:" + options.async + " E:" + JSON.stringify(e) + ")");
            };
            ajax.open(options.req_type, url, options.async);
            // Send the proper header information along with the request
            ajax.setRequestHeader("content-type", "application/x-www-form-urlencoded");
            if (options.data_type) {
                ajax.setRequestHeader("data-type", options.data_type);
            }
            if (options.responseType) {
                ajax.responseType = options.responseType;
            }
            if (options.uri === "service/file" && options.req_type === "GET") {
                ajax.overrideMimeType("text/plain");
            }
            options.header = options.header || {};
            for (let name in options.header) {
                if (options.header.hasOwnProperty(name)) {
                    ajax.setRequestHeader(name, options.header[name]);
                }
            }
            if (options.async) {
                ajax.onreadystatechange = async function () {
                    var _a;
                    if (ajaxTimeout) {
                        clearTimeout(ajaxTimeout);
                        ajaxTimeout = null;
                    }
                    if (ajax.mock) {
                        resolve(ajax.mock);
                    }
                    switch (ajax.readyState) {
                        case 2:
                            chunk_no = 0;
                            break;
                        case 3:
                            chunk_no += 1;
                            if (!chunk_frequence && chunk_len) {
                                chunk_frequence = Math.ceil(32768 / (ajax.responseText.length - chunk_len));
                            }
                            if (!chunk_len && ajax.responseType !== "blob") {
                                chunk_len = ajax.responseText.length;
                            }
                            if (fnProgress && chunk_no % (chunk_frequence * 10) === 0) {
                                file_len = file_len || getResponseHeader(ajax, "file-len");
                                text_len = text_len || ((_a = ajax.response) === null || _a === void 0 ? void 0 : _a.length) || ajax.responseText.length;
                                percent = text_len * 100 / file_len;
                                fnProgress({
                                    id: options.id,
                                    type: "download",
                                    percent: percent
                                });
                            }
                            break;
                        case 4:
                            switch (ajax.status) {
                                case 0:
                                    if (ajaxTimeout) {
                                        clearTimeout(ajaxTimeout);
                                        reject("timeout");
                                        return;
                                    }
                                    reject({ success: false, requestedUrl: url, ajaxStatus: 0 });
                                    break;
                                case 200:
                                case 304:
                                    if (fnProgress) {
                                        fnProgress({
                                            id: options.id,
                                            type: "download",
                                            percent: 100,
                                            size: size
                                        });
                                    }
                                    if (options.req_type === "HEAD") {
                                        let headerResponse = {};
                                        options.requestedHeaders.forEach((headerName) => {
                                            headerResponse[headerName] = getResponseHeader(ajax, headerName);
                                        });
                                        return resolve(headerResponse);
                                    }
                                    switch (getResponseHeader(ajax, "Content-Type")) {
                                        case "application/json":
                                            resolve(JSON.parse(ajax.responseText));
                                            break;
                                        default:
                                            {
                                                // IE uses responseText instead of response
                                                resolve(ajax.response || ajax.responseText);
                                            }
                                    }
                                    break;
                                // status codes that may cause a retry
                                case 502:
                                    Log.write(3 /* LogLevel.error */, "received 502 error while loading");
                                    const maxRetries = typeof options.maxRetries === "number" ? options.maxRetries : MAX_RETRIES;
                                    const retryCount = typeof options.retryCount === "number" ? options.retryCount : 0;
                                    if (retryCount >= maxRetries) {
                                        reject({
                                            response: (ajax.response || ajax.responseText),
                                            status: ajax.status,
                                            retries: retryCount
                                        });
                                    }
                                    else {
                                        Log.write(2 /* LogLevel.warning */, "retrying request");
                                        const retryPause = typeof options.retryPause === "number" ? options.retryPause : 500;
                                        const newOptions = Object.assign(Object.assign({}, options), { retryCount: retryCount + 1 });
                                        setTimeout(() => {
                                            requestAjax(dataUncompressed, newOptions, fnProgress)
                                                .then(resolve)
                                                .catch(reject);
                                        }, retryPause);
                                    }
                                    break;
                                default:
                                    switch (getResponseHeader(ajax, "Content-Type")) {
                                        case "application/json":
                                            // this case can happen on a status code 404
                                            // the server returns an error object with content type application/json
                                            // if a file was requested, the xhr api returns a blob (because of the property 'responseType' on the request),
                                            // no regard of the content
                                            let response = ajax.responseType === "blob" ? ajax.response : JSON.parse(ajax.response);
                                            reject({ response: response, status: ajax.status });
                                            break;
                                        default:
                                            reject({
                                                response: (ajax.response || ajax.responseText),
                                                status: ajax.status
                                            });
                                    }
                            }
                            break;
                    }
                };
                if (ajax.upload) {
                    ajax.upload.onprogress = function (e) {
                        var percent;
                        clearTimeout(ajaxTimeout);
                        if (fnProgress && e.lengthComputable) {
                            percent = e.loaded * 100 / e.total;
                            if (e.loaded === e.total) {
                                ajax.upload.completed = true;
                            }
                            fnProgress({
                                id: options.id,
                                type: "upload",
                                size: size,
                                percent: percent
                            });
                        }
                    };
                    ajax.upload.onloadstart = function () {
                        if (fnProgress) {
                            fnProgress({
                                id: options.id,
                                type: "upload",
                                size: size,
                                percent: 0
                            });
                        }
                    };
                    ajax.upload.onloadend = function () {
                        if (fnProgress && !ajax.upload.completed) {
                            fnProgress({
                                id: options.id,
                                type: "upload",
                                size: size,
                                percent: 100
                            });
                        }
                    };
                }
            }
            // Send AJAX request
            ajax.send(data);
            if (fnProgress) {
                fnProgress({
                    id: options.id,
                    type: "ajax_send"
                });
            }
            if (options.timeout) {
                ajaxTimeout = setTimeout(function () {
                    ajax.abort();
                }, options.timeout);
            }
            if (!options.async) {
                if (options.data_type === "script") {
                    eval.apply(window, [ajax.response || ajax.responseText]);
                }
                resolve(ajax.response || ajax.responseText); // IE uses responseText instead of response
            }
        });
    }
    function workQueue() {
        if (queueList.length > 0) {
            const [dataUncompressed, options, fnProgress, resolve, reject] = queueList.shift();
            inRequest++;
            _requestAjax(dataUncompressed, options, fnProgress).then(resolve).catch(reject).finally(() => {
                inRequest--;
                setTimeout(workQueue, 500);
            });
        }
    }
    if (inRequest < MAX_CONCURRENT_REQUESTS) {
        inRequest++;
        return _requestAjax(dataUncompressed, options, fnProgress).finally(() => {
            inRequest--;
            setTimeout(workQueue, 500);
        });
    }
    else {
        return new Promise((resolve, reject) => {
            queueList.push([dataUncompressed, options, fnProgress, resolve, reject]);
        });
    }
}
function requestQueueSize() {
    return queueList.length;
}
function getValueOnDataPath(data, path) {
    let splittedPath = path.split("."), subData = data, i, len;
    for (i = 0, len = splittedPath.length; i < len; i++) {
        if (typeof subData === "object") {
            subData = subData[splittedPath[i]];
        }
        else {
            subData = undefined;
        }
    }
    return subData;
}
function removeEntryByKey(obj, path, key) {
    const pathArr = path.split(".");
    let current = obj;
    for (let i = 0; i < pathArr.length; i++) {
        if (current[pathArr[i]]) {
            current = current[pathArr[i]];
        }
    }
    delete current[key];
}
async function encryptRedObject(classmethod, objInput, amArray, options, cryptedNestResolver, fnProgress) {
    const baseDataCacheRequest = { misses: [] };
    let obj;
    if (Array.isArray(objInput)) {
        obj = JSON.parse(JSON.stringify(objInput));
    }
    else {
        obj = Object.assign({}, objInput);
    }
    let encryptedData = obj;
    var keys, key, err, value, normalizeOptions, headSearch, searchFieldPath, searchFieldIsArray, clearHeadSearchValuesAndExtensions, field, i, pk, tokens, container = "", token, new_modelname, key_user_s = await crypto.getKey("key_user_s"), recordBase = obj, recordBaseCleanCopy = JSON.parse(JSON.stringify(recordBase)), item = {
        classmethod: classmethod,
        methodOptions: classmethod ? obj.options : undefined,
        model: "",
        obj: obj,
        amArray: amArray,
        path: "",
        hasArray: false,
        recordBase: recordBase,
        recordBaseCleanCopy: recordBaseCleanCopy,
        recordBasePath: "",
        pathToRecordBase: "",
        searchFieldIsArray: false,
        modelPath: ""
    };
    let dManager = DatamodelManager_2.getInstance(), constraintChecker = new CryptedConstraintChecker(stammdatenCache), fileUploader = new FileUploader(fnProgress);
    async function processItem(item) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        /**
         *
         * @param {string|array} to_be_hashed
         * @returns {string}
         * @private
         */
        function _hash(to_be_hashed) {
            var i;
            if (typeof to_be_hashed === "string") {
                to_be_hashed = to_be_hashed.substr(0, 10);
            }
            else if (Array.isArray(to_be_hashed)) {
                for (i = 0; i < to_be_hashed.length; i += 1) {
                    to_be_hashed[i] = to_be_hashed[i].substr(0, 10);
                }
            }
            return crypto.hash(to_be_hashed, sessionStorage.getItem(STORAGE_KEYS.SESSION.HASH_SALT), 16);
        }
        let modelname, model, hasFields, hasArray, new_hasArray, _crypto, fieldCrypto, fieldSearch, path, modelPath, methodOptions, relationType, relationDate, recordBasePath, pathToRecordBase, stack = [], matchingDatamodelResult, matchingDatamodelVersion;
        function isRecordBase(path, modelName) {
            var pathArr = path.split("."), lastKey = pathArr.slice(-1)[0], lastButOneKey = pathArr.slice(-2)[0];
            if (dManager.getModelByNameAndVersion(modelName)) {
                return true;
            }
            if (dManager.getModelByNameAndVersion(lastKey)) {
                return true;
            }
            if (StringUtils.isStringWithNumber(lastKey)) {
                if (dManager.getModelByNameAndVersion(lastButOneKey)) {
                    return true;
                }
            }
            return false;
        }
        function getSearchFieldPath(path, key) {
            let pathArr, searchFieldPath;
            pathArr = path.split(".");
            pathArr.push(key);
            pathArr = pathArr.filter(function (item) {
                return (!StringUtils.isStringWithNumber(item)
                    && item !== "transaction"
                    && !dManager.getModelByNameAndVersion(item));
            });
            if (pathArr.slice(-1)[0].substr(-2) === "_c") {
                searchFieldPath = pathArr.join(".");
            }
            else {
                searchFieldPath = pathArr.join(".") + "_c";
            }
            return searchFieldPath;
        }
        classmethod = item.classmethod;
        methodOptions = item.methodOptions;
        amArray = item.amArray;
        hasArray = item.hasArray;
        obj = item.obj;
        recordBase = item.recordBase;
        recordBaseCleanCopy = item.recordBaseCleanCopy;
        recordBasePath = item.recordBasePath;
        pathToRecordBase = item.pathToRecordBase;
        modelname = obj.head_model || item.model;
        modelPath = item.modelPath;
        matchingDatamodelResult = findMatchingDatamodel(modelname, classmethod, item);
        if (matchingDatamodelResult.error) {
            return Promise.reject(matchingDatamodelResult.error);
        }
        // The matching datamodel version may be undefined (for classmethods different from crud/read or crud/search as requests on old versions are
        // only allowed for these two request types). In this case the most recent version is used.
        matchingDatamodelVersion = matchingDatamodelResult.datamodelVersion;
        model = dManager.getModelByNameAndVersion(modelname, matchingDatamodelVersion);
        // for every type of create command - autonumber fields have to be initialized if existing - so that later on, they can be filled and encrypted
        if (/^.*\/create$/.test(classmethod) && modelname && !amArray) {
            let autonumberFieldsForLevel = dManager.getAutonumberFieldsOnModelPath(modelPath, modelname, true, matchingDatamodelVersion);
            for (let j = 0, len = autonumberFieldsForLevel.length; j < len; j++) {
                // initialize autonumber fields, so that they can be handled via encryption later on
                obj[autonumberFieldsForLevel[j]._fieldname] = undefined;
            }
        }
        keys = Object.keys(obj);
        for (pk = 0; pk < keys.length; pk += 1) {
            path = item.path;
            key = keys[pk];
            value = obj[key];
            if (classmethod === "crud/search" && typeof value === "string") {
                value = value.replace(/\*/g, "");
                const hasFiltersToHash = Object.keys(((_a = obj === null || obj === void 0 ? void 0 : obj.options) === null || _a === void 0 ? void 0 : _a.filter) || {}).length !== 0;
                const hasFilters = hasFiltersToHash ||
                    Object.keys((methodOptions === null || methodOptions === void 0 ? void 0 : methodOptions.filter) || {}).length !== 0;
                if (!value.trim() && !hasFilters) {
                    return Promise.reject({ emptySearchFor: modelname });
                }
                if (hasFiltersToHash) {
                    await search.hashEncryptedFilterOptions((_b = obj === null || obj === void 0 ? void 0 : obj.options) === null || _b === void 0 ? void 0 : _b.filter);
                }
            }
            field = getField(modelname, key, path, hasArray, matchingDatamodelVersion);
            hasFields = !!(field && (field.fields || field.array && field.array.fields));
            new_hasArray = !!(field && field.array && !field.relation && (field.array.type !== "object" || field.array.fields));
            searchFieldIsArray = item.searchFieldIsArray || !!field && field.type === "array";
            // value is "real" object - ignore MongoDB Search Objects like {$in: [...]}
            const subObject = typeof value === "object"
                // do not crawl FileId instances of file fields
                && !((field === null || field === void 0 ? void 0 : field.type) === "file" && value instanceof FileId)
                // do not crawl operators
                && !Object.keys(value).find(v => ALL_OPERATORS.includes(v));
            if (subObject && (amArray
                || dManager.getModelByNameAndVersion(key)
                || key === "search" || key === "transaction"
                || hasFields
                || new_hasArray)) {
                path += (path ? "." : "") + key;
                if (amArray || hasFields || new_hasArray) {
                    new_modelname = modelname;
                    recordBasePath += (recordBasePath ? "." : "") + key;
                    if (field && !amArray) {
                        modelPath = (item.modelPath ? "." : "") + key;
                    }
                }
                else {
                    new_modelname = key;
                    recordBasePath = "";
                    pathToRecordBase = path;
                    modelPath = "";
                }
                if (isRecordBase(path, value.head_model)) {
                    // set object base for head_search
                    recordBase = value;
                    recordBaseCleanCopy = JSON.parse(JSON.stringify(recordBase));
                }
                if (classmethod === "crud/read" || classmethod === "crud/count" || classmethod === "crud/search") {
                    /*
                     * Use key instead of new_modelname
                     * If it is an array this piece of code will be called on model level again
                     */
                    const model = dManager.getModelByNameAndVersion(key);
                    if (model) {
                        if (classmethod === "crud/read" && model.container === "base") {
                            if (item.obj[key] &&
                                (!item.obj[key].head_id
                                    || !((_c = stammdatenCache.get(new_modelname)) === null || _c === void 0 ? void 0 : _c.includes(item.obj[key].head_id)))) {
                                // Head-Id not in existence cache
                                baseDataCacheRequest.misses.push(path);
                            }
                        }
                    }
                    if (modelname && new_modelname !== modelname && modelname !== "transaction") {
                        // if the outer model is transaction - it is no relation but a complex request
                        // otherwise we have a nested request
                        if (dManager.relationIsCrypted(modelname, new_modelname, matchingDatamodelVersion)) {
                            relationType = dManager.relationIsHeadRelation(modelname, new_modelname, matchingDatamodelVersion)
                                ? RelationType.HeadRelation : RelationType.Relation;
                            // Only handle crypted relations here!
                            // It is necessary to remember the given requests
                            // to be able to fully resolve the originally given request.
                            cryptedNestResolver.addNestedRequest(cloneObject(value), modelname, new_modelname, path, relationType);
                        }
                    }
                }
                stack.push({
                    classmethod: classmethod,
                    methodOptions: methodOptions,
                    model: new_modelname,
                    obj: value,
                    amArray: Array.isArray(obj[key]),
                    path: path,
                    hasArray: new_hasArray,
                    recordBase: recordBase,
                    recordBaseCleanCopy: recordBaseCleanCopy,
                    recordBasePath: recordBasePath,
                    pathToRecordBase: pathToRecordBase,
                    searchFieldIsArray: searchFieldIsArray,
                    modelPath: modelPath
                });
            }
            else {
                // check if object has options and if yes if it has an container
                if (dManager.getModelByNameAndVersion(modelname)) {
                    container = dManager.getContainer(modelname);
                }
                else {
                    if (obj.options && obj.options.container) {
                        container = obj.options.container;
                    }
                    else {
                        container = "";
                    }
                }
                if (obj.options) {
                    _crypto = obj.options.crypto;
                }
                if (key === "search" && modelname !== "") {
                    tokens = SearchData.normalizedBirthdize(obj.search);
                    obj.search = {
                        clear: [],
                        soundex: [],
                        crypto: [],
                        tags: []
                    };
                    for (i = 0; i < tokens.length; i += 1) {
                        token = tokens[i];
                        if (token[0] === "#") {
                            if (token.length > 1) {
                                obj.search.tags.push(token.substr(1));
                                // hash aus suchstring entfernen
                                value = value.replace(token, "");
                            }
                        }
                        else {
                            if (!_crypto && (container === "base"
                                || (model && !model.searchCrypto)
                                || modelname === "search")) {
                                obj.search.soundex.push(new KoelnerPhonetik(token).getValue());
                                if (token[0] === "$") {
                                    token = token.substr(1);
                                }
                                else if (token[0] !== "+" && token[0] !== "-") {
                                    token = "+" + token;
                                }
                                if (token.trim() !== "+") {
                                    token = token + "*";
                                }
                                obj.search.clear.push(token);
                            }
                            else {
                                token = token.replace(/\$/g, "");
                                if (token.trim() === "+") {
                                    obj.search.crypto.push("+");
                                }
                                else {
                                    obj.search.crypto.push(await _hash(token) + "^100");
                                    obj.search.crypto.push(await _hash(new KoelnerPhonetik(token).getValue()));
                                }
                            }
                        }
                    }
                    if (modelname === "abda") {
                        obj.search.string = SearchData.normalize(value, { abda: true });
                    }
                }
                else if (key !== "options" && key[0] !== "$") {
                    if (obj.class && obj.method) {
                        classmethod = obj.class + "/" + obj.method;
                        methodOptions = obj.options;
                    }
                    if (dManager.getModelByNameAndVersion(modelname)) {
                        const identField = dManager.getIdentFieldName(modelname);
                        if ((classmethod === "crud/create" || classmethod === "crud/update") && obj[identField]) {
                            /*
                             * Update is only for performance reasons. No extra guaranties are added.
                             *
                             * If id is not specified manually, we cannot check for it
                             * But we cannot relate to this new object with unknown id, so it's not a problem
                             */
                            constraintChecker.addTransactionDatasetId(modelname, obj[identField]);
                        }
                        /*
                         * MISSING:
                         * crud/delete has no guaranties
                         * We do not know the id of an item to be deleted, so we cannot check if it is deleted within the transaction
                         */
                        if (key === "head_id" || key === "search") {
                            field = {};
                        }
                        if (field.type === "datetime") {
                            if (typeof value === "object") {
                                obj[key] = new DateConverter(value).toLocaleISOString();
                            }
                        }
                        else if (field.type === "nativedate" && !(typeof value === "object" && Object.keys(value).every(key => key.startsWith("$")))) {
                            if (!(value instanceof Date)) {
                                return Promise.reject(`value is no nativedate - ${modelname} - ${path}.${key}`);
                            }
                            // convert it into an iso date string for transmission
                            obj[key] = value.toISOString();
                        }
                        if ((field.type === "datetime" || field.type === "date")
                            && classmethod === "crud/update" && (!methodOptions || !methodOptions.fullUpdate)) {
                            // When this is a partial update, we have to handle the possibility,
                            // that there is only the date value given for a relation with date.
                            // In this case we will fetch the field definition for the corresponding relation (has to have relationDate and crypto).
                            let relationDateFields = dManager.getRelationDateFields(modelname, matchingDatamodelVersion), relationDateField = relationDateFields.find((item) => {
                                return item.relationDate === recordBasePath + (recordBasePath ? "." : "") + key;
                            });
                            if (relationDateField && relationDateField.crypto) {
                                // We will only handle this case if the corresponding relation value is not given in this partial update!
                                let relationValue = getValueOnDataPath(recordBaseCleanCopy, relationDateField._path);
                                if (!relationValue) {
                                    let readRequest = {
                                        class: "crud",
                                        method: "read"
                                    };
                                    readRequest[modelname] = Object.assign(Object.assign({}, (dManager.getDatabase(modelname) === "quarter" /* Container.Quarter */ ? {
                                        $or: [
                                            {
                                                head_id: recordBase.head_id
                                            }, {
                                                head_pre_ids: recordBase.head_id
                                            }
                                        ]
                                    } : {
                                        head_id: recordBase.head_id
                                    })), { options: {
                                            deleted: true
                                        } });
                                    relationValue = await redServicePromised(readRequest).then((data) => {
                                        return getValueOnDataPath(data[modelname][0], relationDateField._path);
                                    });
                                    // may be the relationValue is undefined in the original dataset - no constraint check has to be done
                                    if (relationValue || relationValue === 0) {
                                        constraintChecker.addConstraint(relationDateField.relation, relationValue, pathToRecordBase + (recordBasePath ? "." + recordBasePath : "") + "." + relationDateField._path, modelname, RelationType.Relation, value === "$unset" ? undefined : value);
                                    }
                                }
                            }
                        }
                        fieldCrypto = field.crypto || (field.array && field.array.crypto);
                        if (fieldCrypto) {
                            // fetch the autonumber value for this field and model if field value should not be set to empty or deleted
                            if (/^.*\/create$/.test(classmethod) && field.type === "autonumber" && value !== "$unset") {
                                value = await redServicePromised({
                                    class: "database",
                                    method: "getAutonumber",
                                    model: modelname,
                                    identifier: item.modelPath === "" ? key : `${item.modelPath}.${key}`
                                }).then((result) => {
                                    return result.value;
                                });
                            }
                            if (classmethod !== "crud/read" && classmethod !== "crud/count") {
                                // check if we have to handle a crypted relation here. serverside this cannot be handled.
                                if (field.relation || field.headRelation) {
                                    relationType = field.relation ? RelationType.Relation : RelationType.HeadRelation;
                                    if (relationType === RelationType.Relation && field.relationDate) {
                                        relationDate = getValueOnDataPath(recordBaseCleanCopy, field.relationDate);
                                        if (classmethod === "crud/update" && (!methodOptions || !methodOptions.fullUpdate)) {
                                            // If option is fullUpdate: relationDate can be empty and will be reset. So this case can be ignored here.
                                            if (relationDate === "$unset") {
                                                // Reset the relationDate as the field value will be removed from dataset in database.
                                                // Relation will point to current date.
                                                relationDate = undefined;
                                            }
                                            else if (!relationDate) {
                                                // relationDate is not given in the update. We must assume that there is another value in the database.
                                                // So we have to get it here...
                                                let readRequest = {
                                                    class: "crud",
                                                    method: "read"
                                                };
                                                readRequest[modelname] = Object.assign(Object.assign({}, (dManager.getDatabase(modelname) === "quarter" /* Container.Quarter */ ? {
                                                    $or: [
                                                        {
                                                            head_id: recordBase.head_id
                                                        }, {
                                                            head_pre_ids: recordBase.head_id
                                                        }
                                                    ]
                                                } : {
                                                    head_id: recordBase.head_id
                                                })), { options: {
                                                        deleted: true
                                                    } });
                                                relationDate = await redServicePromised(readRequest).then((data) => {
                                                    return getValueOnDataPath(data[modelname][0], field.relationDate);
                                                });
                                            }
                                        }
                                    }
                                    constraintChecker.addConstraint(field.relation || field.headRelation, value, path + "." + key, modelname, relationType, relationDate);
                                }
                                fieldSearch = field.search || (field.array ? field.array.search : undefined);
                                if (fieldSearch && (fieldSearch.indexed || field.array)) {
                                    normalizeOptions = { dollar: false, phone: fieldSearch.indexed === "phone" };
                                    recordBase.head_search = recordBase.head_search || {};
                                    headSearch = recordBase.head_search;
                                    searchFieldPath = getSearchFieldPath(path, key);
                                    clearHeadSearchValuesAndExtensions = SearchData.getClearHeadSearchValuesAndExtensions(fieldSearch, value, field.type, true, classmethod === "crud/search", true, normalizeOptions);
                                    let i, len = clearHeadSearchValuesAndExtensions.length, hashCalls = [];
                                    const hashSalt = sessionStorage.getItem(STORAGE_KEYS.SESSION.HASH_SALT);
                                    for (i = 0; i < len; ++i) {
                                        const headSearchItem = clearHeadSearchValuesAndExtensions[i];
                                        hashCalls.push(crypto.hash(headSearchItem.clearValue, hashSalt, 16));
                                    }
                                    const cryptedValues = await Promise.all(hashCalls);
                                    for (i = 0; i < len; ++i) {
                                        const headSearchItem = clearHeadSearchValuesAndExtensions[i];
                                        const extendedSearchFieldPath = searchFieldPath + headSearchItem.ext;
                                        headSearch[extendedSearchFieldPath] = SearchData.getHeadSearchValue(headSearch[extendedSearchFieldPath], cryptedValues[i], searchFieldIsArray);
                                    }
                                }
                            }
                            // now encrypt the field
                            if (fieldCrypto === "key_tenant_s" || fieldCrypto === true) {
                                if (value !== undefined) {
                                    if (value === "$unset") {
                                        if (classmethod === "crud/create") {
                                            delete obj[key];
                                        }
                                    }
                                    else {
                                        if (key !== "hashSalt" && key !== "privateTenantKey" && key !== "privateTenantRSAKey") {
                                            if ((classmethod === "crud/read" || classmethod === "crud/count")
                                                && (((_d = field.search) === null || _d === void 0 ? void 0 : _d.indexed) === "exact" || ((_f = (_e = field.array) === null || _e === void 0 ? void 0 : _e.search) === null || _f === void 0 ? void 0 : _f.indexed) === "exact")) {
                                                obj[key] = await hashReadCryptoField(field, value);
                                            }
                                            else {
                                                obj[key] = await crypto.encrypt(value);
                                            }
                                        }
                                    }
                                }
                            }
                            else if (fieldCrypto === "key_user_s") {
                                if (key !== "symmetricTenantKey") {
                                    if ((classmethod === "crud/read" || classmethod === "crud/count")
                                        && (((_g = field.search) === null || _g === void 0 ? void 0 : _g.indexed) === "exact" || ((_j = (_h = field.array) === null || _h === void 0 ? void 0 : _h.search) === null || _j === void 0 ? void 0 : _j.indexed) === "exact")) {
                                        // MISSING SRV-2400: Fields in $and and $or are not encrypted
                                        obj[key] = await hashReadCryptoField(field, value);
                                    }
                                    else {
                                        obj[key] = await crypto.encrypt(value, key_user_s);
                                    }
                                }
                            }
                            else {
                                err = "crypto type unknown - " + modelname + " - " + path + "." + key + " / " + field.crypto;
                                return Promise.reject(err);
                            }
                        }
                        else {
                            if (value === "$unset" && classmethod === "crud/create") {
                                delete obj[key];
                            }
                        }
                        if (field.type === "file" && (classmethod === "crud/create" || classmethod === "crud/update")) {
                            const modelArrayRegEx = new RegExp("(transaction\\.)?(\\d+\\.)?(\\w+\\.)?" + modelname + "\\.");
                            const fieldPath = `${path}.${key}`.replace(modelArrayRegEx, "");
                            obj[key] = await fileUploader.addToQueue(value, modelname, fieldPath);
                        }
                    }
                }
            }
        }
        // Potentially the processItem iteration will produce a set of other items to process.
        // stack.reduce will iterate over all items from the stack and call processItem with each.
        // Maybe this will produce a new stack to be handled the same way.
        // Everything will be handled via promise chain, that will prevent RangeError (callstack size exceeded).
        return stack.reduce((promise, item) => {
            return promise.then(() => {
                return processItem(item);
            });
        }, Promise.resolve());
    }
    return processItem(item).then(async () => {
        if (!constraintChecker.hasConstraints()) {
            return Promise.resolve();
        }
        let request = constraintChecker.getConstraintRequest();
        Log.write(0 /* LogLevel.debug */, "checking crypted constraints...");
        let result = [];
        if (request.length > 0) {
            try {
                result = (await redServicePromised(request));
            }
            catch (err) {
                err.forEach(function (singleErr) {
                    if (singleErr.error === "unknown error: invalid head_id") {
                        singleErr.errtag = singleErr.errtag || "error_constraint_check";
                    }
                });
                return Promise.reject(err);
            }
        }
        return constraintChecker.checkResultForMissingConstraints(result);
    }).then(() => {
        return fileUploader.finishUpload()
            .then(uploadResult => {
            return {
                result: {
                    encryptedData,
                    uploadResult
                },
                baseDataCacheRequest
            };
        });
    }).catch((err) => {
        if (typeof err === "object" && err.emptySearchFor) {
            // this is some kind of error, but will be returned as successful result
            err.success = true;
            return {
                result: err,
                baseDataCacheRequest
            };
        }
        if (err instanceof Error) {
            err = {
                errtag: err.name,
                error: err.message,
                errspec: err.stack
            };
        }
        else if (Array.isArray(err)) {
            err = err.map(function (singleErr) {
                if (singleErr instanceof Error) {
                    return {
                        errtag: singleErr.name,
                        error: singleErr.message,
                        errspec: singleErr.stack
                    };
                }
                return singleErr;
            });
        }
        return Promise.reject(err);
    });
}
function fieldCheck(field, value, path, key) {
    var err;
    if (!isFieldTypeValid(field, value)) {
        err = "wrong field type received - "
            + path + "."
            + key
            + " (IS: " + TypeChecker_2.getInstance().typeOf(value) + "/" + JSON.stringify(value)
            + ", SHOULD: " + field.type + ")";
        return { err: err };
    }
    return { err: null, result: value };
}
async function decryptRedObject(obj, amArray, options, cryptedNestResolver, baseDataCacheRequest = {
    misses: []
}) {
    let key, value, field, key_tenant_s = await crypto.getKey("key_tenant_s"), key_user_s = await crypto.getKey("key_user_s"), keys, pdk, modelname, originalResponse = obj;
    let item = {
        model: "",
        obj: obj,
        amArray: amArray,
        path: "",
        hasArray: false,
        objBase: undefined,
        dataVersion: undefined,
        dataQuarter: undefined
    }, dManager = DatamodelManager_2.getInstance();
    options = options || {};
    async function processItem(item) {
        var new_modelname, model, err, path, hasArray, new_hasArray, relationType;
        let objBase, newBase, dataVersion, dataQuarter, firstModelVersion;
        // This empty stack will hold "secondary" items to be processed afterwards.
        const stack = [];
        amArray = item.amArray;
        hasArray = item.hasArray;
        obj = item.obj;
        objBase = item.objBase;
        modelname = obj.head_model || item.model;
        keys = Object.keys(obj);
        firstModelVersion = dManager.getModelByNameFirstVersion(modelname);
        // if head_version is defined, use this
        // if no head_version is defined and it is no top-level object (only at the first model level the property head_model is defined)
        // the version is saved on the item (last top level)
        // if version is defined on neither current object nor item, then use the version of the first/oldest model
        // if the first model has no version information, only one version exists. This means the first version is also the most recent version.
        // In this case dataVersion is undefined and the most recent version is used.
        dataVersion = obj.head_version !== undefined ? obj.head_version :
            (!obj.head_model && item.dataVersion !== undefined ? item.dataVersion :
                (firstModelVersion
                    && firstModelVersion.versions
                    && firstModelVersion.versions.length ? firstModelVersion.versions[0].version : undefined));
        dataQuarter = !obj.head_model && item.dataQuarter !== undefined ? item.dataQuarter : obj.head_quarter;
        if (!(!!firstModelVersion && firstModelVersion.database === "quarter")) { // do not check quarter models against datamodel
            for (pdk = 0; pdk < keys.length; pdk += 1) {
                path = item.path;
                key = keys[pdk];
                value = obj[key];
                // filter everything that has no value
                // aggregate produces null values if field is not there
                if (value === undefined || value === null) {
                    delete obj[key];
                    continue;
                }
                field = getField(modelname, key, path, hasArray, { version: dataVersion, quarter: dataQuarter });
                if (field && field.type && field.type === "file" && modelname && key && options.downloadUpToMb) {
                    const fieldPath = `${path ? path + "." : ""}${key}`
                        .replace(new RegExp("^.*" + modelname + "\\.\\d+\\."), "");
                    await Promise.all([].concat(obj[key]).map((fileId, i) => {
                        const data = {
                            modelName: modelname,
                            fileId,
                            fieldPath
                        };
                        return fetchFile(data, options.downloadUpToMb, !!options.getBinaryData, options.autoDownload)
                            .then((file) => {
                            if (Array.isArray(obj[key])) {
                                obj[key][i] = file;
                            }
                            else {
                                obj[key] = file;
                            }
                        });
                    })).then(() => {
                        return;
                    });
                }
                new_hasArray = !!(field && field.array && !field.relation && (field.array.type !== "object" || field.array.fields));
                if (!field
                    && !amArray
                    && modelname
                    && modelname !== "search"
                    && key !== "search"
                    && key !== "options"
                    && !dManager.getModelByNameAndVersion(key)
                    && key[0] !== "_"
                    && path[0] !== "_" // alert only field is no internal of _statistic
                    && key !== "scriptFields" // allow script fields from elastic which are not part of any datamodel
                    && options.field_check !== false) {
                    // in session extended base models unknown fields are allowed
                    if (["Terminal", "User", "UserGroup", "Administration", "License"].indexOf(modelname) === -1) {
                        err = "received field unknown - " + path + "." + key;
                        Log.write(3 /* LogLevel.error */, err);
                        // remove modelName and array index from beginning of the path, f.e. "PharmaArtikel.0"
                        const modelPath = path.split(".").slice(2).join("");
                        removeEntryByKey(objBase, modelPath, key);
                    }
                }
                else if (typeof value === "object") {
                    model = dManager.getModelByNameAndVersion(key, {
                        version: value.head_version,
                        quarter: value.head_quarter
                    });
                    // Calculate correct path name of key level (path: undefined, key: A => "A", path: p, key: A => "p.A")
                    const keyPath = [path, key].filter(v => v).join(".");
                    if (baseDataCacheRequest.misses.includes(keyPath)) {
                        if (!stammdatenCache.has(key)) {
                            stammdatenCache.set(key, []);
                        }
                        for (const stammdatenItem of item.obj[key]) {
                            stammdatenCache.get(key).push(stammdatenItem.head_id);
                        }
                    }
                    // if key is a modelname we will also check the content of the fetched objects
                    if (amArray || !!model && model.database !== "quarter" || field && Object.keys(field).length > 0
                        || key === "search" || new_hasArray) {
                        if (!!model) {
                            new_modelname = key;
                            objBase = value;
                        }
                        else {
                            new_modelname = modelname;
                        }
                        if (field && field.relation) {
                            path += (path ? "." : "") + field.relation;
                        }
                        else {
                            path += (path ? "." : "") + key;
                        }
                        if (Array.isArray(objBase) && objBase.hasOwnProperty(key)) {
                            newBase = objBase[key];
                        }
                        else {
                            newBase = objBase;
                        }
                        stack.push({
                            model: new_modelname,
                            obj: value,
                            amArray: Array.isArray(obj[key]),
                            path: path,
                            hasArray: new_hasArray,
                            objBase: newBase,
                            dataVersion: new_modelname === modelname ? dataVersion : undefined, // reset version informations for new model
                            dataQuarter: new_modelname === modelname ? dataQuarter : undefined
                        });
                    }
                }
                else {
                    if (dManager.getModelByNameAndVersion(modelname, { version: dataVersion, quarter: dataQuarter })
                        || modelname === "search") {
                        if (field) {
                            if (field.crypto) {
                                switch (field.crypto) {
                                    case "key_tenant_s":
                                    case true: // by intention!
                                        if (!key_tenant_s) {
                                            obj.symmetricTenantKey = await crypto.decrypt(obj.symmetricTenantKey, key_user_s, "string");
                                            key_tenant_s = obj.symmetricTenantKey;
                                        }
                                        obj[key] = await crypto.decrypt(value, key_tenant_s, field.type);
                                        break;
                                    case "key_user_s":
                                        if (!key_tenant_s) {
                                            obj[key] = await crypto.decrypt(value, key_user_s, field.type);
                                            if (key === "symmetricTenantKey") {
                                                key_tenant_s = obj[key];
                                            }
                                        }
                                        break;
                                    default:
                                        throw new Error("INVALID_CRYPTO_TYPE: " + modelname + "/" + key + "/" + field.crypto);
                                }
                                switch (field.type) {
                                    case "int":
                                        obj[key] = parseInt(obj[key], 10);
                                        break;
                                }
                            }
                            // this will check encrypted and non-crypted fields for the correct type
                            if (!isFieldTypeValid(field, obj[key])) {
                                err = "wrong field type received - "
                                    + path + "."
                                    + key
                                    + " (IS: " + TypeChecker_2.getInstance().typeOf(obj[key]) + "/" + JSON.stringify(obj[key])
                                    + ", SHOULD: " + field.type + ")";
                                return Promise.reject(err);
                            }
                            if (field.type === "nativedate") {
                                // nativedates are transmitted as iso strings - convert it back into a date
                                obj[key] = new Date(obj[key]);
                            }
                            if (cryptedNestResolver && (field.relation || field.headRelation)) {
                                relationType = field.relation ? RelationType.Relation : RelationType.HeadRelation;
                                // Handle a field that has a crypted relation:
                                // Therefore it is neccessary to check whether there is a nested request for that relation.
                                // Otherwise we do not have to care about that field.
                                if (cryptedNestResolver.nestedRequestExists(modelname, field.relation || field.headRelation, path + "." + key, relationType)) {
                                    let relationDate = undefined;
                                    if (field.relationDate) {
                                        let dateField = getField(modelname, field.relationDate, undefined, undefined, { version: dataVersion, quarter: dataQuarter });
                                        relationDate = getValueOnDataPath(objBase, field.relationDate);
                                        if (relationDate && dateField.crypto &&
                                            !TypeChecker_2.getInstance().isDateFormatValid(relationDate, DateType_1.date)) {
                                            // this field has not been decrypted yet... simply decrypt it
                                            relationDate = await crypto.decrypt(relationDate, key_tenant_s, dateField.type);
                                        }
                                    }
                                    cryptedNestResolver.addIdentifierToNestedRequest(modelname, field.relation || field.headRelation, path + "." + key, cloneObject(obj[key]), relationType, relationDate);
                                }
                            }
                        }
                    }
                }
            }
        }
        // Potentially the processItem iteration will produce a set of other items to process.
        // stack.reduce will iterate over all items from the stack and call processItem with each.
        // Maybe this will produce a new stack to be handled the same way.
        // Everything will be handled via promise chain, that will prevent RangeError (callstack size exceeded).
        return stack.reduce((promise, item) => {
            return promise.then(() => {
                return processItem(item);
            });
        }, Promise.resolve());
    }
    return processItem(item).then(() => {
        // finally fetch all nest information and resolve it onto the response
        if (!cryptedNestResolver || !cryptedNestResolver.hasNestedRequests()) {
            return Promise.resolve();
        }
        const request = cryptedNestResolver.getCryptedNestRequests();
        Log.write(0 /* LogLevel.debug */, "fetching nests...");
        return redServicePromised(request).then((data) => {
            cryptedNestResolver.insertCryptedNestResults(originalResponse, data);
        });
    });
}
function notifyError(errorName, errorMsg, data) {
    Log.write(3 /* LogLevel.error */, "ERROR:", errorName, errorMsg, data);
    return { errtag: errorName, errspec: errorMsg };
}
/**
 *
 * @param {*} arr
 * @returns {Array}
 */
function confirmArray(arr) {
    if (arr === undefined) {
        return [];
    }
    if (!Array.isArray(arr)) {
        return [arr];
    }
    return arr;
}
/**
 * checks all keys in options and logs an error if one occurs
 * @param {Object} options - the options to be checked
 * @param {Object} data - the data to be checked
 */
function checkOptions(options, data) {
    var options_keys = ["id", "compress", "upload", "query", "decrypt", "maxRetries"], query_keys = ["noQueue", "anonym"], key;
    function notify(key, value) {
        notifyError("checkOptionsError", "unknown or wrong option: " + key + "/" + value, {
            data: data,
            options: options
        });
    }
    options = options || {};
    for (key in options) {
        if (options.hasOwnProperty(key)) {
            if (options_keys.indexOf(key) === -1) {
                notify(key, options[key]);
            }
        }
    }
    options.query = options.query || {};
    for (key in options.query) {
        if (options.query.hasOwnProperty(key)) {
            if (query_keys.indexOf(key) === -1) {
                notify("query." + key, options.query[key]);
            }
        }
    }
}
function isPermittedWithoutDatamodel(className, methodName) {
    let permitted = {
        test: ["get_filenames", "switchDatamodelVersion", "restoreDatamodelVersion", "getActivationLink"],
        auth: ["get_salt", "logout", "isloggedin", "login", "getAppVersion", "register",
            "getKeys", "reset_password_request", "reset_password", "isBetaRegistrationEnabled"],
        bic: ["read"],
        tenant: ["alias_available"],
        zip: ["read"],
        datamodel: ["get"],
        license: ["getAllAvailable"],
        analytics: ["write"]
    };
    return !!permitted[className] && permitted[className].indexOf(methodName) > -1;
}
function redService(data, options, fnProgress, callback_rs) {
    Log.write(2 /* LogLevel.warning */, "DEPRECATED", "Use redServicePromised instead.");
    if (!callback_rs) {
        if (typeof fnProgress === "function") {
            callback_rs = fnProgress;
            if (typeof options === "function") {
                fnProgress = options;
                options = {};
            }
            else {
                fnProgress = null;
            }
        }
        else {
            callback_rs = options;
            fnProgress = null;
            options = {};
        }
    }
    callback_rs = callback_rs || function () {
        return undefined;
    };
    redServicePromised(data, options, fnProgress)
        .then((res) => {
        callback_rs(null, res);
    })
        .catch((err) => {
        callback_rs(err);
    });
}
function isConfidential(modelName) {
    const dManager = DatamodelManager_2.getInstance();
    const container = dManager.getContainer(modelName);
    return container !== "base";
}
function sortKeys(obj) {
    var key, ret = {}, arr = [];
    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            arr.push({ key: key, value: obj[key] });
        }
    }
    arr = arr.sort(function (a, b) {
        if (a.value < b.value) {
            return 1;
        }
        if (a.value > b.value) {
            return -1;
        }
        return 0;
    });
    arr.forEach(function (item) {
        ret[item.key] = item.value;
    });
    return ret;
}
/**
 * Hashes crypto fields to match head_search
 * @param field field properties
 * @param value field value
 * @private
 */
async function hashReadCryptoField(field, value) {
    if (!field) {
        throw new Error(`No field given to hash`);
    }
    while (field.type === "array") {
        field = field.array;
    }
    if (field.type === "object") {
        throw new Error(`Field to hash would be an object: ${JSON.stringify(field)}`);
    }
    if (field.crypto) {
        // MISSING SRV-2400: Fields in $and and $or are not encrypted
        const hash = (value) => {
            const hashSalt = sessionStorage.getItem(STORAGE_KEYS.SESSION.HASH_SALT);
            if (field.type === "date" || field.type === "datetime") {
                // enforcing the date "string"
                value = SearchData.normalize((value instanceof Date ? value.toISOString() : value.toString()).slice(0, 10));
            }
            else if (field.type !== "int" && field.type !== "float") {
                value = SearchData.normalize(value);
            }
            return crypto.hash(value, hashSalt, 16);
        };
        if (typeof value === "object" && Object.keys(value).every(key => ALL_OPERATORS.includes(key))) {
            // do not execute this block for dates!
            for (const key in value) {
                if (!value.hasOwnProperty(key)) {
                    continue;
                }
                if (UNI_OPERATORS.includes(key)) {
                    value[key] = await hash(value[key]);
                    return value;
                }
                if (NOT_ENCRYPT_OPERATORS.includes(key)) {
                    return value;
                }
                if (ARRAY_OPERATORS.includes(key)) {
                    if (!Array.isArray(value[key])) {
                        throw Error(`Unexpected type ${typeof value[key]} of ${value[key]} - expected array`);
                    }
                    value[key] = await Promise.all(value[key].map(val => hash(val)));
                    return value;
                }
            }
        }
        else {
            return hash(value);
        }
    }
}
/**
 * Takes the encrypted request, the original unencrypted request and the encrypted ajax response
 * and injects it into the socket to simulate a socket message.
 * This is done because the frontend wants a unified message stream for local and remote messages.
 *
 * @param request is the encrypted request
 * @param localRequest is the original unencrypted request
 * @param response is the encrypted ajax response
 */
function injectAjaxResultIntoSocket(request, localRequest, response) {
    request = Array.isArray(request) ? request : [request];
    localRequest = Array.isArray(localRequest) ? localRequest : [localRequest];
    for (let i = 0; i < request.length; i++) {
        let req = request[i];
        let localReq = localRequest[i];
        if (req
            && req.method
            && !req.method.includes("read")) {
            req = cloneObject(req);
            delete req.session;
            localReq = cloneObject(localReq);
            delete localReq.session;
            const sender = {
                user_id: sessionStorage.getItem(STORAGE_KEYS.SESSION.USER_ID),
                terminal_id: sessionStorage.getItem(STORAGE_KEYS.SESSION.TERMINAL_ID)
            };
            if (req.method.includes("create")
                || req.method.includes("update")
                || req.method.includes("delete")
                || req.method.includes("createBattery")
                || req.method.includes("getBatteryStatus")
                || req.method.includes("cancelBattery")
                || req.method.includes("continueTest")) {
                const resClone = cloneObject(response);
                exports.eventDispatcher.dispatchEvent(new MessageEvent("cud", {
                    data: {
                        sender,
                        type: "cud",
                        subtype: req.method,
                        data: {
                            request: req,
                            response: resClone,
                            localRequest: localReq
                        }
                    }
                }));
            }
            if (req.method.includes("transaction")) {
                exports.eventDispatcher.dispatchEvent(new MessageEvent("transaction", {
                    data: {
                        sender,
                        type: "transaction",
                        subtype: "",
                        data: response.map((res, index) => {
                            const resClone = cloneObject(res);
                            return {
                                localRequest: localReq.transaction[index],
                                request: req.transaction[index],
                                response: resClone
                            };
                        })
                    }
                }));
            }
        }
    }
}// We have to make sure that only required parts are imported!
class CryptedNestResolver {
    constructor() {
        this.nestedRequests = [];
    }
    /**
     * Add a nest definition to be able to resolve the nest later on.
     */
    addNestedRequest(request, model, relationModel, path, relationType) {
        let splittedPath = path.split("."), pathRegExp;
        // build up a test regexp for the path
        pathRegExp = "^";
        // remove transaction path element as it won't exist on result
        if (splittedPath[0] === "transaction") {
            splittedPath.shift();
        }
        // transaction results are going to get merged on to the whole result array - so we have to merge the paths
        if (splittedPath.length > 2 && splittedPath[1] === "transaction" && /\d+/.test(splittedPath[0]) && /\d+/.test(splittedPath[2])) {
            splittedPath.splice(0, 3, (parseInt(splittedPath[0], 10) + parseInt(splittedPath[2], 10)).toString());
        }
        // path keeps name of nested model on last element
        // --> remove it to be able to filter on fields of parent model data
        splittedPath.pop(); // it will always hold an element as long as path is a string!
        let lastItem;
        splittedPath.forEach((item) => {
            if (lastItem) {
                if (!/\d+/.test(lastItem) && !/\d+/.test(item)) {
                    pathRegExp += "\\.\\d+\\."; // combine two non numerical strings with a numerical placeholder
                }
                else {
                    pathRegExp += "\\.";
                }
            }
            lastItem = item;
            pathRegExp += item;
        });
        if (!/^\d+$/.test(splittedPath[splittedPath.length - 1])) {
            pathRegExp += "\\.\\d+"; // if the last part of the path ist not numerical - add a numerical placeholder
        }
        this.nestedRequests.push({
            requestTemplate: request,
            requestPath: path,
            pathRegExp: new RegExp(pathRegExp),
            model: model,
            relationModel: relationModel,
            requestIdentifiers: [],
            relationType: relationType
        });
    }
    findNestedRequest(model, relationModel, path, relationType) {
        return this.nestedRequests.find((item) => {
            // just matching models does not mean, that this is the desired request
            // so additionally do a filter by path
            return item.model === model
                && item.relationModel === relationModel
                && item.relationType === relationType
                && item.pathRegExp.test(path);
        });
    }
    nestedRequestExists(model, relationModel, path, relationType) {
        return !!this.findNestedRequest(model, relationModel, path, relationType);
    }
    /**
     * Add an identifier value to the previously found nest definition.
     */
    addIdentifierToNestedRequest(model, relationModel, path, identValue, relationType, relationDate = undefined) {
        let nest = this.findNestedRequest(model, relationModel, path, relationType), pathToData;
        if (nest) {
            pathToData = nest.pathRegExp.exec(path)[0];
            if (Array.isArray(identValue)) {
                // split arrays into seperate ident entries
                identValue.forEach((item) => {
                    nest.requestIdentifiers.push({
                        identifier: item,
                        pathToData: pathToData,
                        relationDate: relationDate
                    });
                });
            }
            else {
                nest.requestIdentifiers.push({
                    identifier: identValue,
                    pathToData: pathToData,
                    relationDate: relationDate
                });
            }
        }
    }
    hasNestedRequests() {
        if (this.nestedRequests.length === 0) {
            return false;
        }
        return !!this.nestedRequests.find((item) => {
            return item.requestIdentifiers.length > 0;
        });
    }
    /**
     * Take all previously given nest request information and return a request list for all nested models.
     */
    getCryptedNestRequests() {
        let requests = [], singleRequest, nestedRequest, identFieldName, dManager = DatamodelManager_2.getInstance();
        // iterate over all nested request definitions and build for every definition a single request definition
        for (let i = 0, len = this.nestedRequests.length; i < len; i++) {
            nestedRequest = this.nestedRequests[i];
            if (nestedRequest.requestIdentifiers.length === 0) {
                Log.write(2 /* LogLevel.warning */, "crypted relation request misses identifiers");
            }
            else {
                singleRequest = {
                    class: "crud",
                    method: "read"
                };
                // use the name of the ident field from the model for type Relation
                // otherwise use head_id as ident field name
                if (nestedRequest.relationType === RelationType.Relation) {
                    identFieldName = dManager.getIdentFieldName(nestedRequest.relationModel);
                }
                else {
                    identFieldName = "head_id";
                }
                // add the identifier entry with value(s) onto the request
                if (nestedRequest.requestIdentifiers.length === 1) {
                    singleRequest[nestedRequest.relationModel] = JSON.parse(JSON.stringify(nestedRequest.requestTemplate));
                    if (!singleRequest[nestedRequest.relationModel].$or) {
                        singleRequest[nestedRequest.relationModel].$or = [];
                    }
                    singleRequest[nestedRequest.relationModel].$or.push({
                        [identFieldName]: nestedRequest.requestIdentifiers[0].identifier
                    });
                    if (identFieldName === "head_id" && dManager.getDatabase(nestedRequest.relationModel) === "quarter" /* Container.Quarter */) {
                        singleRequest[nestedRequest.relationModel].$or.push({
                            head_pre_ids: nestedRequest.requestIdentifiers[0].identifier
                        });
                    }
                    singleRequest[nestedRequest.relationModel].options = CryptedNestResolver.getNestedRequestOptions(nestedRequest.relationType, nestedRequest.requestIdentifiers[0].relationDate);
                }
                else {
                    singleRequest[nestedRequest.relationModel] = [];
                    nestedRequest.requestIdentifiers.forEach((currentIdentifier) => {
                        let subReq = JSON.parse(JSON.stringify(nestedRequest.requestTemplate));
                        if (!subReq.$or) {
                            subReq.$or = [];
                        }
                        subReq.$or.push({
                            [identFieldName]: currentIdentifier.identifier
                        });
                        if (identFieldName === "head_id" && dManager.getDatabase(nestedRequest.relationModel) === "quarter" /* Container.Quarter */) {
                            subReq.$or.push({
                                head_pre_ids: currentIdentifier.identifier
                            });
                        }
                        subReq.options = CryptedNestResolver.getNestedRequestOptions(nestedRequest.relationType, currentIdentifier.relationDate);
                        singleRequest[nestedRequest.relationModel] = singleRequest[nestedRequest.relationModel] || [];
                        singleRequest[nestedRequest.relationModel].push(subReq);
                    });
                }
                requests.push(singleRequest);
            }
        }
        return requests;
    }
    static getNestedRequestOptions(relationType, relationDate) {
        let options = {};
        if (relationType === RelationType.Relation && relationDate) {
            options.date = relationDate;
        }
        else if (relationType === RelationType.HeadRelation) {
            options.deleted = true; // it is neccessary to set this option to be able to read deleted records
        }
        return options;
    }
    /**
     * Takes the originally given response and inserts relation items
     * from the nest response.
     * This function will modify the originalResponse.
     */
    insertCryptedNestResults(originalResponse, nestResponse) {
        let nestResponseItem, nestResponseItemList, responseShardItem, nestedRequestItem, dManager = DatamodelManager_2.getInstance(), identFieldName, nestResponsePointer = 0;
        // iterate over all nestedRequests and match original and nest response
        for (let i = 0, len = this.nestedRequests.length; i < len; i++) {
            nestedRequestItem = this.nestedRequests[i];
            if (nestedRequestItem.requestIdentifiers.length === 0) {
                continue;
            }
            nestResponseItemList = nestResponse[nestResponsePointer][nestedRequestItem.relationModel];
            // use the name of the ident field from the model for type Relation
            // otherwise use head_id as ident field name
            identFieldName = nestedRequestItem.relationType === RelationType.Relation
                ? dManager.getIdentFieldName(nestedRequestItem.relationModel) : "head_id";
            nestedRequestItem.requestIdentifiers.forEach((item) => {
                nestResponseItem = nestResponseItemList.find(function (responseItem) {
                    var _a;
                    return responseItem[identFieldName] === item.identifier || (identFieldName === "head_id" && ((_a = responseItem.head_pre_ids) === null || _a === void 0 ? void 0 : _a.includes(item.identifier)));
                });
                if (nestResponseItem) {
                    // nest item found --> put it onto the original response
                    // therefore get the position to insert
                    responseShardItem = item.pathToData.split(".").reduce((shardItem, subPath) => {
                        return shardItem[subPath];
                    }, originalResponse);
                    responseShardItem[nestedRequestItem.relationModel] = responseShardItem[nestedRequestItem.relationModel] || [];
                    responseShardItem[nestedRequestItem.relationModel].push(nestResponseItem);
                }
            });
            nestResponsePointer++;
        }
        return originalResponse;
    }
}/**
 * @method redService
 * @param data
 * @param [options]
 * @param [fnProgress]
 */
async function redServicePromised(data, options, fnProgress) {
    if (!data) {
        let error = notifyError("RedServiceError", "data must not be null or undefined", data);
        return Promise.reject(error);
    }
    const requestClone = cloneObject(data);
    const key_tenant_s = await crypto.getKey("key_tenant_s");
    const key_user_s = await crypto.getKey("key_user_s");
    const dManager = DatamodelManager_2.getInstance();
    let encrypted = false;
    const downloadUpToMb = data.options && data.options.downloadUpToMb;
    const getBinaryData = data.options && data.options.getBinaryData;
    const autoDownload = data.options && data.options.autoDownload;
    if (downloadUpToMb) {
        delete data.options.downloadUpToMb;
    }
    if (getBinaryData) {
        delete data.options.getBinaryData;
    }
    if (autoDownload) {
        delete data.options.autoDownload;
    }
    // module >> class
    let data_arr = Array.isArray(data) ? data : [data];
    let i;
    for (i = 0; i < data_arr.length; i += 1) {
        if (!data_arr[i]) {
            throw notifyError("RedServiceError", "data[i] must not be null or undefined", data);
        }
        if (data_arr[i].module) {
            data_arr[i].class = data_arr[i].module;
            delete data_arr[i].module;
        }
    }
    // check for dummy call
    if (data.class === "dummy") {
        return Promise.resolve({ success: true });
    }
    exports.eventDispatcher.dispatchEvent(new InternalMessageEvent(ApiMessageTypes.UserInteraction, {
        data: {
            type: ApiMessageTypes.UserInteraction,
            subtype: "redService"
        }
    }));
    options = options || {};
    checkOptions(options, data);
    if (data.options) {
        options.user_group_id = data.options.user_group_id;
    }
    const session = await getSession();
    if (Array.isArray(data)) {
        for (i = 0; i < data.length; i += 1) {
            data[i].session = data[i].session || session;
            delete data[i].head_search;
        }
    }
    else {
        // Object
        data.session = data.session || session;
        delete data.head_search;
    }
    let classmethod;
    if (data.class && data.method) {
        classmethod = data.class + "/" + data.method;
    }
    let cryptedNestResolver = new CryptedNestResolver();
    let result = {
        uploadResponse: undefined,
        encryptedData: data
    };
    let baseDataCachingRequest = { misses: [] };
    if (dManager.getDatamodel()) {
        if (!!key_tenant_s) {
            encrypted = true;
        }
        try {
            const encryptedResult = await encryptRedObject(classmethod, data, Array.isArray(data), data.options, cryptedNestResolver, fnProgress);
            result = encryptedResult.result;
            baseDataCachingRequest = encryptedResult.baseDataCacheRequest;
        }
        catch (err) {
            let error = notifyError("EncryptError", err.error ? err.error : stringify(err), data);
            return Promise.reject(error);
        }
    }
    else {
        data_arr.forEach((dataItem) => {
            if (!isPermittedWithoutDatamodel(dataItem.class, dataItem.method)) {
                throw { error: "encryption not possible due to missing datamodel", errtag: "error_missing_datamodel" };
            }
        });
    }
    // When creating a new battery with the hogrefe software interface (hsi)
    // The server will write the corresponding pae information into the database.
    // Since the pae data model contains crypto fields, we need to encrypt it here
    async function encryptPaeForHsi(rpcData) {
        if (dManager.getDatamodel()) {
            if (!rpcData.TestSpecs) {
                throw notifyError("invalid data", "TestSpecs must be specified!", rpcData);
            }
            rpcData.TestSpecs = await Promise.all(rpcData.TestSpecs.map(async (dataItem) => {
                if (!dataItem.PatientAkteEintrag) {
                    throw notifyError("invalid data", "TestSpecs must contain pae information!", rpcData);
                }
                const pae = { PatientAkteEintrag: dataItem.PatientAkteEintrag };
                try {
                    const enc = await encryptRedObject("crud/create", pae, Array.isArray(rpcData), rpcData.options, cryptedNestResolver, fnProgress);
                    return Object.assign(Object.assign({}, dataItem), { PatientAkteEintrag: enc.result.encryptedData.PatientAkteEintrag });
                }
                catch (e) {
                    throw notifyError("EncryptError", e.error ? e.error : stringify(e), rpcData);
                }
            }));
        }
        return rpcData;
    }
    async function encryptPaeGetPae(rpcData) {
        if (rpcData.types && Array.isArray(rpcData.types)) {
            rpcData.types = await Promise.all(rpcData.types.map((dataItem) => hashReadCryptoField({
                // Mock field definition
                crypto: true,
                types: "string"
            }, dataItem)));
        }
        if (rpcData.tags && Array.isArray(rpcData.tags)) {
            rpcData.tags = await Promise.all(rpcData.tags.map((dataItem) => hashReadCryptoField({
                // Mock field definition
                crypto: true,
                tags: "string"
            }, dataItem)));
        }
        return rpcData;
    }
    /**
     * SRV-4246: relation fields of a child model that point at `parentModel` and combine `crypto`
     * with `onDeleteCascade`, restricted to those whose value is also stored as a salted hash in
     * `head_search.<path>_c_exact` (`search.indexed: "exact"`) - only those can be compared
     * server-side at all.
     */
    function getExactIndexedCryptoCascadeFields(parentModel) {
        const datamodel = dManager.getDatamodel(), result = [];
        for (const childModel in datamodel) {
            if (!datamodel.hasOwnProperty(childModel)) {
                continue;
            }
            dManager.getRelationValueFields(childModel, parentModel).forEach((field) => {
                var _a, _b;
                const isCrypto = !!(field.crypto || ((_a = field.array) === null || _a === void 0 ? void 0 : _a.crypto)), search = field.search || ((_b = field.array) === null || _b === void 0 ? void 0 : _b.search);
                if (isCrypto && !!field.onDeleteCascade && (search === null || search === void 0 ? void 0 : search.indexed) === "exact") {
                    result.push({ childModel, field });
                }
            });
        }
        return result;
    }
    /**
     * Ident values of the records a crud/delete targets, as far as they are visible in the request.
     * Anything else (delete by head_id, by a non-ident condition, by $regex, ...) yields none - the
     * server then keeps its coarse, fail-closed probe for those records.
     */
    function getTargetedIdentValues(identCondition) {
        if (typeof identCondition === "string" || typeof identCondition === "number") {
            return [String(identCondition)];
        }
        if (typeof identCondition === "object" && identCondition !== null) {
            if (typeof identCondition.$eq === "string" || typeof identCondition.$eq === "number") {
                return [String(identCondition.$eq)];
            }
            if (Array.isArray(identCondition.$in)) {
                return identCondition.$in
                    .filter((item) => typeof item === "string" || typeof item === "number")
                    .map((item) => String(item));
            }
        }
        return [];
    }
    /**
     * SRV-4246: a crypto relation field with onDeleteCascade cannot be resolved by the server - it
     * has neither the tenant key nor the head_search hash salt (Administration.hashSalt is itself
     * crypto and only ever decrypted here in the browser). Its delete-cascade guard therefore falls
     * back to "does ANY child hold a value in that field", which rejects parent deletes that have
     * no dangling child at all - for the mandatory AppointmentTemplate.categoryId that made every
     * AppointmentCategory undeletable (PR #4488, r3810254509).
     *
     * The hash IS reproducible here, so attach hash(identValue) for every parent ident value the
     * request names. The server filters on it, which build-query.service.ts rewrites into
     * `head_search.<path>_c_exact`, and blocks only on children that really point at this parent.
     * Hashed per child field, because the head_search value was written with THAT field's
     * definition (normalization differs by field type).
     */
    async function attachCryptoCascadeIdentHashes(rpcData) {
        var _a;
        if (!dManager.getDatamodel()) {
            return rpcData;
        }
        const identHashes = {};
        for (const modelName of Object.keys(rpcData)) {
            if (!dManager.getModelByNameAndVersion(modelName)) {
                continue;
            }
            const cascadeFields = getExactIndexedCryptoCascadeFields(modelName);
            if (!cascadeFields.length) {
                continue;
            }
            const identField = dManager.getIdentFieldName(modelName);
            const identValues = getTargetedIdentValues((_a = rpcData[modelName]) === null || _a === void 0 ? void 0 : _a[identField]);
            for (const { childModel, field } of cascadeFields) {
                const key = `${childModel}.${field._path}`;
                for (const identValue of identValues) {
                    identHashes[key] = identHashes[key] || {};
                    identHashes[key][identValue] = await hashReadCryptoField(field, identValue);
                }
            }
        }
        if (Object.keys(identHashes).length) {
            rpcData.options = rpcData.options || {};
            rpcData.options.cryptoCascadeIdentHashes = identHashes;
        }
        return rpcData;
    }
    /**
     * Handle encrypted fields in non-crud requests
     * @param rpcData
     */
    function encryptFunctionSpecificFields(rpcData) {
        if (rpcData.class === "hsi" && rpcData.method === "createBattery") {
            return encryptPaeForHsi(rpcData);
        }
        else if (rpcData.class === "pae" && (rpcData.method === "getPae" || rpcData.method === "countPae")) {
            return encryptPaeGetPae(rpcData);
        }
        else if (rpcData.class === "crud" && rpcData.method === "delete") {
            return attachCryptoCascadeIdentHashes(rpcData);
        }
        return rpcData;
    }
    if (result === null || result === void 0 ? void 0 : result.encryptedData) {
        const isTransaction = result.encryptedData.class === "transaction" && result.encryptedData.method === "transaction";
        if (isTransaction) {
            result.encryptedData.transaction = await Promise.all(result === null || result === void 0 ? void 0 : result.encryptedData.transaction.map(encryptFunctionSpecificFields));
        }
        else {
            result.encryptedData = await encryptFunctionSpecificFields(result === null || result === void 0 ? void 0 : result.encryptedData);
        }
    }
    if (options.upload === false) {
        return Promise.resolve({ success: true });
    }
    if (result && result.emptySearchFor !== undefined) {
        return Promise.resolve({
            success: true,
            [result.emptySearchFor]: []
        });
    }
    options.async = true;
    options.req_type = "POST";
    options.data_type = "json";
    options.uri = "service/redservice";
    // if fnProgress --> eventlistener
    if (fnProgress) {
        options.query = options.query || {};
        options.query.id = crypto.random();
        exports.eventDispatcher.addEventListener(options.query.id, (evt) => fnProgress(evt.data), { once: true });
    }
    const data_s = JSON.stringify(result.encryptedData);
    let ajaxResult;
    try {
        ajaxResult = await requestAjax(data_s, options, fnProgress);
    }
    catch (err) {
        let error = notifyError("AJAXError", stringify(err), data);
        return Promise.reject(error);
    }
    injectAjaxResultIntoSocket(result.encryptedData, requestClone, ajaxResult);
    if (!(!dManager.getDatamodel()
        || (!key_tenant_s && !key_user_s)
        || typeof ajaxResult !== "object"
        || options.decrypt === false || encrypted === false)) {
        if (data.options && downloadUpToMb) {
            data.options.downloadUpToMb = downloadUpToMb;
        }
        if (data.options && getBinaryData) {
            data.options.getBinaryData = getBinaryData;
        }
        if (data.options && autoDownload) {
            data.options.autoDownload = autoDownload;
        }
        try {
            await decryptRedObject(ajaxResult, Array.isArray(ajaxResult), data.options, cryptedNestResolver, baseDataCachingRequest);
        }
        catch (err) {
            if (err.errtag && ["error_filesize_too_large", "error_filesize_too_large"].indexOf(err.errtag) !== -1) {
                return Promise.reject(err);
            }
            let error = notifyError("DecryptError", stringify(err), data);
            return Promise.reject(error);
        }
    }
    let result_arr = confirmArray(ajaxResult), x;
    for (x = 0; x < result_arr.length; x += 1) {
        if (result_arr[x].success === false) {
            throw ajaxResult;
        }
    }
    return ajaxResult;
}
async function sendEvent(obj) {
    obj.class = "socket";
    obj.method = "send";
    obj.data = await crypto.encrypt(obj.data);
    obj.crypto = true;
    return redServicePromised(obj);
}// we have to import the file with complete path, because rollup or whoever does not know sh*t about package resolve algorithm
var FileServiceDomain;
(function (FileServiceDomain) {
    FileServiceDomain["Tenant"] = "tenant";
    FileServiceDomain["Base"] = "base";
})(FileServiceDomain || (FileServiceDomain = {}));
/**
 * This interface provides a simple way to communicate with the FileService
 * https://github.com/redmedical/file-service
 * Currently, it provides the possibility to call the deprecated Server-File-API as a Fallback.
 * @see red.file
 */
class FileServiceInterface {
    constructor(domain, owner) {
        this.domain = domain;
        this.owner = owner;
    }
    async init() {
        const result = await redServicePromised({
            class: "jwt-auth",
            method: "fileServiceAuth"
        });
        if (!result.success) {
            throw new Error("Can not get token from server");
        }
        /**
         * set the expiration time to now + 55 min since it is fixed to 1 hour in the file service!
         */
        FileServiceInterface.expirationTime = Date.now() + new Date(Date.now() + 1000 * 60 * 55).getTime();
        FileServiceInterface.token = result.jwt;
        FileServiceInterface.host = result.serviceUrl;
    }
    get tokenExpired() {
        return Date.now() >= FileServiceInterface.expirationTime;
    }
    get isInitialized() {
        return !!FileServiceInterface.token && !!FileServiceInterface.host;
    }
    /**
     * Returns a domain- and owner-specific file-service client
     * @private
     */
    async getClient() {
        if (!this.isInitialized || !this.tokenExpired) {
            await this.init();
        }
        const client = new src.RedFileService(FileServiceInterface.host, FileServiceInterface.token);
        return client.Domain(this.domain, this.owner).useJwt(FileServiceInterface.token);
    }
    async encryptFile(file) {
        const key = await crypto.getKey("key_tenant_s");
        switch (typeof file) {
            case "string":
                const base64 = btoa(file);
                const encrypted = await crypto.encrypt(base64, key, "base64");
                return new Blob([encrypted]);
            default:
                const arBuf = await file.arrayBuffer();
                const uint8 = new Uint8Array(arBuf);
                const contentEncrypted = await crypto.encrypt(uint8, key);
                return new Blob([contentEncrypted]);
        }
    }
    async decryptFile(file, meta, options) {
        var _a;
        try {
            const raw = await file.text();
            /**
             * file.text() resolves to a string like:
             * ------formdata-undici-[some-id]\r\n[some-file-headers]\r\n\r\n[content-of-the-file]\r\n------formdata-undici-[some-id]
             * so we need to strip the content...
             */
            const [txt] = (_a = raw.split("\r\n\r\n")[1]) === null || _a === void 0 ? void 0 : _a.split("\r\n");
            const key = await crypto.getKey("key_tenant_s");
            let decrypted;
            if ((meta === null || meta === void 0 ? void 0 : meta.encoding) === "base64") {
                decrypted = atob(await crypto.decrypt(txt, key, "base64"));
            }
            else {
                decrypted = await crypto.decrypt(txt, key, "unit8array");
            }
            return new Blob([decrypted], { type: (meta === null || meta === void 0 ? void 0 : meta.fileType) || "" });
        }
        catch (e) {
            console.error(e);
        }
    }
    /**
     * Create a new FileMeta Object without uploading the file itself.
     * Creates a "detached" File.
     * This requires the enabled detached mode of the FileService.
     * @param model
     * @param path
     * @param meta
     */
    async createFile(model, path, meta) {
        const client = await this.getClient();
        const result = await client.createFile({ model, path, meta, detach: true });
        return result.fileId;
    }
    /**
     * The usual way to upload files. This will create the meta-data and directly upload the file object.
     * @param model
     * @param path
     * @param file
     * @param allowUnencrypted
     * @param metaInfo
     */
    async upload(model, path, file, metaInfo, allowUnencrypted = false) {
        const client = await this.getClient();
        const confidentialFlag = isConfidential(model);
        if (!allowUnencrypted && !confidentialFlag) {
            throw new Error("Unencrypted file upload not allowed");
        }
        const contentBlob = confidentialFlag
            ? await this.encryptFile(file)
            : new Blob([file]);
        const meta = await client.upload(model, path, contentBlob, metaInfo);
        return meta.fileId;
    }
    /**
     * Upload files async
     * @param model
     * @param path
     * @param file
     * @param allowUnencrypted
     * @param metaInfo
     */
    async uploadAsync(model, path, file, metaInfo, allowUnencrypted = false) {
        const client = await this.getClient();
        const confidentialFlag = isConfidential(model);
        if (!allowUnencrypted && !confidentialFlag) {
            throw new Error("Unencrypted file upload not allowed");
        }
        const contentBlob = confidentialFlag
            ? await this.encryptFile(file)
            : new Blob([file]);
        return client.uploadAsync(model, path, contentBlob, metaInfo);
    }
    async detachedUpload(fileId, file) {
        const client = await this.getClient();
        const meta = await client.File(fileId).meta();
        const contentBlob = isConfidential(meta.model)
            ? await this.encryptFile(file)
            : new Blob([file], { type: file.type });
        const update = await client.File(fileId).detachedUpload(contentBlob);
        return update;
    }
    /**
     * Returns a list of FileMeta-Objects with status "upload" and mode "detached".
     * This will work with new generated files only!
     * @param limit
     * @param skip
     */
    async getDetachedFiles(limit, skip) {
        const client = await this.getClient();
        return client.getDetachedFiles(limit, skip);
    }
    /**
     * Downloads a file from the FileService. If the file does not exist, it will call the legacy File-API.
     * @param fileId
     * @param options
     */
    async download(fileId, options) {
        const client = await this.getClient();
        try {
            const meta = await client.File(fileId).meta();
            const transform = (file) => {
                return this.decryptFile(file, meta.meta, options);
            };
            const transformer = isConfidential(meta.model) ? transform : null;
            const file = await client.File(fileId).download(transformer);
            const result = new Blob([file], { type: meta.meta.fileType });
            result.success = true;
            result.fileId = fileId;
            result.data = await result.text();
            return result;
        }
        catch (e) {
            if (e instanceof FileAPIError_1 && e.kind === FileAPIErrorKind_1.FileNotExistingError) {
                if (options) {
                    return this.downloadFallback(fileId, options);
                }
                else {
                    throw e;
                }
            }
        }
    }
    /**
     * Returns the S3-PresignedUrl to download the file.
     * WARNING: This will not handle content decryption!
     * Use only for non-confidential content!!
     * @param fileId
     */
    async getDownloadUrl(fileId) {
        const client = await this.getClient();
        return client.File(fileId).getDownloadUrl();
    }
    /**
     * Returns The MetaData of an existing File.
     * @param fileId
     * @param options
     */
    async meta(fileId, options) {
        try {
            const client = await this.getClient();
            const result = await client.File(fileId).meta();
            return Object.assign(Object.assign({}, result), { legacy: false });
        }
        catch (e) {
            if (e instanceof FileAPIError_1 && e.kind === FileAPIErrorKind_1.FileNotExistingError) {
                if (options) {
                    const fallbackResult = await this.metaFallback(fileId, options.modelName, options.fieldPath);
                    return Object.assign(Object.assign({}, fallbackResult), { legacy: true });
                }
                else {
                    throw e;
                }
            }
        }
    }
    async metaFallback(fileId, modelName, fieldPath) {
        const result = await fileService({
            method: "getSize",
            fileId,
            modelName,
            fieldPath
        });
        return {
            fileId,
            model: modelName,
            path: fieldPath,
            owner: this.owner,
            domain: this.domain,
            size: result.ContentLength
        };
    }
    async downloadFallback(fileId, options) {
        if (options.isLegacy) {
            return fileService(Object.assign(Object.assign({}, options), { fileId, method: "legacyRead" }), options.fnProgress);
        }
        const response = await fileService(Object.assign(Object.assign({}, options), { fileId, method: "legacyRead", autoDownload: false, getBinaryData: true }));
        if (!response.success) {
            throw new Error(`Can not download file with id ${fileId}. (Download-Fallback)`);
        }
        const content = response.data;
        const result = new File([content], fileId);
        return result;
    }
}
FileServiceInterface.expirationTime = 0;class LicenseReadError extends Error {
    constructor(code, rawMessage, details) {
        const detailsStr = JSON.stringify(details);
        const fullMessage = `${code}: ${rawMessage}${detailsStr ? ` details: ${detailsStr}` : ""}`;
        super(fullMessage);
        this.code = code;
        this.rawMessage = rawMessage;
        this.details = details;
    }
}
class LicenseState {
    clearSession() {
        this._session = undefined;
        sessionStorage.removeItem(STORAGE_KEYS.SESSION.SESSION_LICENSE);
    }
    hasSessionKey() {
        var _a;
        return !!((_a = sessionStorage.getItem(STORAGE_KEYS.SESSION.SESSION_LICENSE)) === null || _a === void 0 ? void 0 : _a.length);
    }
    get current() {
        if (this.hasSessionKey() || this._session) {
            if (!this._session) {
                this._session = JSON.parse(sessionStorage.getItem(STORAGE_KEYS.SESSION.SESSION_LICENSE));
            }
            return this._session;
        }
    }
    async updateSessionLicense() {
        const { success, Administration: [{ License: [license] = [] } = {}] = [] } = await redServicePromised({
            class: "sessions",
            method: "getSessionInformation"
        });
        if (success && (license === null || license === void 0 ? void 0 : license.id)) {
            this._session = license;
            sessionStorage.setItem(STORAGE_KEYS.SESSION.SESSION_LICENSE, JSON.stringify(license));
        }
        else {
            this.clearSession();
            throw new LicenseReadError("session_license_unavailable", "could not update session license");
        }
    }
    get flags() {
        var _a, _b;
        return (_b = (_a = this.current) === null || _a === void 0 ? void 0 : _a.flags) !== null && _b !== void 0 ? _b : {};
    }
    get options() {
        var _a, _b;
        return (_b = (_a = this.current) === null || _a === void 0 ? void 0 : _a.options) !== null && _b !== void 0 ? _b : {};
    }
    enabled(flag) {
        const val = this.flags[flag];
        if (typeof val === "undefined") {
            throw new LicenseReadError("license_flag_undefined", `${flag} is not defined`, {
                current: this.current,
                session: sessionStorage.getItem(STORAGE_KEYS.SESSION.SESSION_LICENSE)
            });
        }
        return val;
    }
    option(option) {
        if (this.options.hasOwnProperty(option)) {
            return this.current.options[option];
        }
        throw new LicenseReadError("license_option_undefined", `${option} is not defined`, {
            current: this.current,
            session: sessionStorage.getItem(STORAGE_KEYS.SESSION.SESSION_LICENSE)
        });
    }
    async getAllLicenses() {
        const response = await fetch("/service/licenses");
        const { success, License: licenses } = await response.json();
        if (success && licenses.length > 0) {
            return licenses;
        }
        else {
            throw new LicenseReadError("session_license_unavailable", "could not get licenses", { success, licenses });
        }
    }
}
const license = () => new LicenseState();class auth {
    static async addRsaKeyPair(tenantRsaKey = false) {
        // generate key pair
        let tmpConnectKeyPair = await crypto.createRSAKeyPair();
        const publicKeyString = await crypto.rsaKeyToString(tmpConnectKeyPair.publicKey);
        const publicKey = await crypto.stringToRsaKey(publicKeyString);
        const privateKeyString = await crypto.rsaKeyToString(tmpConnectKeyPair.privateKey);
        const privateKey = await crypto.stringToRsaKey(privateKeyString);
        const encryptedPrivateKeyString = await crypto.encrypt(privateKeyString);
        tmpConnectKeyPair = null;
        let privKeyField;
        let pubKeyField;
        if (tenantRsaKey) {
            privKeyField = "privateTenantRSAKey";
            pubKeyField = "publicTenantRSAKey";
        }
        else {
            privKeyField = "privateTenantKey";
            pubKeyField = "publicTenantKey";
        }
        return redServicePromised({
            class: "tenant",
            method: "addRsaKeyPair",
            Administration: {
                [privKeyField]: encryptedPrivateKeyString,
                [pubKeyField]: publicKeyString
            }
        }).then(async (result) => {
            if (result.success) {
                if (tenantRsaKey) {
                    await crypto.setKey("key_private_rsa_tenant_s", privateKey);
                }
                else {
                    await Promise.all([
                        crypto.setKey("connectPublicKey", publicKey),
                        crypto.setKey("connectPrivateKey", privateKey)
                    ]);
                }
            }
            return result;
        });
    }
    /**
     * registers a tenant
     * always pass a property captchaSolution to obj. This property verifies you solved the proof-of-work challenge
     * @param obj
     * @param password
     * @param master_password
     * @param callback
     */
    static async register(obj, password, master_password, callback) {
        const salt = crypto.random();
        obj.Tenant.salt = crypto.random();
        const rawUserKey = await crypto.derivateKey(password, salt);
        let tmpUserKey = await crypto.derivateKey(password, salt, crypto.derivate_key_it, true);
        let userKeyString = await crypto.aesKeyToString(tmpUserKey);
        const symmetricUserKeyHash = await crypto.hash(userKeyString, userKeyString);
        tmpUserKey = null;
        userKeyString = null;
        const rawTenantKey = await crypto.derivateKey(master_password, obj.Tenant.salt);
        let tmpTenantKey = await crypto.derivateKey(master_password, obj.Tenant.salt, crypto.derivate_key_it, true);
        const tenantKeyString = await crypto.aesKeyToString(tmpTenantKey);
        obj.Tenant.masterPasswordEnc = await crypto.encrypt(master_password, rawTenantKey);
        obj.Tenant.masterPasswordHash = await crypto.hash(master_password, obj.Tenant.salt);
        obj.hashSalt = await crypto.encrypt(crypto.random(), rawTenantKey);
        tmpTenantKey = null;
        const encryptedTenantKey = await crypto.encrypt(tenantKeyString, rawUserKey);
        let tmpRsaKeyPair = await crypto.createRSAKeyPair();
        const publicKeyString = await crypto.rsaKeyToString(tmpRsaKeyPair.publicKey);
        const privateKeyString = await crypto.rsaKeyToString(tmpRsaKeyPair.privateKey);
        const privateKey = await crypto.stringToRsaKey(privateKeyString);
        tmpRsaKeyPair = null;
        const encryptedPrivateRSAKeyStringWithTenantKey = await crypto.encrypt(privateKeyString, rawTenantKey);
        obj.class = "auth";
        obj.method = "register";
        obj.User.salt = salt;
        obj.User.symmetricUserKeyHash = symmetricUserKeyHash;
        obj.User.symmetricTenantKey = encryptedTenantKey;
        obj.privateTenantRSAKey = encryptedPrivateRSAKeyStringWithTenantKey;
        obj.publicTenantRSAKey = publicKeyString;
        // add value here to prevent having to change a lot SI tests
        obj.captchaSolution = obj.captchaSolution || "!changeme-captcha!";
        return redServicePromised(obj)
            .then(async (result) => {
            if (result.success) {
                // set new user id for using it primarily in createUserWithData() method
                sessionStorage.setItem(STORAGE_KEYS.SESSION.USER_ID, result.User[0].id);
                await Promise.all([
                    crypto.setKey("key_user_s", rawUserKey),
                    crypto.setKey("key_tenant_s", rawTenantKey),
                    crypto.setKey("key_private_rsa_tenant_s", privateKey)
                ]);
                auth.setDeviceId(result.session.deviceId);
            }
            return result;
        });
    }
    static async createUserWithData(obj, password, requestArray, authorUserGroupId, eventName, callback) {
        var salt = crypto.random();
        const rawUserKey = await crypto.derivateKey(password, salt);
        let tmpUserKey = await crypto.derivateKey(password, salt, crypto.derivate_key_it, true);
        let userKeyString = await crypto.aesKeyToString(tmpUserKey);
        const symmetricUserKeyHash = await crypto.hash(userKeyString, userKeyString);
        tmpUserKey = null;
        userKeyString = null;
        const keys = (await redServicePromised({ class: "auth", method: "getKeys" }));
        const ownUserKey = await crypto.getKey("key_user_s");
        let key_tenant_s = await crypto.decrypt(keys.symmetricTenantKey, ownUserKey);
        const encryptedTenantKey = await crypto.encrypt(key_tenant_s, rawUserKey);
        key_tenant_s = null;
        const transaction = {
            class: "transaction",
            method: "transaction",
            transaction: requestArray,
            options: {
                socket: {
                    type: "transaction",
                    subtype: eventName
                }
            }
        };
        obj.class = "auth";
        obj.method = "create_user";
        obj.User.salt = salt;
        obj.User.symmetricUserKeyHash = symmetricUserKeyHash;
        obj.User.symmetricTenantKey = encryptedTenantKey;
        if (authorUserGroupId) {
            obj.options = obj.options || {};
            obj.options.user_group_id = authorUserGroupId;
        }
        if (requestArray) {
            // add user_group_id to all transactions!
            if (authorUserGroupId) {
                for (var x = 0; x < requestArray.length; x++) {
                    requestArray[x].options = requestArray[x].options || {};
                    requestArray[x].options.user_group_id = authorUserGroupId;
                }
            }
            // if we have additional request, put obj before them in transaction array
            transaction.transaction.unshift(obj);
        }
        // if we have additional request, send a transaction, otherwise a standard auth request
        return redServicePromised(requestArray ? transaction : obj);
    }
    static createUser(obj, password, authorUserGroupId, callback) {
        return auth.createUserWithData(obj, password, undefined, authorUserGroupId);
    }
    /**
     *
     * @param {EventListener | null} socketListener - socketListener - A socketListener can be passed here.
     * If no socketListener should be used, pass null as auth parameter is not optional
     * @param {IServerCallback} callback - Deprecated!
     * @returns {Promise<IServerResponse | Array<IServerResponse>>}
     */
    static async isLoggedIn(socketListener, callback) {
        let command = {
            "class": "auth",
            method: "isloggedin"
        };
        const redServiceResult = await redServicePromised(command)
            .catch((err) => {
            if (exports.eventDispatcher) {
                exports.eventDispatcher.close();
            }
            setDatamodel(null);
            if ((err === null || err === void 0 ? void 0 : err.errtag) === "error_tenant_terminated") {
                return auth.logout()
                    .then(() => Promise.reject(err))
                    .catch(() => Promise.reject(err));
            }
            return Promise.reject(err);
        });
        if (redServiceResult.success) {
            if (!exports.eventDispatcher.isConnected) {
                await exports.eventDispatcher.connect(sessionStorage.getItem(STORAGE_KEYS.SESSION.SESSION_ID));
            }
            await Promise.all([
                auth.setKeys(await crypto.getKey("key_user_s")),
                loadDatamodel()
            ]);
            return redServiceResult;
        }
        else {
            if (exports.eventDispatcher) {
                exports.eventDispatcher.close();
            }
            setDatamodel(null);
            return redServiceResult;
        }
    }
    /**
     * Logs a user in.
     * @param tenant_alias - Alias of the tenent
     * @param user_alias - Alias of the user
     * @param password - The users password
     * @param captchaSolution
     * @param analyticsPayload
     * @param socketListener - A socketListener can be passed here. If no socketListener should be used, pass null as auth parameter is not optional.
     * @param callback
     */
    static async login(tenant_alias, user_alias, password, captchaSolution, socketListener, analyticsPayload = {}, callback) {
        const getAppVersionResult = await redServicePromised({
            "class": "auth",
            method: "getAppVersion",
            tenantAlias: tenant_alias
        });
        if (!getAppVersionResult.success) {
            return getAppVersionResult;
        }
        await indexedDB.write(exports.ObjectStoreNames.RED_APP_VERSION, { id: "appVersion", version: getAppVersionResult.version });
        const getSaltResult = await redServicePromised({
            "class": "auth",
            method: "get_salt",
            Tenant: {
                alias: tenant_alias
            },
            User: {
                alias: user_alias
            }
        });
        if (!getSaltResult.success) {
            return getSaltResult;
        }
        const salt = getSaltResult.User[0].salt;
        sessionStorage.setItem(STORAGE_KEYS.SESSION.SALT, salt);
        const rawUserKey = await crypto.derivateKey(password, salt);
        let tmpUserKey = await crypto.derivateKey(password, salt, crypto.derivate_key_it, true);
        let userKeyString = await crypto.aesKeyToString(tmpUserKey);
        const symmetricUserKeyHash = await crypto.hash(userKeyString, userKeyString);
        tmpUserKey = null;
        userKeyString = null;
        return redServicePromised(Object.assign(Object.assign({ "class": "auth", method: "login", Tenant: {
                "alias": tenant_alias
            }, User: {
                "alias": user_alias,
                symmetricUserKeyHash: symmetricUserKeyHash
            }, user_agent: analyticsPayload.userAgent || navigator.userAgent || null }, (analyticsPayload.redAgentVersion ? { red_agent_version: analyticsPayload.redAgentVersion } : {})), { captchaSolution }))
            .then(async (result) => {
            var _a, _b;
            if (result.success) {
                sessionStorage.setItem(STORAGE_KEYS.SESSION.USER_ALIAS, user_alias);
                sessionStorage.setItem(STORAGE_KEYS.SESSION.USER_ID, result.user.id);
                sessionStorage.setItem(STORAGE_KEYS.SESSION.SESSION_ID, result.session.session_id);
                if (result.session.terminal_id) {
                    sessionStorage.setItem(STORAGE_KEYS.SESSION.TERMINAL_ID, result.session.terminal_id);
                }
                else {
                    sessionStorage.removeItem(STORAGE_KEYS.SESSION.TERMINAL_ID);
                }
                await auth.setKeys(rawUserKey);
                auth.setDeviceId(result.session.deviceId);
                await exports.eventDispatcher.connect(result.session.session_id);
                await loadDatamodel();
                if ((_a = result.administration.datamodelVersion) === null || _a === void 0 ? void 0 : _a.test) {
                    console.error(`WARNING: This tenant is locked in Test-Datamodel version ${result.administration.datamodelVersion.major}.${result.administration.datamodelVersion.minor}.${result.administration.datamodelVersion.patch} (${result.administration.datamodelVersion.test})!`);
                }
                if (!((_b = result.terminal) === null || _b === void 0 ? void 0 : _b.error) && result.session.terminal_id) {
                    // If there is no authorized terminal, we cannot write a hash salt and an RSA key pair
                    let hashSalt;
                    if (result.administration.hashSalt) {
                        hashSalt = await crypto.decrypt(result.administration.hashSalt);
                    }
                    else {
                        hashSalt = crypto.random();
                        let hashSaltEnc = await crypto.encrypt(hashSalt);
                        await redServicePromised({
                            class: "tenant",
                            method: "createHashSalt",
                            Administration: {
                                hashSalt: hashSaltEnc
                            },
                            options: {
                                user_group_id: result.user.memberOf[0]
                            }
                        });
                    }
                    sessionStorage.setItem(STORAGE_KEYS.SESSION.HASH_SALT, hashSalt);
                    if (result.administration.privateTenantRSAKey) {
                        const decryptedRSAPrivateKeyString = await crypto.decrypt(result.administration.privateTenantRSAKey, undefined, "string");
                        const decryptedRSAPrivateKey = await crypto.stringToRsaKey(decryptedRSAPrivateKeyString);
                        await crypto.setKey("key_private_rsa_tenant_s", decryptedRSAPrivateKey);
                    }
                    else {
                        const rsaResult = await auth.addRsaKeyPair(true);
                        if (!rsaResult.success) {
                            throw Error("Cannot create new key pair");
                        }
                    }
                }
                await license().updateSessionLicense();
                return {
                    success: result.success,
                    passwordIsReset: result.passwordIsReset,
                    useRedAgent: result.administration.useRedAgent
                };
            }
            else {
                setDatamodel(null);
                return Promise.resolve(result);
            }
        })
            .catch((err) => {
            setDatamodel(null);
            if ((err === null || err === void 0 ? void 0 : err.errtag) === "error_tenant_terminated") {
                return auth.logout()
                    .then(() => Promise.reject(err))
                    .catch(() => Promise.reject(err));
            }
            return Promise.reject(err);
        });
    }
    static async setKeys(rawUserKey) {
        let decryptedKeyTenant;
        const keyMapping = {
            key_tenant_s: "symmetricTenantKey"
        };
        const keyNames = Object.keys(keyMapping);
        const keyRequests = keyNames.map(keyName => crypto.getKey(keyName));
        const keys = await Promise.all(keyRequests);
        [decryptedKeyTenant] = keys;
        let missingKeys = [];
        keys.forEach((key, i) => {
            if (!key) {
                missingKeys.push(keyMapping[keyNames[i]]);
            }
        });
        if (missingKeys.length) {
            const keysResult = (await redServicePromised({
                class: "auth",
                method: "getKeys",
                keys: missingKeys
            }));
            if (!decryptedKeyTenant) {
                const decryptedKeyTenantString = await crypto.decrypt(keysResult.symmetricTenantKey, rawUserKey, "string");
                decryptedKeyTenant = await crypto.stringToAesKey(decryptedKeyTenantString);
            }
        }
        await Promise.all([
            crypto.setKey("key_user_s", rawUserKey), // save key with new user id from login result, which is set in sessionStorage
            crypto.setKey("key_tenant_s", decryptedKeyTenant)
        ]);
    }
    static async updateTerminalId(callback) {
        const session = await getSession();
        if (session.deviceId && session.terminal_id_connector
            && session.deviceId !== session.terminal_id_connector) {
            return redServicePromised({
                "class": "terminal",
                method: "updateDeviceIdInDatabase",
                session: session,
                deviceId: session.terminal_id_connector
            }).then((res) => {
                localStorage.removeItem(STORAGE_KEYS.LOCAL.DEVICE_ID);
                auth.setDeviceId(session.terminal_id_connector);
                return res;
            });
        }
        return Promise.resolve({
            success: false,
            error: "terminal id did not change"
        });
    }
    static setDeviceId(id) {
        if (!exports.terminalIdentifier) {
            localStorage.setItem(STORAGE_KEYS.LOCAL.DEVICE_ID, id);
        }
    }
    static lock(callback) {
        return redServicePromised({
            class: "auth",
            method: "lock"
        });
    }
    static async unlock(password, callback) {
        let userKey = await crypto.derivateKey(password, sessionStorage.getItem(STORAGE_KEYS.SESSION.SALT), crypto.derivate_key_it, true);
        let keyUserS = await crypto.aesKeyToString(userKey);
        const symmetricUserKeyHash = await crypto.hash(keyUserS, keyUserS);
        userKey = null;
        keyUserS = null;
        return redServicePromised({
            class: "auth",
            method: "unlock",
            symmetricUserKeyHash: symmetricUserKeyHash
        });
    }
    /**
     * Changes the users password
     * @param tenant_alias - alias of the users tenant
     * @param user_alias - alias of the user
     * @param password - the currect users password
     * @param userGroupId - the userGroupId with which the change should be written
     * @param new_password - the new password
     */
    static async changePassword(tenant_alias, user_alias, password, new_password, userGroupId, callback) {
        const getSaltResult = await redServicePromised({
            "class": "auth",
            method: "get_salt",
            Tenant: {
                alias: tenant_alias
            },
            User: {
                alias: user_alias
            }
        });
        if (!getSaltResult.success) {
            return getSaltResult;
        }
        const salt = getSaltResult.User[0].salt;
        let symmetricUserKeyHash;
        if (password) { // admin user is allowed to change password without old password
            let tmpUserKey = await crypto.derivateKey(password, salt, crypto.derivate_key_it, true);
            let userKeyString = await crypto.aesKeyToString(tmpUserKey);
            symmetricUserKeyHash = await crypto.hash(userKeyString, userKeyString);
            tmpUserKey = null;
            userKeyString = null;
        }
        const newRawUserKey = await crypto.derivateKey(new_password, salt);
        let tmpNewRawUserKey = await crypto.derivateKey(new_password, salt, crypto.derivate_key_it, true);
        let newUserKeyString = await crypto.aesKeyToString(tmpNewRawUserKey);
        const new_symmetricUserKey = await crypto.hash(newUserKeyString, newUserKeyString);
        tmpNewRawUserKey = null;
        newUserKeyString = null;
        const checkCredentialsCommand = {
            class: "auth",
            method: "checkCredentials",
            Tenant: {
                alias: tenant_alias
            },
            User: {
                alias: user_alias
            }
        };
        if (password) {
            checkCredentialsCommand.User.symmetricUserKeyHash = symmetricUserKeyHash;
        }
        const checkCredentialsResult = await redServicePromised(checkCredentialsCommand);
        if (!checkCredentialsResult.success) {
            return checkCredentialsResult;
        }
        const keys = (await redServicePromised({ class: "auth", method: "getKeys" }));
        const ownUserKey = await crypto.getKey("key_user_s");
        let tenantKeyString = await crypto.decrypt(keys.symmetricTenantKey, ownUserKey);
        const encryptedTenantKey = await crypto.encrypt(tenantKeyString, newRawUserKey);
        tenantKeyString = null;
        const redServiceCommandObject = {
            class: "auth",
            method: "change_password",
            Tenant: {
                alias: tenant_alias
            },
            User: {
                alias: user_alias
            },
            keys: {
                symmetricUserKeyHash: new_symmetricUserKey,
                symmetricTenantKey: encryptedTenantKey
            },
            options: {
                user_group_id: userGroupId
            }
        };
        if (password) {
            redServiceCommandObject.User.symmetricUserKeyHash = symmetricUserKeyHash;
        }
        return redServicePromised(redServiceCommandObject);
    }
    /**
     * Resets the users password
     * @param tenantAlias - alias of the users tenant
     * @param userAlias - alias of the user
     */
    static async resetPasswordRequest(tenantAlias, userAlias) {
        const command = {
            class: "auth",
            method: "reset_password_request",
            tenantAlias,
            userAlias
        };
        return redServicePromised(command);
    }
    /**
     * Resets the users password
     * @param tenantAlias - alias of the users tenant
     * @param tenantSalt - token of the users tenant
     * @param userAlias - alias of the user
     * @param masterPassword - the master password of tenant registration user
     * @param newPassword - the new password for user
     * @param token - the token from url parameter -> ?t=<token>
     */
    static async resetPassword(tenantAlias, tenantSalt, userAlias, masterPassword, newPassword, token) {
        const getSaltResult = await redServicePromised({
            "class": "auth",
            method: "get_salt",
            Tenant: {
                // @ts-ignore
                alias: tenantAlias
            },
            User: {
                alias: userAlias
            }
        });
        if (!getSaltResult.success) {
            return getSaltResult;
        }
        const salt = getSaltResult.User[0].salt;
        let tmpTenantKey = await crypto.derivateKey(masterPassword, tenantSalt, crypto.derivate_key_it, true);
        const tenantKeyString = await crypto.aesKeyToString(tmpTenantKey);
        const rawUserKey = await crypto.derivateKey(newPassword, salt);
        let tmpNewRawUserKey = await crypto.derivateKey(newPassword, salt, crypto.derivate_key_it, true);
        let newUserKeyString = await crypto.aesKeyToString(tmpNewRawUserKey);
        const newSymmetricUserKey = await crypto.hash(newUserKeyString, newUserKeyString);
        tmpNewRawUserKey = null;
        const encryptedTenantKey = await crypto.encrypt(tenantKeyString, rawUserKey);
        const masterPasswordHash = await crypto.hash(masterPassword, tenantSalt);
        newUserKeyString = null;
        const command = {
            class: "auth",
            method: "reset_password",
            symmetricUserKeyHash: newSymmetricUserKey,
            symmetricTenantKey: encryptedTenantKey,
            masterPasswordHash,
            token
        };
        return redServicePromised(command);
    }
    static async checkPassword(password, callback) {
        var salt = sessionStorage.getItem(STORAGE_KEYS.SESSION.SALT), key_user_s;
        if (!salt) {
            return Promise.reject("not logged in");
        }
        key_user_s = await crypto.derivateKey(password, salt);
        let key = await crypto.getKey("key_user_s");
        if (key_user_s === key) {
            return { success: true };
        }
        else {
            return { success: false };
        }
    }
    /**
     * Log out the current user
     */
    static logout(callback) {
        return redServicePromised({
            "class": "auth",
            method: "logout"
        })
            .then((result) => {
            if (result.success) {
                auth.clearAfterLogout();
            }
            setDatamodel(null);
            return result;
        })
            .catch((err) => {
            setDatamodel(null);
            auth.clearAfterLogout();
            return Promise.reject(err);
        });
    }
    /**
     * Clear session storage, socket connection, listeners and timers on client-side after logout
     * @internal ONLY for internal use
     */
    static clearAfterLogout() {
        sessionStorage.clear();
        if (exports.eventDispatcher) {
            exports.eventDispatcher.clear();
        }
    }
    static async isBetaRegistrationEnabled() {
        const { enableBetaRegistration } = await redServicePromised({
            class: "auth",
            method: "isBetaRegistrationEnabled"
        });
        return enableBetaRegistration;
    }
}
__decorate([
    hybridCallbackPromise()
], auth, "register", null);
__decorate([
    hybridCallbackPromise()
], auth, "createUserWithData", null);
__decorate([
    hybridCallbackPromise()
], auth, "createUser", null);
__decorate([
    hybridCallbackPromise(true)
], auth, "isLoggedIn", null);
__decorate([
    hybridCallbackPromise(true)
], auth, "login", null);
__decorate([
    hybridCallbackPromise()
], auth, "updateTerminalId", null);
__decorate([
    hybridCallbackPromise()
], auth, "lock", null);
__decorate([
    hybridCallbackPromise()
], auth, "unlock", null);
__decorate([
    hybridCallbackPromise()
], auth, "changePassword", null);
__decorate([
    hybridCallbackPromise()
], auth, "checkPassword", null);
__decorate([
    hybridCallbackPromise()
], auth, "logout", null);
addStaticEventListener("logout" /* SocketMessageTypes.Logout */, (evt) => {
    console.log("logout triggered!");
    auth.clearAfterLogout();
}, { skipDecryptRedObject: true });/**
 * module for browser-side migrations
 * those migrations come into play, when encrypted data needs to be manipulated or search indexed
 */
exports.migration=void 0;
(function (migration_1) {
    /**
     * the kind of message
     */
    let MessageKind;
    (function (MessageKind) {
        /// signal for migrating a data item
        MessageKind["MIGRATE"] = "migrate";
        /// signal for completing the whole migration and stopping the worker
        MessageKind["FINISH"] = "finish";
    })(MessageKind || (MessageKind = {}));
    const migrationMessageHandlers = {
        [MessageKind.MIGRATE]: migrate,
        [MessageKind.FINISH]: finish
    };
    /**
     * Event for Migration Messages
     * Consists of internal data/source and the migration identifier
     */
    class MigrationMessageEvent extends Event {
        constructor(source, migration) {
            super(source.type);
            this.source = source;
            this.migration = migration;
        }
        get data() {
            return this.source.data;
        }
    }
    /**
     * Event for Migration Start
     * Consists of internal data/source and the migration identifier
     */
    class MigrationWorkerStartedEvent extends Event {
        constructor(source, migration) {
            super(source.type);
            this.source = source;
            this.migration = migration;
        }
        get data() {
            return this.source.data;
        }
    }
    /**
     * Event for Migration Error
     * Consists of the original ErrorEvent and the migration identifier
     */
    class MigrationErrorEvent extends Event {
        constructor(source, migration) {
            super(source.type);
            this.source = source;
            this.migration = migration;
        }
    }
    /**
     * Error for Worker Response-Timeouts
     * Consists of the expected message and the timeout that was exceeded
     */
    class ResponseTimeoutError extends Error {
        constructor(expectation, timeout = 2000) {
            super();
            this.expectation = expectation;
            this.timeout = timeout;
            this.message = `Did not receive expected message within ${timeout} milliseconds`;
        }
    }
    /**
     * Event for Worker Response-Timeouts
     * Consists of the ResponseTimeoutError and a text description of the phase that could not be completed
     */
    class ResponseTimeoutErrorEvent extends Event {
        constructor(responseTimeoutError, when) {
            super("responseTimeout");
            this.responseTimeoutError = responseTimeoutError;
            this.when = when;
        }
    }
    /**
     * Waits for response of a worker, meeting expected structure.
     * Every property has to be equal (===) to the expectation.
     * Currently, this is only checked on the first level!
     * If there are additional properties to expectation, they are ignored
     * @param worker
     * @param expectation
     * @param timeout error after not receiving expected response for this amount of milliseconds
     * @private
     */
    function waitForResponse(worker, expectation, timeout = 2000) {
        return new Promise((resolve, reject) => {
            const onMessage = (event) => {
                const { data } = event;
                for (const key in expectation) {
                    if (expectation.hasOwnProperty(key)) {
                        if ((data === null || data === void 0 ? void 0 : data[key]) !== expectation[key]) {
                            return;
                        }
                    }
                }
                worker.removeEventListener("message", onMessage);
                resolve(event);
            };
            worker.addEventListener("message", onMessage);
            setTimeout(() => {
                worker.removeEventListener("message", onMessage);
                reject(new ResponseTimeoutError(expectation, timeout));
            }, timeout);
        });
    }
    migration_1.waitForResponse = waitForResponse;
    /**
     * Worker Registry to be able to run multiple workers in parallel someday.
     * Keeps track of status of running workers and initializes them.
     * Also the error handling is done here.
     * Any event the worker may send is wrapped and re-emitted including the migration identifier.
     */
    class WorkerRegistry extends EventTarget {
        constructor(options = {}) {
            super();
            this.registry = new Map();
            this.options = Object.assign(Object.assign({}, WorkerRegistry.DEFAULT_OPTIONS), options);
        }
        /**
         * get amount of running workers
         *
         * Unfortunately, we cannot define this function as getter because our Testclient Angular version dies not support this
         *
         * MISSING:
         * Replace it with a getter after updating the test client
         */
        getSize() {
            return this.registry.size;
        }
        /**
         * can we start another worker?
         *
         * Unfortunately, we cannot define this function as getter because our Testclient Angular version dies not support this
         *
         * MISSING:
         * Replace it with a getter after updating the test client
         */
        isSlotsAvailable() {
            return this.options.maxWorkers > this.getSize();
        }
        /**
         * is the worker of migration currently running
         * @param migration
         */
        isRunning(migration) {
            return this.registry.has(migration);
        }
        /**
         * starts a migration worker if it is not already running
         * it tries to load the worker from <base-url>/<migration-id>/worker
         * all messages sent by the worker are re-emitted
         * the worker needs to receive and respond to "init" with "initialized" event
         * @param migration migration identifier
         * @param content message content for current migrate event - used for initialization
         * @see MigrationMessageEvent
         * @see WorkerRegistry.onError
         */
        async start(migration, content) {
            if (this.isRunning(migration)) {
                return;
            }
            if (!this.isSlotsAvailable()) {
                throw new Error("No slots available");
            }
            const baseUrl = this.options.baseUrl instanceof URL ? this.options.baseUrl : new URL(this.options.baseUrl);
            const url = new URL(baseUrl);
            url.searchParams.set("id", migration);
            const worker = new Worker(url);
            // register all possible worker events
            worker.onerror = (errorEvent) => this.onerror(migration, errorEvent);
            worker.onmessageerror = (errorEvent) => this.dispatchEvent(errorEvent);
            worker.onmessage = (messageEvent) => this.dispatchEvent(new MigrationMessageEvent(messageEvent, migration));
            worker.postMessage({
                type: "init",
                data: content
            });
            try {
                const response = await waitForResponse(worker, { type: "initialized" });
                this.registry.set(migration, worker);
                this.dispatchEvent(new MigrationWorkerStartedEvent(response, migration));
            }
            catch (err) {
                this.handleResponseTimeoutError(err);
                throw err;
            }
        }
        /**
         * handles worker error events
         * @param migration
         * @param error
         */
        async onerror(migration, error) {
            this.registry.delete(migration);
            this.dispatchEvent(new MigrationErrorEvent(error, migration));
        }
        /**
         * handles respondTimeoutErrors
         * @param err
         */
        handleResponseTimeoutError(err) {
            console.error(err);
            if (err instanceof ResponseTimeoutError) {
                this.dispatchEvent(new ResponseTimeoutErrorEvent(err, "stop"));
            }
            else {
                this.dispatchEvent(new ErrorEvent("WorkerError"));
            }
        }
        /**
         * stop migration worker
         * this sends a "stop" message to the worker and waits for a "end" response
         * it terminates the worker if it did not receive an "end"-response
         * @param migration
         */
        async stop(migration) {
            if (!this.postMessage(migration, { type: "stop" })) {
                console.warn(`Migration ${migration} is not running`);
                return;
            }
            try {
                await this.waitForResponse(migration, { type: "end" });
            }
            catch (err) {
                this.handleResponseTimeoutError(err);
                const worker = this.registry.get(migration);
                worker === null || worker === void 0 ? void 0 : worker.terminate();
            }
            finally {
                this.registry.delete(migration);
            }
        }
        /**
         * sends a message to migration worker
         * calls Worker.postMessage on the underlying Worker instance
         * returns true if the message has been sent to worker
         * @param migration
         * @param message
         * @returns boolean true if worker was available for sending a message, false otherwise
         * @see Worker.postMessage
         */
        postMessage(migration, message) {
            if (!this.isRunning(migration)) {
                return false;
            }
            const worker = this.registry.get(migration);
            worker.postMessage(message);
            return true;
        }
        /**
         * awaits a matching response in given migration worker identified by id
         * @param migration id of running migration
         * @param expectation expected message prototype
         * @param timeout maximum amount of time before rejecting
         * @see waitForResponse
         */
        waitForResponse(migration, ...args) {
            if (!this.isRunning(migration)) {
                throw new Error(""); // TODO: create error type
            }
            const worker = this.registry.get(migration);
            return waitForResponse(worker, ...args);
        }
    }
    WorkerRegistry.DEFAULT_OPTIONS = {
        maxWorkers: 1,
        baseUrl: new URL("/service/migration/worker", location.href)
    };
    migration_1.WorkerRegistry = WorkerRegistry;
    const { migrationWorkerRegistryOptions } = window;
    /**
     * public migration worker registry
     */
    migration_1.migrationWorkerRegistry = new WorkerRegistry(migrationWorkerRegistryOptions || {});
    async function finish(message) {
        const migration = message.data.migration;
        if (migration_1.migrationWorkerRegistry.postMessage(migration, { type: "finish", data: message.data })) {
            /*
             * MISSING: SRV-2102
             * reply to server, that the worker already finished before receiving the finish
             * red.redServicePromised({class:..., method: ..., type: error, reasonCode: "early-exit", ...})
             */
            return;
        }
        try {
            await migration_1.migrationWorkerRegistry.waitForResponse(migration, { type: "finished" });
            /*
             * MISSING: SRV-2102
             * reply to server, that the worker affirmed finish
             * red.redServicePromised({class:..., method: ..., type: finish-affirmed, ...})
             */
        }
        catch (err) {
            await migration_1.migrationWorkerRegistry.stop(migration);
        }
    }
    migration_1.finish = finish;
    /**
     * handle migrate message sent to migrate one data item
     * this starts the worker if it is not already running
     * it posts a message and waits for a acknowledgement message "migrate-start"
     * @param message
     * @private
     */
    async function migrate(message) {
        const migration = message.data.migration;
        if (!migration_1.migrationWorkerRegistry.isRunning(migration)) {
            await migration_1.migrationWorkerRegistry.start(migration, message.data);
        }
        migration_1.migrationWorkerRegistry.postMessage(migration, {
            type: "migrate",
            data: message.data
        });
        try {
            await migration_1.migrationWorkerRegistry.waitForResponse(migration, {
                type: "migrate-start"
            });
        }
        catch (err) {
            /*
             * MISSING: SRV-2102
             * reply to server, that migration was sent to
             */
        }
    }
    migration_1.migrate = migrate;
    /**
     * handle any message type, that could not be handled
     * @private
     */
    async function onUnknownMessage(message) {
        console.error("Could not handle migration message");
        console.error(message);
        /*
         * MISSING: SRV-2102, optional
         * reply to server, that server sent a message that was not handleable
         */
    }
    async function onMigration(message) {
        var _a;
        const kind = ((_a = message === null || message === void 0 ? void 0 : message.data) === null || _a === void 0 ? void 0 : _a.kind) || "";
        const handler = migrationMessageHandlers[kind];
        if (!handler) {
            await onUnknownMessage(message);
            return;
        }
        await handler(message);
    }
    migration_1.onMigration = onMigration;
    addStaticEventListener("migration", (evt) => {
        onMigration(evt.data);
    }, { skipDecryptRedObject: true });
})(exports.migration || (exports.migration = {}));/**
 * Client-side API for the analytics RPC endpoint.
 * Sends analytics events from the browser to the backend for processing.
 */
class analytics {
    /**
     * Sends an analytics event to the backend.
     *
     * The backend validates the event_type against a server-side allowlist
     * (config: analytics.externalEventTypes) and processes it asynchronously.
     *
     * @param eventType - The event type identifier. Must be in the server-side allowlist.
     * @param payload   - Optional free-form payload object with zero or more keys.
     * @returns A promise resolving to {success: true} on acceptance.
     */
    static write(eventType, payload) {
        redServicePromised({
            class: "analytics",
            method: "trackEvent",
            event_type: eventType,
            payload
        }).catch(error => {
            // Make a best effort to log errors, but don't let them propagate to callers since analytics is fire-and-forget
            console.debug(`analytics.write failed for event_type "${eventType}"`, error);
        });
    }
}class IdGenerator {
    getNewId() {
        return crypto.random(12, true).replace(/\+/g, "_").replace(/\//g, "$");
    }
    /**
     * Returns a timestamped random string that is compatible to mongodb.ObjectId
     * @returns {string}
     */
    getNewHeadId() {
        var rand = Math.random().toString().substr(2, 11);
        rand = rand + new Array(12 - rand.length).join("0");
        return (Number(new Date()) - 0).toString() + rand;
    }
}
// Todo only for backwards compatibility, move into separate API  definition
function getNewHeadId() {
    return new IdGenerator().getNewHeadId();
}
// Todo only for backwards compatibility, move into separate API  definition
function getNewId() {
    return new IdGenerator().getNewId();
}const file = {
    tenant: (tenantId) => new FileServiceInterface(FileServiceDomain.Tenant, tenantId),
    base: () => new FileServiceInterface(FileServiceDomain.Base, "0")
};exports.EventDispatcher=EventDispatcher;exports.FileId=FileId;exports.IdGenerator=IdGenerator;exports.IndexedDBWrapper=IndexedDBWrapper;exports.InternalMessageEvent=InternalMessageEvent;exports.KoelnerPhonetik=KoelnerPhonetik;exports.LicenseReadError=LicenseReadError;exports.Log=Log;exports.SYM_ENCRYPTED_FILTER=SYM_ENCRYPTED_FILTER;exports.SearchData=SearchData;exports.StringUtils=StringUtils;exports.addStaticEventListener=addStaticEventListener;exports.analytics=analytics;exports.arrayContains=arrayContains;exports.auth=auth;exports.checkOptions=checkOptions;exports.cloneObject=cloneObject;exports.confirmArray=confirmArray;exports.crypto=crypto;exports.decryptRedObject=decryptRedObject;exports.encryptRedObject=encryptRedObject;exports.fieldCheck=fieldCheck;exports.file=file;exports.fileService=fileService;exports.fileServiceGetSize=fileServiceGetSize;exports.getDatamodel=getDatamodel;exports.getNewHeadId=getNewHeadId;exports.getNewId=getNewId;exports.getSession=getSession;exports.getTenantId=getTenantId;exports.hashReadCryptoField=hashReadCryptoField;exports.indexedDB=indexedDB;exports.initEventDispatcher=initEventDispatcher;exports.initializeSession=initializeSession;exports.injectAjaxResultIntoSocket=injectAjaxResultIntoSocket;exports.isConfidential=isConfidential;exports.isPermittedWithoutDatamodel=isPermittedWithoutDatamodel;exports.license=license;exports.loadDatamodel=loadDatamodel;exports.mergeObjects=mergeObjects;exports.notifyError=notifyError;exports.redService=redService;exports.redServicePromised=redServicePromised;exports.removeEntryByKey=removeEntryByKey;exports.requestAjax=requestAjax;exports.requestQueueSize=requestQueueSize;exports.search=search;exports.sendEvent=sendEvent;exports.setDatamodel=setDatamodel;exports.setHostCredentials=setHostCredentials;exports.setTerminalIdentifier=setTerminalIdentifier;exports.sortKeys=sortKeys;exports.stringify=stringify;return exports;})({});